import React, { Component } from 'react';
import { Button, Row, Col, Card, CardHeader, CardTitle, CardBody, Table,
Modal, ModalHeader, ModalBody, ModalFooter, Input,
Nav, NavItem, NavLink, TabContent, TabPane, Badge, ButtonGroup,
FormGroup, Label
} from 'reactstrap';
import TinyCashflow from 'views/tiny/TinyCashflow.js';
import TinyLoading, { TinyBusy } from "components/tiny/TinyLoading";
import TinyMiscFee from 'views/tiny/TinyMiscFee.js';
import { hasCap } from 'utils/permissions';
import { Line } from 'react-chartjs-2';
import axios from 'axios';
import numberWithCommas from "../constant/numberFormat.js";
import classNames from "classnames";
import TinyTooltip from "components/tiny/TinyTooltip";
import r2h_logo from "assets/img/R2H_logo_1117_02_outline-15.png";
import oa_logo from "assets/img/OceanAtlas_logo.png";
import tiny_logo from "assets/img/Tiny-Poker_logo.png";

import TinyPageHeader from "components/tiny/TinyPageHeader";
// R2H 營運截止日期：20251208-20251214 是最後一週有數據
// 20251215-20251221 及之後，R2H 所有數據顯示 0
const R2H_CUTOFF_DATE = '20251215-20251221';

// 總淨營收的費用來源切換週。這一週（含）之後改讀後臺登記的金流資料
// （cashflow_manual_entries），之前維持讀會計那張 Google Sheet。
//
// 為什麼是 2026-04：`出金手`（最後 2026-02-08）與「租用帳戶」欄裡的人頭戶租金
// （最後 2026-03-08）是舊制金流成本，刻意不匯進新表 —— 切在 4 月正好避開它們。
// 這之後的每一週、每一項都逐項驗證過兩邊完全相同
// （scripts/tiny/verify_netprofit_cutover.py），所以切過去畫面不該有任何變化。
const CASHFLOW_CUTOVER_WEEK = '20260406-20260412';

// payFee 的新舊制分界（聯盟新制）。⚠️ 原本這個值在兩個地方各寫一次，
// 其中一處還是寫死的字串 —— 兩份手抄遲早會漂。
const PAYFEE_ANCHOR_WEEK = '20250901-20250907';

const EnhancedNav = ({ children, ...props }) => {
    return (
      <Nav 
        {...props} 
        className="custom-nav mb-1 position-relative"
        style={{
          borderRadius: '8px',
          overflow: 'hidden',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          display: 'flex',
          flexWrap: 'wrap',
          background: '#111822', // Slightly lighter than the main background
          padding: '4px',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          cursor: "pointer"
        }}
      >
        {children}
      </Nav>
    );
  };
  
  // Custom NavItem Component
  const EnhancedNavItem = ({ children, ...props }) => {
    return (
      <NavItem 
        {...props} 
        style={{
          margin: '2px',
          position: 'relative',
          zIndex: 1
        }}
      >
        {children}
      </NavItem>
    );
  };
  
  // Custom NavLink Component
  const EnhancedNavLink = ({ children, active, onClick, ...props }) => {
    return (
      <NavLink
        {...props}
        active={active}
        onClick={onClick}
        className={classNames({ active: active })}
        style={{
          padding: '10px 18px',
          borderRadius: '6px',
          fontSize: '14px',
          fontWeight: active ? '600' : '400',
          transition: 'all 0.2s ease',
          color: active ? '#fff' : 'rgba(255, 255, 255, 0.7)',
          background: active ? 'linear-gradient(135deg, #005580, #007399)' : 'transparent',
          border: active ? 'none' : '1px solid transparent',
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: '100px',
          textAlign: 'center',
          boxShadow: active ? '0 3px 8px rgba(0, 103, 255, 0.3)' : 'none'
        }}
      >
        {/* Optional gradient overlay for hover effect */}
        <div 
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: active ? 'transparent' : 'linear-gradient(135deg, rgba(58, 123, 213, 0), rgba(0, 210, 255, 0))',
            opacity: 0,
            transition: 'opacity 0.2s ease',
            pointerEvents: 'none'
          }}
          className="nav-link-overlay"
        />
        {children}
      </NavLink>
    );
  };
  

class Revenue extends Component {
    constructor(props) {
        super(props);
        const { user } = props;
        // ⚠️ v2.32.2：改看 caps.view_revenue，不再看 permission === 'super'。
        // 舊寫法硬綁角色字串，但新制的 permission 是由 caps 推導出來的
        // （見 auth_service.derive_permission），**'super' 這個值再也不會出現** ——
        // 留著會讓明明有權限的人看到「需要 Super 權限」。實際踩到過。
        // 營收看不看得到，唯一真相就是這個 cap。
        const canViewRevenue = hasCap(user, 'view_revenue');
        
        this.state = {
            openAPlist: false,
            viewList: [],
            viewCostList: [],
            openCostModal: false,
            activeTab: canViewRevenue ? '1' : '2', // Set default tab based on permission
            editCostlist: { event: "", amount: "" },
            revenueID: "",
            expandedRows: {},  // Initialize expandedRows as an empty object
            expandedMiscRows: {},  // Initialize expandedMiscRows for miscellaneous section
            
            // Initialize the sub-tab states
            activeUnionFeeTab: 0,
            activeClubFeeTab: 0,
            activeGamesFeeTab: 0,
            activeUnionMembershipTab: 0,
            timeIntervalMain: 'allTime',
            timeIntervalUnionFee: 'allTime',
            timeIntervalClubFee: 'allTime',
            timeIntervalGamesFee: 'allTime',
            timeIntervalMembership: 'allTime',
            timeIntervalOtherFee: 'allTime',
            timeIntervalMTT: 'allTime',
            timeIntervalMiscFee: 'allTime',
            viewModeMain: 'table',
            viewModeUnionFee: 'table',
            viewModeClubFee: 'table',
            viewModeGamesFee: 'table',
            viewModeOtherFee: 'table',
            viewModeUnionMembership: 'table',
            viewModeMTT: 'table',
            openAPlist: false,
            viewList: [],
            openCostModal: false,
            viewCostList: [],
            editCostlist: {
                event: "",
                amount: ""
            },
            revenueID: "",
            mainClubSortCriteria: 'last10weeks', // Default main club sort criteria
            membershipView: 'card',  // Added new state for membership view
            openNoteModal: false,  // 添加备注弹窗状态
            currentNote: "",  // 当前编辑的备注内容
            currentNoteId: "",  // 当前编辑的备注ID
            notes: {},  // 存储所有备注
            activeProvider: 'TinyPoker', // 預設顯示 TinyPoker
            cashflowView: 'table', // 金流數據 Tab：table / summary / legacy(舊 OA・R2H 唯讀)
            showLegacyProviders: false, // 是否顯示歷史聯盟(OA/R2H)切換
            cashflowExpenses: {}, // 後臺登記的四項費用（切換週之後的總淨營收來源）
            cashflowExpensesLoaded: false, // 沒載成功就退回讀 Sheet，見 getWeekExpenses
            tinyRevenueData: [], // TinyPoker 營收數據
            tinyLoading: false, // TinyPoker 載入狀態
            tinyExpandedRows: {}, // TinyPoker 展開的行
            tinyNotesByWeek: {}, // TinyPoker 每週備註（多筆）
            viewModeTiny: 'table', // TinyPoker 視圖模式
            timeIntervalTiny: 'allTime', // TinyPoker 時間區間
            showTinyDetailModal: false, // TinyPoker 詳情 Modal
            tinyDetailWeek: '', // 詳情週期
            tinyDetailData: null, // 詳情資料
            tinyNotesLoading: false, // 備註載入狀態
            tinyNoteTitle: '', // 新增備註標題
            tinyNoteDescription: '', // 新增備註內容
            tinySavingNote: false, // 備註儲存狀態
            showExpenseModal: false, // 費用編輯 Modal
            expenseModalWeek: '', // 當前編輯的週期
            expenseModalItems: [], // 費用項目列表
            expenseModalLoading: false, // Modal 載入狀態
            newExpenseName: '', // 新增費用名稱
            newExpenseAmount: '', // 新增費用金額
            newExpenseCategory: 'other', // 新增費用類別
            openCombinedModal: false, // 添加新的状态用于控制组合模态框
            showMiscDetails: false, // 用於控制雜項詳情模態框的顯示
            miscDetails: { // 存儲雜項詳情數據
                evCashout: 0,
                MTT: 0,
                Jackpot: 0,
                SpinUp: 0
            },
            showChipDetailModal: false, // 用于控制入金出金详情模态框
            chipDetailTitle: "", // 入金出金详情标题
            chipDetailContent: "", // 入金出金详情内容
            showFullChipDetails: false, // 是否显示完整的出入金信息（TWD+USDT）
            showFlashLevelView: 'AllGames', // 是否显示Flash Level View
            flashDetailField: 'fee', // 用于存储Flash Level View的详细字段
            showAgentTaxEventModal: false, // 代理线生态审核名单模态框
            tinyNoteTooltip: { visible: false, notes: [], x: 0, y: 0 },
            showTinyWeekNotesModal: false,
            tinyWeekNotesModalWeek: '',
            // JP 是否計入聯盟營收（全局 setting，預設 true）；由 backend /api/tiny/system-settings/jp_in_union_revenue 載入
            jpInUnionRevenue: true,
        };
        this.toggleTab = this.toggleTab.bind(this);
    }
  
    componentDidMount() {
        const { user } = this.props;
        const canViewRevenue = hasCap(user, 'view_revenue');
        
        if (canViewRevenue) {
            this.props.onLoad();
            // 預載入 Tiny 營收數據，供總淨營收表格使用
            this.loadTinyRevenueData();
            this.loadCashflowExpenses();
        } else {
            this.props.getUnionsFee();
        }
    }
  
    componentWillUnmount() {
    }

    toggleProvider = (provider) => {
        if (this.state.activeProvider !== provider) {
            this.setState({
                activeProvider: provider
            });
        }

        if (provider === 'NetProfit') {
            this.props.loadRake2HighData();
            this.props.onLoad()
            // 會計可能剛在「金流數據」頁改過費用，切回來要拿最新的
            this.loadCashflowExpenses();
        } else if (provider === 'TinyPoker') {
            this.loadTinyRevenueData();
        } else if (provider === 'Rake2High' || provider === 'OtherFee' || provider === 'MiscFee') {
            this.props.loadRake2HighData();
        } else {
            this.props.onLoad()
        }
    }

    toggleViewMode = (tabName, targetMode) => {
        const stateProp = `viewMode${tabName}`;
        // Only change the view mode if the target mode is different from the current mode
        if (this.state[stateProp] !== targetMode) {
            this.setState({
                [stateProp]: targetMode
            });
        }
    }

    // Step 3: Update setTimeInterval method to be tab-specific
    setTimeInterval = (interval, tabName) => {
        const stateProp = `timeInterval${tabName}`;
        this.setState({
            [stateProp]: interval
        });
    }

    toggleExpandRow = (rowId) => {
        this.setState({
            expandedRows: {
                ...this.state.expandedRows,
                [rowId]: !this.state.expandedRows[rowId]
            }
        });
    }

    toggleExpandMiscRow = (rowId) => {
        this.setState({
            expandedMiscRows: {
                ...this.state.expandedMiscRows,
                [rowId]: !this.state.expandedMiscRows[rowId]
            }
        });
    }

    openAPlistTable = (aplist) =>{
        this.setState({
            openAPlist: true,
            viewList: aplist,
        })
    }

    openCombinedLists = (revenue) => {
        let costList = []
        if (typeof revenue.costList !== "undefined") {
            costList = revenue.costList
        }
        
        let apList = []
        if (typeof revenue.AllAPlist !== "undefined") {
            apList = revenue.AllAPlist
        }
        
        this.setState({
            openCombinedModal: true,
            viewList: apList,
            viewCostList: costList,
            revenueID: revenue._id
        })
    }

    openCostTable= (revenue) =>{
        let list = []
        if (typeof revenue.costList!=="undefined"){
            list = revenue.costList
        }
        this.setState({
            openCostModal: true,
            viewCostList: list,
            revenueID: revenue._id
        })
    }

    changeFlashItem = (item) => {
        this.setState({
            flashDetailField: item
        });
    }

    toggleFlashLevelView = (view) => {

        this.setState({
            showFlashLevelView: view
        });

        if (view === "FlashLevel") {
            this.props.getFlashLevelData();
        }else{
            this.props.getGamesFee();
        }
    }

    toggleTab = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
            
            // 当切换到 Membership 标签时，同时加载两种数据
            if (tab === '8') {
                this.props.getMembershipData();
                this.props.getUnionMembership();
                this.props.getUnionsFee();
            }
        }
    }
    
    handleChangeCost = (e) => {
        this.setState({ 
            editCostlist: {
                ...this.state.editCostlist, 
                [e.target.name]: e.target.value 
            }
        });
    }

    addTempCostList = () => {
        const { editCostlist, viewCostList } = this.state;
        if (editCostlist.event.trim() !== '' && editCostlist.amount.trim() !== '') {
            this.setState({
                viewCostList: [...viewCostList, editCostlist],
                editCostlist: { event: "", amount: "" }
            });
        }
    }

    deleteTempCostlist = (e) => {
        let list = this.state.viewCostList;
        list.splice(e.target.id, 1);
        this.setState({ viewCostList: list });
    }
    
    closeCostModal = () => {
        this.setState({
            openCostModal: false,
            viewCostList: [],
            editCostlist: { event: "", amount: "" },
            revenueID: ""
        });
    }

    saveCostList = () => {
        this.props.onSaveCostList(this.state.revenueID, this.state.viewCostList);
        this.closeCostModal();
    }

    // Updated renderCostListModal function with fixed position and scrolling
    renderCostListModal = () => {
        const modalBgColor = "#001a33";
        
        return (
            <Modal 
                isOpen={this.state.openCostModal}
                contentClassName='text-light'
                modalClassName="position-fixed"
                style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    maxWidth: '90%',
                    width: '800px',
                    margin: '0'
                }}
            >
                {/* Apply a backdrop div to force the background color */}
                <div style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: modalBgColor,
                    borderRadius: "0.3rem"
                }}>
                </div>
                
                <ModalHeader style={{backgroundColor: modalBgColor, borderColor: modalBgColor, position: "relative", zIndex: 1}}> 
                    <div style={{color: "white"}}>Cost List</div>
                </ModalHeader>
                
                <ModalBody style={{
                    backgroundColor: modalBgColor, 
                    position: "relative", 
                    zIndex: 1,
                    maxHeight: '60vh', 
                    overflowY: 'auto'
                }}>
                    <Table size="sm" className="tablesorter" >
                        <thead className="text-primary">
                            <tr>
                                <th>Event</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <Input style={{height: 30}} className='bg-dark text-light' type='text' id={"event"} name={"event"} value={this.state.editCostlist.event || ""} onChange={this.handleChangeCost.bind(this)}/> 
                                </td>
                                <td>
                                    <Input style={{height: 30}} className='bg-dark text-light' type='text' id={"amount"} name={"amount"} value={this.state.editCostlist.amount || ""} onChange={this.handleChangeCost.bind(this)}/> 
                                </td>
                                <td>
                                    <Button style={{marginRight: 3}} size='sm' color="success" onClick={this.addTempCostList.bind(this)}> + </Button>
                                </td>
                            </tr>
                            {typeof this.state.viewCostList !== "undefined" && this.state.viewCostList.map((costlist, index) => (
                                <tr key={index}>
                                    <td>{costlist.event}</td>
                                    <td>
                                        <Badge style={{ 
                                            fontSize: "12px", 
                                            padding: "6px 8px",
                                            backgroundColor: parseFloat(costlist.amount) >= 0 ? "#cc0000" : "#00802b",
                                            color: "#e6e6e6"
                                        }}>
                                            {parseFloat(costlist.amount) >= 0 ? 
                                                numberWithCommas(Math.round(parseFloat(costlist.amount)) * -1) : 
                                                numberWithCommas(Math.abs(Math.round(parseFloat(costlist.amount))))
                                            }
                                        </Badge>
                                    </td>
                                    <td><Button style={{marginRight: 3}} id={index} size='sm' color="danger" onClick={this.deleteTempCostlist.bind(this)}> delete </Button></td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </ModalBody>
                
                <ModalFooter style={{
                    backgroundColor: modalBgColor, 
                    borderColor: modalBgColor,
                    display: "flex",
                    justifyContent: "flex-end",
                    position: "relative",
                    zIndex: 1
                }}>
                    <Button color="primary" size="sm" className="mr-2" onClick={this.saveCostList.bind(this)}>
                        保存
                    </Button>
                    <Button color="secondary" size="sm" onClick={this.closeCostModal.bind(this)}>
                        取消
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }

    // Updated renderAPlistModal function with fixed position and scrolling
    renderAPlistModal = () => {
        const modalBgColor = "#001a33";
        
        return (
            <Modal 
                isOpen={this.state.openAPlist} 
                contentClassName='text-light'
                modalClassName="position-fixed"
                style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    maxWidth: '90%',
                    width: '800px',
                    margin: '0'
                }}
            >
                {/* Apply a backdrop div to force the background color */}
                <div style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: modalBgColor,
                    borderRadius: "0.3rem"
                }}>
                </div>
                
                <ModalHeader style={{backgroundColor: modalBgColor, borderColor: modalBgColor, position: "relative", zIndex: 1}}> 
                    <div style={{color: "white"}}>Additional Pay List</div>
                </ModalHeader>
                
                <ModalBody style={{
                    backgroundColor: modalBgColor, 
                    position: "relative", 
                    zIndex: 1,
                    maxHeight: '60vh', 
                    overflowY: 'auto'
                }}>
                    <Table className="tablesorter">    
                        <thead>
                            <tr>
                                <th>聯盟ID</th>
                                <th>俱樂部ID</th>
                                <th>代理ID</th>
                                <th>子代理ID</th>
                                <th>項目</th>
                                <th>金額</th>
                            </tr>
                        </thead>               
                        <tbody>
                            {this.state.viewList.map((ap, index) => (
                                <tr key={index}>
                                    <td>{ap.unionID}</td>
                                    <td>{ap.clubID}</td>
                                    <td>{ap.agentID}</td>
                                    <td>{ap.subAgentID}</td>
                                    <td>{ap.APevent}</td>
                                    <td>
                                        <Badge style={{ 
                                            fontSize: "12px", 
                                            padding: "6px 8px",
                                            backgroundColor: ap.APamount >= 0 ? "#cc0000" : "#00802b",
                                            color: "#e6e6e6"
                                        }}>
                                            {ap.APamount >= 0 ? numberWithCommas(Math.round(ap.APamount) * -1) : numberWithCommas(Math.abs(Math.round(ap.APamount)))}
                                        </Badge>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </ModalBody>
                
                <ModalFooter style={{
                    backgroundColor: modalBgColor,
                    borderColor: modalBgColor,
                    display: "flex",
                    justifyContent: "flex-end",
                    position: "relative",
                    zIndex: 1
                }}>
                    <Button color="secondary" size="sm" onClick={() => {this.setState({openAPlist: false, viewList: []})}}>
                        取消
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }

    // First, we need to add a method to expand or collapse all rows
    expandCollapseAll = (expand) => {
        // Get all revenue rows (if data exists)
        if (typeof this.props.revenue !== "undefined") {
            // Create a new expandedRows object
            const newExpandedRows = {};
            
            // Set all rows to the desired state (expanded or collapsed)
            this.props.revenue.forEach((_, index) => {
                newExpandedRows[index] = expand;
            });
            
            // Update state
            this.setState({
                expandedRows: newExpandedRows
            });
        }
    }

    // Method to expand or collapse all miscellaneous rows
    expandCollapseMiscAll = (expand) => {
        // Get all revenue rows (if data exists)
        if (typeof this.props.revenue !== "undefined") {
            // Create a new expandedMiscRows object
            const newExpandedMiscRows = {};
            
            // Set all rows to the desired state (expanded or collapsed)
            this.props.revenue.forEach((_, index) => {
                newExpandedMiscRows[index] = expand;
            });
            
            // Update state
            this.setState({
                expandedMiscRows: newExpandedMiscRows
            });
        }
    }

    // 打开代理线生态审核名单模态框并加载数据
    openAgentTaxEventModal = (weekString) => {
        this.setState({ showAgentTaxEventModal: true });
        this.props.getAgentTaxEventList(weekString);
    }

    // 关闭代理线生态审核名单模态框
    closeAgentTaxEventModal = () => {
        this.setState({ 
            showAgentTaxEventModal: false
        });
    }

    // Step 4: Add a generic filtered data getter for all tabs
    getFilteredData = (data, tabName) => {
        if (!data || data.length === 0) return [];
        
        const timeInterval = this.state[`timeInterval${tabName}`];
        let filteredData = [...data];
        
        // Data is already in reverse chronological order (newest first),
        // so we take the first N items based on the time interval
        switch (timeInterval) {
            case 'recent4weeks': // 近四周 (most recent 4 weeks)
                return filteredData.slice(0, 4).reverse(); // Take the first 4 items (most recent)
            case 'recent12weeks': // 近一季 (most recent 12 weeks)
                return filteredData.slice(0, 12).reverse(); // Take the first 12 items (most recent)
            case 'recent26weeks': // 近半年 (most recent 26 weeks)
                return filteredData.slice(0, 26).reverse(); // Take the first 26 items (most recent)
            case 'recent52weeks': // 近一年 (most recent 52 weeks)
                return filteredData.slice(0, 52).reverse(); // Take the first 52 items (most recent)
            case 'allTime': // 全部時間 (all historical data)
            default:
                return filteredData.reverse();
        }
    }

    generateMainChartData = () => {
        const { revenue = [] } = this.props;
        const filteredData = this.getFilteredData(revenue, 'Main');
        
        if (filteredData.length === 0) return null;
        
        // Create a copy of the data for sorting
        const chronologicalData = [...filteredData];
        
        // Sort data chronologically (oldest to newest) for proper left-to-right display
        chronologicalData.sort((a, b) => {
            const dateA = new Date(a.duration);
            const dateB = new Date(b.duration);
            return dateA - dateB;
        });
        
        const labels = chronologicalData.map(item => item.duration);
        
        // Generate datasets with chronologically sorted data
        const datasets = [
            {
                label: '總淨收入',
                data: chronologicalData.map(item => {
                    const superUnionNetIncome = typeof item.superUnionNetIncomeMinusCost !== "undefined" 
                        ? item.superUnionNetIncomeMinusCost 
                        : item.superUnionNetIncome;
                    return item.homeUnionIncome + item.homeClubIncome + superUnionNetIncome;
                }),
                borderColor: 'rgba(75, 192, 192, 1)',
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                tension: 0.3,
                fill: false
            },
            {
                label: '本部俱樂部收入',
                data: chronologicalData.map(item => item.homeClubIncome),
                borderColor: 'rgba(54, 162, 235, 1)',
                backgroundColor: 'rgba(54, 162, 235, 0.2)',
                tension: 0.3,
                fill: false
            },
            {
                label: '本部聯盟收入',
                data: chronologicalData.map(item => item.homeUnionIncome),
                borderColor: 'rgba(255, 99, 132, 1)',
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                tension: 0.3,
                fill: false
            },
            {
                label: '超級聯盟收入',
                data: chronologicalData.map(item => {
                    return typeof item.superUnionNetIncomeMinusCost !== "undefined" 
                        ? item.superUnionNetIncomeMinusCost 
                        : item.superUnionNetIncome;
                }),
                borderColor: 'rgba(153, 102, 255, 1)',
                backgroundColor: 'rgba(153, 102, 255, 0.2)',
                tension: 0.3,
                fill: false
            }
        ];
        
        return {
            labels,
            datasets
        };
    }

    // Updated Union Fee Chart Data Generator
generateUnionFeeChartData = () => {
    const headers = (typeof this.props.unions_col !== "undefined") ? this.props.unions_col : [];
    const unionsFee = (typeof this.props.unions_fee !== "undefined") ? this.props.unions_fee : [];
    
    if (unionsFee.length === 0 || headers.length === 0) return null;
    
    // Use getFilteredData to apply time filtering
    const filteredData = this.getFilteredData(unionsFee, 'UnionFee');
    
    // Create chronologically sorted data
    const chronologicalData = [...filteredData];
    
    chronologicalData.sort((a, b) => {
        const dateA = new Date(a.duration);
        const dateB = new Date(b.duration);
        return dateA - dateB;
    });
    
    const labels = chronologicalData.map(item => item.duration);
    
    // Generate datasets for each union
    const datasets = headers.map((header, index) => {
        // Create a color palette
        const colors = [
            'rgba(75, 192, 192, 1)', 'rgba(54, 162, 235, 1)', 
            'rgba(255, 99, 132, 1)', 'rgba(153, 102, 255, 1)',
            'rgba(255, 159, 64, 1)', 'rgba(255, 205, 86, 1)',
            'rgba(201, 203, 207, 1)', 'rgba(0, 204, 150, 1)'
        ];
        
        const colorIndex = index % colors.length;
        
        return {
            label: header.name,
            data: chronologicalData.map(item => item[header.id]),
            borderColor: colors[colorIndex],
            backgroundColor: colors[colorIndex].replace('1)', '0.2)'),
            tension: 0.3,
            fill: false
        };
    });
    
    return {
        labels,
        datasets
    };
}

// Updated Club Fee Chart Data Generator
    generateClubFeeChartData = () => {
        let headers = (typeof this.props.main_club !== "undefined" && typeof this.props.main_club.clubs !== "undefined") 
            ? [...this.props.main_club.clubs] // Mutable copy
            : [];
        const clubFeeData = (typeof this.props.main_club !== "undefined" && typeof this.props.main_club.sumData !== "undefined") 
            ? this.props.main_club.sumData 
            : [];
        const sortCriteria = this.state.mainClubSortCriteria; // Get sort criteria
        
        if (clubFeeData.length === 0 || headers.length === 0) return null;

        // 过滤重复的列（相同数据但名称不同）
        const duplicateMap = {};
        const filteredHeaders = [];
        
        // 检查数据内容是否相同来识别重复列
        if (headers.length > 0 && clubFeeData.length > 0) {
            for (let i = 0; i < headers.length; i++) {
                const currentHeader = headers[i];
                let isDuplicate = false;
                
                // 已经添加的列的id
                const existingIds = filteredHeaders.map(h => h.id);
                
                // 遍历已过滤的列，检查数据是否相同
                for (const existingId of existingIds) {
                    let isDataIdentical = true;
                    
                    // 比较每行数据
                    for (const row of clubFeeData) {
                        if (row[currentHeader.id] !== row[existingId]) {
                            isDataIdentical = false;
                            break;
                        }
                    }
                    
                    if (isDataIdentical) {
                        isDuplicate = true;
                        duplicateMap[currentHeader.id] = existingId; // 记录重复关系
                        break;
                    }
                }
                
                if (!isDuplicate) {
                    filteredHeaders.push(currentHeader);
                }
            }
        }
        
        // 使用过滤后的headers
        headers = filteredHeaders;

        // Calculate club totals based on sort criteria
        const clubTotals = {};
        headers.forEach(header => { clubTotals[header.id] = 0; });

        const dataToSum = sortCriteria === 'last10weeks'
            ? clubFeeData.slice(0, 10)
            : clubFeeData;
        
        dataToSum.forEach(item => {
            headers.forEach(header => {
                if (typeof item[header.id] !== 'undefined' && !isNaN(item[header.id])) {
                    clubTotals[header.id] += Math.round(item[header.id]);
                }
            });
        });

        // Sort headers based on calculated totals
        headers.sort((a, b) => {
            const totalA = clubTotals[a.id] || 0;
            const totalB = clubTotals[b.id] || 0;
            if (totalA === 0 && totalB === 0) return String(a.id).localeCompare(String(b.id));
            if (totalA === 0) return 1;
            if (totalB === 0) return -1;
            return totalB - totalA;
        });
        
        // Use getFilteredData to apply time filtering for the chart's x-axis
        const filteredData = this.getFilteredData(clubFeeData, 'ClubFee');
        
        // Create chronologically sorted data for the x-axis
        const chronologicalData = [...filteredData];
        chronologicalData.sort((a, b) => {
            const dateAString = String(a.duration).split('-')[0];
            const dateBString = String(b.duration).split('-')[0];
            const dateA = new Date(dateAString.slice(0,4), dateAString.slice(4,6) - 1, dateAString.slice(6,8));
            const dateB = new Date(dateBString.slice(0,4), dateBString.slice(4,6) - 1, dateBString.slice(6,8));
            return dateA - dateB;
        });
        
        const labels = chronologicalData.map(item => item.duration);
        
        // Generate datasets using the *sorted* headers
        const datasets = headers.map((header, index) => { // Use sorted headers
            // Create a color palette
            const colors = [
                'rgba(75, 192, 192, 1)', 'rgba(54, 162, 235, 1)', 
                'rgba(255, 99, 132, 1)', 'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)', 'rgba(255, 205, 86, 1)',
                'rgba(201, 203, 207, 1)', 'rgba(0, 204, 150, 1)'
                // Add more colors if needed
            ];
            
            const colorIndex = index % colors.length;
            
            return {
                label: header.name, // Use name from sorted header
                data: chronologicalData.map(item => item[header.id]), // Map data using sorted header id
                borderColor: colors[colorIndex],
                backgroundColor: colors[colorIndex].replace('1)', '0.2)'),
                tension: 0.3,
                fill: false
            };
        });
        
        return {
            labels,
            datasets
        };
    }

    generateFlashLevelChartData = () => {
        const headers = (typeof this.props.flash_level_col !== "undefined") ? this.props.flash_level_col : [];
        const flashLevelData = (typeof this.props.flash_level_data !== "undefined") ? this.props.flash_level_data : [];
        const { flashDetailField } = this.state;

        let attribute = "fee";
        if (flashDetailField === 'players') {
            attribute = "players";
        } else if (flashDetailField === 'hands') {
            attribute = "hands";
        }
        
        if (flashLevelData.length === 0 || headers.length === 0) return null;
        
        // Use getFilteredData to apply time filtering
        const filteredData = this.getFilteredData(flashLevelData, 'GamesFee');
        
        // Create chronologically sorted data
        const chronologicalData = [...filteredData];

        chronologicalData.sort((a, b) => {
            const dateA = new Date(a.duration);
            const dateB = new Date(b.duration);
            return dateA - dateB;
        });
        
        const labels = chronologicalData.map(item => item.duration);
        
        // Generate datasets for each flash level
        const datasets = headers.map((header, index) => {
            // Create a color palette
            const colors = [
                'rgba(75, 192, 192, 1)', 'rgba(54, 162, 235, 1)', 
                'rgba(255, 99, 132, 1)', 'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)', 'rgba(255, 205, 86, 1)',
                'rgba(201, 203, 207, 1)', 'rgba(0, 204, 150, 1)'
            ];
            
            const colorIndex = index % colors.length;
            
            return {
                label: header,
                data: chronologicalData.map(item => item[header][attribute]),
                borderColor: colors[colorIndex],
                backgroundColor: colors[colorIndex].replace('1)', '0.2)'),
                tension: 0.3,
                fill: false
            };
        });
        
        return {
            labels,
            datasets
        };
    }

    // Updated Games Fee Chart Data Generator
    generateGamesFeeChartData = () => {
        const headers = (typeof this.props.games_col !== "undefined") ? this.props.games_col : [];
        const gamesFeeData = (typeof this.props.games_fee !== "undefined") ? this.props.games_fee : [];
        
        if (gamesFeeData.length === 0 || headers.length === 0) return null;
        
        // Use getFilteredData to apply time filtering
        const filteredData = this.getFilteredData(gamesFeeData, 'GamesFee');
        
        // Create chronologically sorted data
        const chronologicalData = [...filteredData];

        chronologicalData.sort((a, b) => {
            const dateA = new Date(a.duration);
            const dateB = new Date(b.duration);
            return dateA - dateB;
        });
        
        const labels = chronologicalData.map(item => item.duration);
        
        // Generate datasets for each game
        const datasets = headers.map((header, index) => {
            // Create a color palette
            const colors = [
                'rgba(75, 192, 192, 1)', 'rgba(54, 162, 235, 1)', 
                'rgba(255, 99, 132, 1)', 'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)', 'rgba(255, 205, 86, 1)',
                'rgba(201, 203, 207, 1)', 'rgba(0, 204, 150, 1)'
            ];
            
            const colorIndex = index % colors.length;
            
            return {
                label: header,
                data: chronologicalData.map(item => item[header]),
                borderColor: colors[colorIndex],
                backgroundColor: colors[colorIndex].replace('1)', '0.2)'),
                tension: 0.3,
                fill: false
            };
        });
        
        return {
            labels,
            datasets
        };
    }



    // Updated Membership Chart Data Generator
    generateMembershipChartData = () => {
        const headers = (typeof this.props.membership_header !== "undefined") ? this.props.membership_header : [];
        const membershipData = (typeof this.props.membership_sum !== "undefined") ? this.props.membership_sum : [];
        
        if (membershipData.length === 0 || headers.length === 0) return null;
        
        // Use getFilteredData to apply time filtering
        const filteredData = this.getFilteredData(membershipData, 'Membership');
        
        // Create chronologically sorted data
        const chronologicalData = [...filteredData];

        chronologicalData.sort((a, b) => {
            const dateA = new Date(a.duration);
            const dateB = new Date(b.duration);
            return dateA - dateB;
        });
        
        const labels = chronologicalData.map(item => item.duration);
        
        // Generate datasets for each membership type
        const datasets = headers.map((header, index) => {
            const colors = [
                'rgba(75, 192, 192, 1)', 'rgba(54, 162, 235, 1)', 
                'rgba(255, 99, 132, 1)', 'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)', 'rgba(255, 205, 86, 1)',
                'rgba(201, 203, 207, 1)', 'rgba(0, 204, 150, 1)'
            ];
            
            const colorIndex = index % colors.length;
            
            return {
                label: header.name,
                data: chronologicalData.map(item => item[header.id]),
                borderColor: colors[colorIndex],
                backgroundColor: colors[colorIndex].replace('1)', '0.2)'),
                tension: 0.3,
                fill: false
            };
        });
        
        return {
            labels,
            datasets
        };
    }

    // Updated Union Membership Chart Data Generator
    generateUnionMembershipChartData = () => {
        const headers = (typeof this.props.unions_col !== "undefined") ? this.props.unions_col : [];
        const unionMembershipData = (typeof this.props.union_membership_amount !== "undefined") ? this.props.union_membership_amount : [];
        
        if (unionMembershipData.length === 0 || headers.length === 0) return null;
        
        // Use getFilteredData to apply time filtering
        const filteredData = this.getFilteredData(unionMembershipData, 'UnionMembership');
        
        // Create chronologically sorted data
        const chronologicalData = [...filteredData];

        chronologicalData.sort((a, b) => {
            const dateA = new Date(a.duration);
            const dateB = new Date(b.duration);
            return dateA - dateB;
        });
        
        const labels = chronologicalData.map(item => item.duration);
        
        // Generate datasets for each union
        const datasets = headers.map((header, index) => {
            // Create a color palette
            const colors = [
                'rgba(75, 192, 192, 1)', 'rgba(54, 162, 235, 1)', 
                'rgba(255, 99, 132, 1)', 'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)', 'rgba(255, 205, 86, 1)',
                'rgba(201, 203, 207, 1)', 'rgba(0, 204, 150, 1)'
            ];
            
            const colorIndex = index % colors.length;
            
            return {
                label: header.name,
                data: chronologicalData.map(item => item[header.id]),
                borderColor: colors[colorIndex],
                backgroundColor: colors[colorIndex].replace('1)', '0.2)'),
                tension: 0.3,
                fill: false
            };
        });
        
        return {
            labels,
            datasets
        };
    }

    renderChartView = (tabName, chartDataFunction) => {
        const chartData = chartDataFunction();
        
        if (!chartData) {
            return (
                <div className="text-center p-5">
                    <h4>No data available</h4>
                </div>
            );
        }
        
        const chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: 'top',
                    labels: {
                        color: '#fff'
                    }
                },
                tooltip: {
                    mode: 'index',
                    intersect: false,
                    callbacks: {
                        label: function(context) {
                            let label = context.dataset.label || '';
                            if (label) {
                                label += ': ';
                            }
                            if (context.parsed.y !== null) {
                                label += numberWithCommas(Math.round(context.parsed.y));
                            }
                            return label;
                        }
                    }
                }
            },
            scales: {
                y: {
                    ticks: {
                        color: '#fff',
                        callback: function(value) {
                            return numberWithCommas(value);
                        }
                    },
                    grid: {
                        color: 'rgba(255, 255, 255, 0.1)'
                    }
                },
                x: {
                    ticks: {
                        color: '#fff'
                    },
                    grid: {
                        color: 'rgba(255, 255, 255, 0.1)'
                    }
                }
            }
        };
        
        return (
            <div style={{ height: '500px' }}>
                <Line data={chartData} options={chartOptions} />
            </div>
        );
    }

    renderR2HDetailItem = (label, value, color, inverse = false, onClick = null, longLabel= null) => {
        // 設置更窄的寬度以確保每行能放5個項目
        return (
            <div className="px-1" style={{ width: '25%', display: 'inline-block', marginBottom: '10px' }}>
                <div className="p-2 border rounded" style={{ height: '100%', minHeight: '40px' }}>
                    <div className="d-flex justify-content-between align-items-center" style={{ height: '100%' }}>
                        <small style={{ fontSize: "14px" }}>{label}</small>
                        {onClick ? (
                            <div>
                                <Button 
                                    color='info' 
                                    size='sm' 
                                    onClick={onClick}
                                >
                                    <i className="fa fa-eye" aria-hidden="true"></i>
                                </Button>
                                {this.renderBadge(value, color,  inverse)}
                            </div>
                        ) : (
                            this.renderBadge(value, color, inverse)
                        )}
                    </div>
                </div>
            </div>
        );
    };

    /// Helper function for detail item
    renderDetailItem = (label, value, inverse = false, onClick = null, longLabel= null) => {
        // Determine column size based on label length
        const colSize = longLabel
            ? { lg: "3", md: "6" }
            : { lg: "2", md: "6" };
        
        return (
            <Col lg={colSize.lg} md={colSize.md} className="mb-3">
                <div className="p-2 border rounded">
                    <div className="d-flex justify-content-between align-items-center">
                        <small style={{ fontSize: "14px" }}>{label}</small>
                        {onClick ? (
                            <div>
                                <Button 
                                    color='info' 
                                    size='sm' 
                                    onClick={onClick}
                                >
                                    <i className="fa fa-eye" aria-hidden="true"></i>
                                </Button>
                                {this.renderBadge(value, "#00802b", inverse)}
                            </div>
                        ) : (
                            this.renderBadge(value, "#00802b", inverse)
                        )}
                    </div>
                </div>
            </Col>
        );
    };

    // Helper function for badges
    renderBadge = (value, color, inverse = false) => {
        const amount = inverse ? value * -1 : value;
        const isNotANumber = Number.isNaN(value) || value === null || value === undefined;
        const isPositive = isNotANumber ? false : (inverse ? value <= 0 : value >= 0);
        const nanColor = "#cc8800";
        const bgColor = isNotANumber ? nanColor : (isPositive ? color : "#cc0000");
        return (                  
            <Badge style={{ 
                fontSize: "12px", 
                padding: "6px 8px",
                backgroundColor: bgColor,
                color: "#e6e6e6",
                marginLeft: "5px",
            }}>
                {numberWithCommas(Math.round(amount))}
            </Badge>
        );
    };

    // Method to render the Rake2High chart
    renderRake2HighChart = () => {
        const chartData = this.generateRake2HighChartData();
        
        if (!chartData) {
            return (
                <div className="text-center p-5">
                    <h4>No data available</h4>
                </div>
            );
        }
        
        const chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: 'top',
                    labels: {
                        color: '#fff'
                    }
                },
                tooltip: {
                    mode: 'index',
                    intersect: false,
                    callbacks: {
                        label: function(context) {
                            let label = context.dataset.label || '';
                            if (label) {
                                label += ': ';
                            }
                            if (context.parsed.y !== null) {
                                label += numberWithCommas(Math.round(context.parsed.y));
                            }
                            return label;
                        }
                    }
                }
            },
            scales: {
                y: {
                    ticks: {
                        color: '#fff',
                        callback: function(value) {
                            return numberWithCommas(value);
                        }
                    },
                    grid: {
                        color: 'rgba(255, 255, 255, 0.1)'
                    }
                },
                x: {
                    ticks: {
                        color: '#fff'
                    },
                    grid: {
                        color: 'rgba(255, 255, 255, 0.1)'
                    }
                }
            }
        };
        
        return (
            <div style={{ height: '500px' }}>
                <Line data={chartData} options={chartOptions} />
            </div>
        );
    }

    // Method to generate the Rake2High chart data
    generateRake2HighChartData = () => {
        const { r2h_revenue = [] } = this.props;
        
        if (r2h_revenue.length === 0) return null;
        
        // Use getFilteredData to apply time filtering
        const filteredData = this.getFilteredData(r2h_revenue, 'Main');
        
        // Create chronologically sorted data (assuming data is already sorted by date)
        const chronologicalData = [...filteredData];
        
        // Sort by date (assuming 月份/日期 contains date strings that can be compared)
        chronologicalData.sort((a, b) => {
            // If dates are in a format that can be directly compared like "YYYY/MM/DD-YYYY/MM/DD" or similar
            const dateA = a["月份/日期"]; 
            const dateB = b["月份/日期"];
            return dateA.localeCompare(dateB);
        });
        
        const labels = chronologicalData.map(item => item["月份/日期"]);

        // Generate datasets
        const datasets = [
            {
                label: '總營利',
                data: chronologicalData.map(item => {
                    // 获取水房手续费数据
                    const waterHouseFee = item["水房"] ? parseFloat(item["水房"]) : 0;
                    
                    // 获取人事成本数据
                    const personnelCost = item["人事成本\n(植威填)"] ? parseFloat(item["人事成本\n(植威填)"]) : 0;
                    
                    // 获取植威信用卡杂项数据
                    const creditCardMisc = item["植威信用卡雜項\n(植威填)"] ? parseFloat(item["植威信用卡雜項\n(植威填)"]) : 0;
                    
                    // 原始联盟营利
                    let unionProfit = item["聯盟營利"] ? parseFloat(item["聯盟營利"]) : 0;
                    
                    // 调整联盟营利: 加上水房手续费、人事成本和植威信用卡杂项
                    const adjustedUnionProfit = unionProfit + waterHouseFee + personnelCost + creditCardMisc;
                    
                    const clubProfit = item["俱樂部營利"] ? parseFloat(item["俱樂部營利"]) : 0;
                    const MttProfit = item["正負"] ? parseFloat(item["正負"]) : 0;
                    
                    // 总利润 = 调整后的联盟利润 + 俱乐部利润 + MTT利润
                    return adjustedUnionProfit + clubProfit + MttProfit;
                }),
                borderColor: 'rgba(153, 102, 255, 1)',
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                tension: 0.3,
                fill: false
            },
            {
                label: '聯盟營利',
                data: chronologicalData.map(item => {
                    // 获取水房手续费数据
                    const waterHouseFee = item["水房"] ? parseFloat(item["水房"]) : 0;
                    
                    // 获取人事成本数据
                    const personnelCost = item["人事成本\n(植威填)"] ? parseFloat(item["人事成本\n(植威填)"]) : 0;
                    
                    // 获取植威信用卡杂项数据
                    const creditCardMisc = item["植威信用卡雜項\n(植威填)"] ? parseFloat(item["植威信用卡雜項\n(植威填)"]) : 0;
                    
                    // 原始联盟营利
                    let unionProfit = item["聯盟營利"] ? parseFloat(item["聯盟營利"]) : 0;
                    
                    // 调整联盟营利: 加上水房手续费、人事成本和植威信用卡杂项
                    return unionProfit + waterHouseFee + personnelCost + creditCardMisc;
                }),
                borderColor: 'rgba(54, 162, 235, 1)',
                backgroundColor: 'rgba(54, 162, 235, 0.2)',
                tension: 0.3,
                fill: false
            },
            {
                label: '俱樂部營利',
                data: chronologicalData.map(item => item["俱樂部營利"]),
                borderColor: 'rgba(255, 99, 132, 1)',
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                tension: 0.3,
                fill: false
            },
            {
                label: 'MTT營利',
                data: chronologicalData.map(item => item["正負"]),
                borderColor: 'rgba(47, 188, 47, 0.76)',
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                tension: 0.3,
                fill: false
            },
            {
                label: 'BOT收入',
                data: chronologicalData.map(item => item["BOT費用"]),
                borderColor: 'rgba(228, 232, 15, 0.76)',
                backgroundColor: 'rgba(133, 144, 12, 0.2)',
                tension: 0.3,
                fill: false
            },
            {
                label: '水房',
                data: chronologicalData.map(item => item["水房"]),
                borderColor: 'rgb(255, 0, 230)',
                backgroundColor: 'rgba(123, 7, 125, 0.58)',
                tension: 0.3,
                fill: false,
                hidden: true // Hidden by default
            },
            {
                label: '總服務費+總保險',
                data: chronologicalData.map(item => item["聯盟+俱樂部之總服務費+總保險"]),
                borderColor: 'rgba(75, 192, 192, 1)',
                backgroundColor: 'rgba(153, 102, 255, 0.2)',
                tension: 0.3,
                fill: false,
                hidden: true // Hidden by default
            },
            {
                label: '聯盟總水',
                data: chronologicalData.map(item => item["聯盟總水"]),
                borderColor: 'rgba(255, 159, 64, 1)',
                backgroundColor: 'rgba(255, 159, 64, 0.2)',
                tension: 0.3,
                fill: false,
                hidden: true // Hidden by default
            },
            {
                label: '俱樂部總水',
                data: chronologicalData.map(item => item["俱樂部總水"]),
                borderColor: 'rgba(255, 205, 86, 1)',
                backgroundColor: 'rgba(255, 205, 86, 0.2)',
                tension: 0.3,
                fill: false,
                hidden: true // Hidden by default
            }
        ];
        
        return {
            labels,
            datasets
        };
    }

    calculateR2HProfit = (revenue) => {
        // 获取水房手续费数据
        // const waterHouseFee = revenue["水房"] ? parseFloat(revenue["水房"]) : 0;
                            
        // // 获取人事成本数据
        // const personnelCost = revenue["人事成本\n(植威填)"] ? parseFloat(revenue["人事成本\n(植威填)"]) : 0;
        
        // // 获取植威信用卡杂项数据
        // const creditCardMisc = revenue["植威信用卡雜項\n(植威填)"] ? parseFloat(revenue["植威信用卡雜項\n(植威填)"]) : 0;
        
        // 原始联盟营利
        let unionProfit = revenue["聯盟營利"] ? parseFloat(revenue["聯盟營利"]) : 0;

        let botProfit = revenue["BOT費用"] ? parseFloat(revenue["BOT費用"]) : 0;

        let ovbShare = revenue["OVB分潤"] ? parseFloat(revenue["OVB分潤"]) : 0;
        
        // 调整联盟营利: 加上水房手续费、人事成本和植威信用卡杂项
        // const adjustedUnionProfit = unionProfit + waterHouseFee + personnelCost + creditCardMisc;
        
        const clubProfit = revenue["俱樂部營利"] ? parseFloat(revenue["俱樂部營利"]) : 0;
        const MttProfit = revenue["正負"] ? parseFloat(revenue["正負"]) : 0;
        
        // 修改总利润计算方式：调整后的联盟利润 + 俱乐部利润 + MTT利润
        // console.log(unionProfit, clubProfit, MttProfit, botProfit)
        let totalProfit = unionProfit + clubProfit + MttProfit + botProfit - ovbShare;

        return {
            totalProfit,
            // adjustedUnionProfit,
            unionProfit,
            clubProfit,
            MttProfit,
        }
    }

    // Helper: 判斷日期是否在 R2H 截止日期之後（含）
    isAfterR2HCutoff = (dateStr) => {
        return dateStr >= R2H_CUTOFF_DATE;
    }

    // TinyPoker 營收內容
    renderTinyPokerContent = () => {
        const { tinyRevenueData = [], tinyLoading, tinyExpandedRows = {}, viewModeTiny, timeIntervalTiny } = this.state;
        const cellCentered = { textAlign: 'center' };
        
        if (tinyLoading) {
            return (
                <TinyLoading text="載入 TinyPoker 營收數據" variant="block" />
            );
        }
        
        if (!tinyRevenueData || tinyRevenueData.length === 0) {
            return (
                <div className="text-center py-5" style={{ 
                    background: 'linear-gradient(135deg, rgba(225, 78, 202, 0.1), rgba(186, 84, 245, 0.1))',
                    borderRadius: '10px',
                    margin: '20px 0'
                }}>
                    <i className="fa fa-diamond fa-3x mb-3" style={{ color: '#e14eca' }}></i>
                    <h4>暫無 TinyPoker 營收數據</h4>
                    <p className="text-muted">請先執行週報流程產生營收報表</p>
                </div>
            );
        }
        
        return (
            <>
                {/* 控制按鈕區 */}
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-3" style={{ gap: '10px' }}>
                  {/* Table/Chart 與 JP 徽章並排在左；時間區間仍然靠右 */}
                  <div className="d-flex flex-wrap align-items-center" style={{ gap: '10px' }}>
                    {/* Table/Chart 切換按鈕 */}
                    <Nav pills className="rev-seg-nav" style={{ "--tab-accent": "116,132,255" }}>
                        <NavItem>
                            <NavLink
                                href="#"
                                className={classNames("rev-seg-link", { active: viewModeTiny === 'table' })}
                                onClick={(e) => { e.preventDefault(); this.toggleViewMode('Tiny', 'table'); }}
                            >
                                <i className="fa fa-th-large mr-1"></i> Table
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                href="#"
                                className={classNames("rev-seg-link", { active: viewModeTiny === 'chart' })}
                                onClick={(e) => { e.preventDefault(); this.toggleViewMode('Tiny', 'chart'); }}
                            >
                                <i className="fa fa-area-chart mr-1"></i> Chart
                            </NavLink>
                        </NavItem>
                    </Nav>

                    {/* JP 排除提醒 —— 只在受影響的這個分頁出現，而且只佔一顆徽章。
                        ⚠️ 縮小但**不減弱**：保留盾牌圖示與粉紅色系（跟原本 banner 同色），
                        所以掃視時仍然抓得到；完整說明改放 title，滑過去就有。 */}
                    {!this.state.jpInUnionRevenue && (
                        <TinyTooltip
                            maxWidth={360}
                            content={
                                <>
                                    <strong style={{ color: '#fd5d93' }}>目前 JP 由老闆當莊家</strong>
                                    （系統模式 <code style={{ color: '#ffd9b8' }}>banker</code>），
                                    所以 JP 的盈虧算在莊家頭上、<strong>不進聯盟營收</strong>。
                                    <br />
                                    實際差別：JP 補償類別的額外費用<strong>不會被扣</strong>，
                                    表格裡的「JP 淨營收」與「TinyJP」兩欄<strong>不顯示</strong>。
                                    <br />
                                    要改回把 JP 計入聯盟營收，請聯絡 Brad。
                                </>
                            }
                        >
                            <span
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 6,
                                    padding: '5px 11px',
                                    borderRadius: 999,
                                    fontSize: 12,
                                    fontWeight: 600,
                                    whiteSpace: 'nowrap',
                                    color: '#fd5d93',
                                    background: 'rgba(253, 93, 147, 0.14)',
                                    border: '1px solid rgba(253, 93, 147, 0.5)',
                                }}
                            >
                                <i className="fa fa-shield" style={{ fontSize: 13 }} />
                                JP 不計入聯盟營收
                                <i className="fa fa-circle-question" style={{ fontSize: 12, opacity: 0.75 }} />
                            </span>
                        </TinyTooltip>
                    )}
                  </div>

                    {/* 時間區間選擇按鈕（僅在 Chart 模式顯示） */}
                    {viewModeTiny === 'chart' && (
                        <Nav pills className="rev-seg-nav" style={{ "--tab-accent": "90,170,255" }}>
                            <NavItem><NavLink href="#" className={classNames("rev-seg-link", { active: timeIntervalTiny === 'allTime' })} onClick={(e) => { e.preventDefault(); this.setTimeInterval('allTime', 'Tiny'); }}>All Time</NavLink></NavItem>
                            <NavItem><NavLink href="#" className={classNames("rev-seg-link", { active: timeIntervalTiny === 'last5weeks' })} onClick={(e) => { e.preventDefault(); this.setTimeInterval('last5weeks', 'Tiny'); }}>Last 5 Weeks</NavLink></NavItem>
                            <NavItem><NavLink href="#" className={classNames("rev-seg-link", { active: timeIntervalTiny === 'last10weeks' })} onClick={(e) => { e.preventDefault(); this.setTimeInterval('last10weeks', 'Tiny'); }}>Last 10 Weeks</NavLink></NavItem>
                            <NavItem><NavLink href="#" className={classNames("rev-seg-link", { active: timeIntervalTiny === 'last20weeks' })} onClick={(e) => { e.preventDefault(); this.setTimeInterval('last20weeks', 'Tiny'); }}>Last 20 Weeks</NavLink></NavItem>
                        </Nav>
                    )}
                </div>
                
                {/* 根據 viewModeTiny 顯示 Table 或 Chart */}
                {viewModeTiny === 'chart' ? (
                    this.renderChartView('Tiny', this.generateTinyChartData)
                ) : (
                    <>
                    <div className="table-responsive tiny-revenue-table-wrap d-none d-md-block">
                    <Table className="tablesorter tiny-revenue-main-table">
                        <thead className="text-primary">
                            <tr>
                                <th style={{ width: "112px", minWidth: "112px", fontSize: '13px', whiteSpace: 'nowrap', ...cellCentered }}>週期</th>
                                <th style={{ backgroundColor: 'rgba(225, 78, 202, 0.2)', ...cellCentered, fontSize: '13px' }}>
                                    <div>聯盟總水</div>
                                    <div style={{ marginTop: '5px', display: 'flex', justifyContent: 'center', gap: '4px' }}>
                                        <span 
                                            className="tiny-bulk-expand"
                                            onClick={() => this.expandCollapseAllTiny('union')} 
                                            style={{ 
                                                cursor: 'pointer',
                                                fontSize: '9px',
                                                padding: '2px 6px',
                                                borderRadius: '3px',
                                                background: 'linear-gradient(135deg, rgba(225, 78, 202, 0.3), rgba(186, 84, 245, 0.3))',
                                                color: '#e14eca',
                                                border: '1px solid rgba(225, 78, 202, 0.4)',
                                                transition: 'all 0.2s',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '3px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.background = 'linear-gradient(135deg, rgba(225, 78, 202, 0.5), rgba(186, 84, 245, 0.5))';
                                                e.target.style.transform = 'scale(1.05)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.background = 'linear-gradient(135deg, rgba(225, 78, 202, 0.3), rgba(186, 84, 245, 0.3))';
                                                e.target.style.transform = 'scale(1)';
                                            }}
                                        >
                                            <i className="fa fa-chevron-down" style={{ fontSize: '8px' }}></i>
                                            <span className="tiny-toggle-label-full">全展開</span>
                                            <span className="tiny-toggle-label-compact">開</span>
                                        </span>
                                        <span 
                                            className="tiny-bulk-collapse"
                                            onClick={() => this.expandCollapseAllTiny(null)} 
                                            style={{ 
                                                cursor: 'pointer',
                                                fontSize: '9px',
                                                padding: '2px 6px',
                                                borderRadius: '3px',
                                                background: 'rgba(100, 100, 100, 0.3)',
                                                color: '#aaa',
                                                border: '1px solid rgba(150, 150, 150, 0.4)',
                                                transition: 'all 0.2s',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '3px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.background = 'rgba(100, 100, 100, 0.5)';
                                                e.target.style.color = '#fff';
                                                e.target.style.transform = 'scale(1.05)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.background = 'rgba(100, 100, 100, 0.3)';
                                                e.target.style.color = '#aaa';
                                                e.target.style.transform = 'scale(1)';
                                            }}
                                        >
                                            <i className="fa fa-chevron-up" style={{ fontSize: '8px' }}></i>
                                            <span className="tiny-toggle-label-full">全收起</span>
                                            <span className="tiny-toggle-label-compact">收</span>
                                        </span>
                                    </div>
                                </th>
                                <th style={{ backgroundColor: 'rgba(255, 193, 7, 0.2)', ...cellCentered, fontSize: '13px' }}>
                                    {/* v2.28.0：原「eco總水」→「Bot總水」= EcoBot + 自營Bot。
                                        展開後上排 eco、下排自營Bot。真人總水 = 聯盟 − 這一欄。 */}
                                    <div>Bot總水</div>
                                    <div style={{ marginTop: '5px', display: 'flex', justifyContent: 'center', gap: '4px' }}>
                                        <span 
                                            className="tiny-bulk-expand"
                                            onClick={() => this.expandCollapseAllTiny('eco')} 
                                            style={{ 
                                                cursor: 'pointer',
                                                fontSize: '9px',
                                                padding: '2px 6px',
                                                borderRadius: '3px',
                                                background: 'linear-gradient(135deg, rgba(255, 193, 7, 0.3), rgba(255, 152, 0, 0.3))',
                                                color: '#ffc107',
                                                border: '1px solid rgba(255, 193, 7, 0.4)',
                                                transition: 'all 0.2s',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '3px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.background = 'linear-gradient(135deg, rgba(255, 193, 7, 0.5), rgba(255, 152, 0, 0.5))';
                                                e.target.style.transform = 'scale(1.05)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.background = 'linear-gradient(135deg, rgba(255, 193, 7, 0.3), rgba(255, 152, 0, 0.3))';
                                                e.target.style.transform = 'scale(1)';
                                            }}
                                        >
                                            <i className="fa fa-chevron-down" style={{ fontSize: '8px' }}></i>
                                            <span className="tiny-toggle-label-full">全展開</span>
                                            <span className="tiny-toggle-label-compact">開</span>
                                        </span>
                                        <span 
                                            className="tiny-bulk-collapse"
                                            onClick={() => this.expandCollapseAllTiny(null)} 
                                            style={{ 
                                                cursor: 'pointer',
                                                fontSize: '9px',
                                                padding: '2px 6px',
                                                borderRadius: '3px',
                                                background: 'rgba(100, 100, 100, 0.3)',
                                                color: '#aaa',
                                                border: '1px solid rgba(150, 150, 150, 0.4)',
                                                transition: 'all 0.2s',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '3px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.background = 'rgba(100, 100, 100, 0.5)';
                                                e.target.style.color = '#fff';
                                                e.target.style.transform = 'scale(1.05)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.background = 'rgba(100, 100, 100, 0.3)';
                                                e.target.style.color = '#aaa';
                                                e.target.style.transform = 'scale(1)';
                                            }}
                                        >
                                            <i className="fa fa-chevron-up" style={{ fontSize: '8px' }}></i>
                                            <span className="tiny-toggle-label-full">全收起</span>
                                            <span className="tiny-toggle-label-compact">收</span>
                                        </span>
                                    </div>
                                </th>
                                <th style={{ backgroundColor: 'rgba(54, 162, 235, 0.2)', ...cellCentered, fontSize: '13px' }}>
                                    <div>真人總水</div>
                                    <div style={{ marginTop: '5px', display: 'flex', justifyContent: 'center', gap: '4px' }}>
                                        <span 
                                            className="tiny-bulk-expand"
                                            onClick={() => this.expandCollapseAllTiny('real')} 
                                            style={{ 
                                                cursor: 'pointer',
                                                fontSize: '9px',
                                                padding: '2px 6px',
                                                borderRadius: '3px',
                                                background: 'linear-gradient(135deg, rgba(54, 162, 235, 0.3), rgba(33, 150, 243, 0.3))',
                                                color: '#36a2eb',
                                                border: '1px solid rgba(54, 162, 235, 0.4)',
                                                transition: 'all 0.2s',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '3px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.background = 'linear-gradient(135deg, rgba(54, 162, 235, 0.5), rgba(33, 150, 243, 0.5))';
                                                e.target.style.transform = 'scale(1.05)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.background = 'linear-gradient(135deg, rgba(54, 162, 235, 0.3), rgba(33, 150, 243, 0.3))';
                                                e.target.style.transform = 'scale(1)';
                                            }}
                                        >
                                            <i className="fa fa-chevron-down" style={{ fontSize: '8px' }}></i>
                                            <span className="tiny-toggle-label-full">全展開</span>
                                            <span className="tiny-toggle-label-compact">開</span>
                                        </span>
                                        <span 
                                            className="tiny-bulk-collapse"
                                            onClick={() => this.expandCollapseAllTiny(null)} 
                                            style={{ 
                                                cursor: 'pointer',
                                                fontSize: '9px',
                                                padding: '2px 6px',
                                                borderRadius: '3px',
                                                background: 'rgba(100, 100, 100, 0.3)',
                                                color: '#aaa',
                                                border: '1px solid rgba(150, 150, 150, 0.4)',
                                                transition: 'all 0.2s',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '3px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.background = 'rgba(100, 100, 100, 0.5)';
                                                e.target.style.color = '#fff';
                                                e.target.style.transform = 'scale(1.05)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.background = 'rgba(100, 100, 100, 0.3)';
                                                e.target.style.color = '#aaa';
                                                e.target.style.transform = 'scale(1)';
                                            }}
                                        >
                                            <i className="fa fa-chevron-up" style={{ fontSize: '8px' }}></i>
                                            <span className="tiny-toggle-label-full">全收起</span>
                                            <span className="tiny-toggle-label-compact">收</span>
                                        </span>
                                    </div>
                                </th>
                                <th style={{ backgroundColor: 'rgba(75, 192, 192, 0.2)', ...cellCentered, fontSize: '13px' }}>
                                    <div>收入總和</div>
                                    <div style={{ marginTop: '5px', display: 'flex', justifyContent: 'center', gap: '4px' }}>
                                        <span 
                                            className="tiny-bulk-expand"
                                            onClick={() => this.expandCollapseAllTiny('income')} 
                                            style={{ 
                                                cursor: 'pointer',
                                                fontSize: '9px',
                                                padding: '2px 6px',
                                                borderRadius: '3px',
                                                background: 'linear-gradient(135deg, rgba(75, 192, 192, 0.3), rgba(56, 178, 172, 0.3))',
                                                color: '#4bc0c0',
                                                border: '1px solid rgba(75, 192, 192, 0.4)',
                                                transition: 'all 0.2s',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '3px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.background = 'linear-gradient(135deg, rgba(75, 192, 192, 0.5), rgba(56, 178, 172, 0.5))';
                                                e.target.style.transform = 'scale(1.05)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.background = 'linear-gradient(135deg, rgba(75, 192, 192, 0.3), rgba(56, 178, 172, 0.3))';
                                                e.target.style.transform = 'scale(1)';
                                            }}
                                        >
                                            <i className="fa fa-chevron-down" style={{ fontSize: '8px' }}></i>
                                            <span className="tiny-toggle-label-full">全展開</span>
                                            <span className="tiny-toggle-label-compact">開</span>
                                        </span>
                                        <span 
                                            className="tiny-bulk-collapse"
                                            onClick={() => this.expandCollapseAllTiny(null)} 
                                            style={{ 
                                                cursor: 'pointer',
                                                fontSize: '9px',
                                                padding: '2px 6px',
                                                borderRadius: '3px',
                                                background: 'rgba(100, 100, 100, 0.3)',
                                                color: '#aaa',
                                                border: '1px solid rgba(150, 150, 150, 0.4)',
                                                transition: 'all 0.2s',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '3px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.background = 'rgba(100, 100, 100, 0.5)';
                                                e.target.style.color = '#fff';
                                                e.target.style.transform = 'scale(1.05)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.background = 'rgba(100, 100, 100, 0.3)';
                                                e.target.style.color = '#aaa';
                                                e.target.style.transform = 'scale(1)';
                                            }}
                                        >
                                            <i className="fa fa-chevron-up" style={{ fontSize: '8px' }}></i>
                                            <span className="tiny-toggle-label-full">全收起</span>
                                            <span className="tiny-toggle-label-compact">收</span>
                                        </span>
                                    </div>
                                </th>
                                <th style={{ backgroundColor: 'rgba(255, 159, 64, 0.2)', ...cellCentered, fontSize: '13px' }}>
                                    <div>支出總和</div>
                                    <div style={{ marginTop: '5px', display: 'flex', justifyContent: 'center', gap: '4px' }}>
                                        <span 
                                            className="tiny-bulk-expand"
                                            onClick={() => this.expandCollapseAllTiny('expense')} 
                                            style={{ 
                                                cursor: 'pointer',
                                                fontSize: '9px',
                                                padding: '2px 6px',
                                                borderRadius: '3px',
                                                background: 'linear-gradient(135deg, rgba(255, 159, 64, 0.3), rgba(255, 138, 43, 0.3))',
                                                color: '#ff9f40',
                                                border: '1px solid rgba(255, 159, 64, 0.4)',
                                                transition: 'all 0.2s',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '3px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.background = 'linear-gradient(135deg, rgba(255, 159, 64, 0.5), rgba(255, 138, 43, 0.5))';
                                                e.target.style.transform = 'scale(1.05)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.background = 'linear-gradient(135deg, rgba(255, 159, 64, 0.3), rgba(255, 138, 43, 0.3))';
                                                e.target.style.transform = 'scale(1)';
                                            }}
                                        >
                                            <i className="fa fa-chevron-down" style={{ fontSize: '8px' }}></i>
                                            <span className="tiny-toggle-label-full">全展開</span>
                                            <span className="tiny-toggle-label-compact">開</span>
                                        </span>
                                        <span 
                                            className="tiny-bulk-collapse"
                                            onClick={() => this.expandCollapseAllTiny(null)} 
                                            style={{ 
                                                cursor: 'pointer',
                                                fontSize: '9px',
                                                padding: '2px 6px',
                                                borderRadius: '3px',
                                                background: 'rgba(100, 100, 100, 0.3)',
                                                color: '#aaa',
                                                border: '1px solid rgba(150, 150, 150, 0.4)',
                                                transition: 'all 0.2s',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '3px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.background = 'rgba(100, 100, 100, 0.5)';
                                                e.target.style.color = '#fff';
                                                e.target.style.transform = 'scale(1.05)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.background = 'rgba(100, 100, 100, 0.3)';
                                                e.target.style.color = '#aaa';
                                                e.target.style.transform = 'scale(1)';
                                            }}
                                        >
                                            <i className="fa fa-chevron-up" style={{ fontSize: '8px' }}></i>
                                            <span className="tiny-toggle-label-full">全收起</span>
                                            <span className="tiny-toggle-label-compact">收</span>
                                        </span>
                                    </div>
                                </th>
                                <th style={{ backgroundColor: 'rgba(255, 99, 132, 0.2)', ...cellCentered, fontSize: '13px' }}>
                                    額外費用
                                    <div style={{ fontSize: '10px', color: '#aaa' }}>可編輯</div>
                                </th>
                                <th className="tiny-col-note" style={{ backgroundColor: 'rgba(153, 153, 255, 0.2)', ...cellCentered, fontSize: '13px', width: '132px', minWidth: '132px' }}>
                                    備註摘要
                                    <div style={{ fontSize: '10px', color: '#aaa' }}>多筆</div>
                                </th>
                                <th className="tiny-col-detail" style={{ backgroundColor: 'rgba(110, 220, 180, 0.2)', ...cellCentered, fontSize: '13px' }}>
                                    詳情
                                </th>
                                {this.state.jpInUnionRevenue && (
                                <th style={{ backgroundColor: 'rgba(45, 206, 137, 0.20)', ...cellCentered, fontSize: '13px' }}>
                                    <div>JP淨營收</div>
                                    <div style={{ marginTop: '5px', display: 'flex', justifyContent: 'center', gap: '4px' }}>
                                        <span
                                            className="tiny-bulk-expand"
                                            onClick={() => this.expandCollapseAllTiny('jp')}
                                            style={{
                                                cursor: 'pointer',
                                                fontSize: '9px',
                                                padding: '2px 6px',
                                                borderRadius: '3px',
                                                background: 'linear-gradient(135deg, rgba(45, 206, 137, 0.3), rgba(103, 214, 103, 0.3))',
                                                color: '#2dce89',
                                                border: '1px solid rgba(45, 206, 137, 0.4)',
                                                transition: 'all 0.2s',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '3px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.background = 'linear-gradient(135deg, rgba(45, 206, 137, 0.5), rgba(103, 214, 103, 0.5))';
                                                e.target.style.transform = 'scale(1.05)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.background = 'linear-gradient(135deg, rgba(45, 206, 137, 0.3), rgba(103, 214, 103, 0.3))';
                                                e.target.style.transform = 'scale(1)';
                                            }}
                                        >
                                            <i className="fa fa-chevron-down" style={{ fontSize: '8px' }}></i>
                                            <span className="tiny-toggle-label-full">全展開</span>
                                            <span className="tiny-toggle-label-compact">開</span>
                                        </span>
                                        <span
                                            className="tiny-bulk-collapse"
                                            onClick={() => this.expandCollapseAllTiny(null)}
                                            style={{
                                                cursor: 'pointer',
                                                fontSize: '9px',
                                                padding: '2px 6px',
                                                borderRadius: '3px',
                                                background: 'rgba(100, 100, 100, 0.3)',
                                                color: '#aaa',
                                                border: '1px solid rgba(150, 150, 150, 0.4)',
                                                transition: 'all 0.2s',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '3px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.background = 'rgba(100, 100, 100, 0.5)';
                                                e.target.style.color = '#fff';
                                                e.target.style.transform = 'scale(1.05)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.background = 'rgba(100, 100, 100, 0.3)';
                                                e.target.style.color = '#aaa';
                                                e.target.style.transform = 'scale(1)';
                                            }}
                                        >
                                            <i className="fa fa-chevron-up" style={{ fontSize: '8px' }}></i>
                                            <span className="tiny-toggle-label-full">全收起</span>
                                            <span className="tiny-toggle-label-compact">收</span>
                                        </span>
                                    </div>
                                </th>
                                )}
                                <th style={{ backgroundColor: 'rgba(47, 188, 47, 0.3)', ...cellCentered, fontSize: '14px', fontWeight: 'bold' }}>聯盟淨營收</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tinyRevenueData.map((item, index) => {
                                const isExpanded = tinyExpandedRows[item.week];
                                const currYear = this.getTinyWeekYearTag(item.week);
                                const prevYear = index > 0 ? this.getTinyWeekYearTag(tinyRevenueData[index - 1]?.week) : '';
                                const showYearDivider = index === 0 || currYear !== prevYear;
                                const unionBreakdown = item.union_breakdown || {};
                                const ecoBreakdown = item.eco_breakdown || {};
                                // v2.28.0 自營Bot：跟 eco 合併成「Bot 總水」一欄顯示
                                const selfBotBreakdown = item.self_bot_breakdown || {};
                                // v2.30.3 JP 佔成依週期（20260511 起 50%）。
                                // ⚠️ fallback 是 0.30 不是 0.50 —— 這一版之前存進
                                // weekly_revenue_summary 的金額都是用 30% 算的，
                                // 舊資料沒有 eco_jp_share_rate，標籤要跟著那個「已存的數字」走，
                                // 否則會出現「寫 50% 但數字是 30% 算的」。重跑該週後就會變 50%。
                                const jpShareRate = (item.jp_net_breakdown || {}).eco_jp_share_rate ?? 0.30;
                                const jpSharePct = +(jpShareRate * 100).toFixed(2);
                                const botTotal = (ecoBreakdown.total || 0) + (selfBotBreakdown.total || 0);
                                const realBreakdown = item.real_breakdown || {};
                                const income = item.income || {};
                                const expense = item.expense || {};
                                const additionalExpenses = item.additional_expenses || { total: 0, items: [] };
                                const adjusted = this.getAdjustedRevenue(item);
                                const colSpanTotal = this.state.jpInUnionRevenue ? 11 : 10;

                                return (
                                    <React.Fragment key={`tiny-rev-${index}`}>
                                        {showYearDivider && (
                                            <tr className="tiny-year-separator-row">
                                                <td colSpan={colSpanTotal}>
                                                    <div className="tiny-year-separator">
                                                        <span className="tiny-year-separator-line" />
                                                        <span className="tiny-year-separator-pill">{currYear} 年</span>
                                                        <span className="tiny-year-separator-line" />
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                        <tr className="tiny-main-row">
                                            <td style={{ ...cellCentered, whiteSpace: 'nowrap' }}>
                                                {this.renderTinyWeekLabel(item.week, index, tinyRevenueData)}
                                            </td>
                                            <td 
                                                style={{ ...cellCentered, cursor: 'pointer' }}
                                                onClick={() => this.toggleTinyRow(item.week, 'union')}
                                            >
                                                <span style={{ color: '#e14eca' }}>
                                                    {numberWithCommas(Math.round(unionBreakdown.total || 0))}
                                                    <i className={`fa fa-chevron-${isExpanded === 'union' ? 'up' : 'down'} ml-2`} style={{ fontSize: '10px' }}></i>
                                                </span>
                                            </td>
                                            <td 
                                                style={{ ...cellCentered, cursor: 'pointer' }}
                                                onClick={() => this.toggleTinyRow(item.week, 'eco')}
                                            >
                                                <span style={{ color: '#ffc107' }}>
                                                    {numberWithCommas(Math.round(botTotal))}
                                                    <i className={`fa fa-chevron-${isExpanded === 'eco' ? 'up' : 'down'} ml-2`} style={{ fontSize: '10px' }}></i>
                                                </span>
                                            </td>
                                            <td 
                                                style={{ ...cellCentered, cursor: 'pointer' }}
                                                onClick={() => this.toggleTinyRow(item.week, 'real')}
                                            >
                                                <span style={{ color: '#36a2eb' }}>
                                                    {numberWithCommas(Math.round(realBreakdown.total || 0))}
                                                    <i className={`fa fa-chevron-${isExpanded === 'real' ? 'up' : 'down'} ml-2`} style={{ fontSize: '10px' }}></i>
                                                </span>
                                            </td>
                                            <td 
                                                style={{ ...cellCentered, cursor: 'pointer' }}
                                                onClick={() => this.toggleTinyRow(item.week, 'income')}
                                            >
                                                <span style={{ color: '#4bc0c0' }}>
                                                    {numberWithCommas(Math.round(income.total || 0))}
                                                    <i className={`fa fa-chevron-${isExpanded === 'income' ? 'up' : 'down'} ml-2`} style={{ fontSize: '10px' }}></i>
                                                </span>
                                            </td>
                                            <td
                                                style={{ ...cellCentered, cursor: 'pointer' }}
                                                onClick={() => this.toggleTinyRow(item.week, 'expense')}
                                            >
                                                <span style={{ color: '#ff922b' }}>
                                                    -{numberWithCommas(Math.round(expense.total || 0))}
                                                    <i className={`fa fa-chevron-${isExpanded === 'expense' ? 'up' : 'down'} ml-2`} style={{ fontSize: '10px' }}></i>
                                                </span>
                                            </td>
                                            <td
                                                style={{ ...cellCentered, cursor: 'pointer' }}
                                                onClick={() => this.openExpenseModal(item.week)}
                                            >
                                                <span style={{
                                                    color: (adjusted.additionalTotal || 0) >= 0 ? '#ff6b6b' : '#2fbf2f'
                                                }}>
                                                    {(adjusted.additionalTotal || 0) >= 0
                                                        ? `-${numberWithCommas(Math.round(adjusted.additionalTotal || 0))}`
                                                        : `+${numberWithCommas(Math.abs(Math.round(adjusted.additionalTotal)))}`
                                                    }
                                                    <i className="fa fa-edit ml-2" style={{ fontSize: '12px' }}></i>
                                                </span>
                                            </td>
                                            <td className="tiny-col-note" style={{ ...cellCentered, width: '132px', maxWidth: '132px', whiteSpace: 'normal' }}>
                                                {this.renderTinyWeekNoteTitles(item.week)}
                                            </td>
                                            <td className="tiny-col-detail" style={{ ...cellCentered }}>
                                                <span
                                                    className="tiny-detail-btn"
                                                    onClick={() => this.openTinyDetailModal(item.week, item)}
                                                    style={{
                                                        cursor: 'pointer',
                                                        fontSize: '10px',
                                                        padding: '4px 10px',
                                                        borderRadius: '4px',
                                                        background: 'linear-gradient(135deg, rgba(75, 192, 192, 0.35), rgba(56, 178, 172, 0.35))',
                                                        color: '#4bc0c0',
                                                        border: '1px solid rgba(75, 192, 192, 0.45)',
                                                        transition: 'all 0.2s',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        gap: '4px',
                                                        fontWeight: 'bold',
                                                        letterSpacing: '0.3px',
                                                        boxShadow: '0 2px 8px rgba(75, 192, 192, 0.25)'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.background = 'linear-gradient(135deg, rgba(75, 192, 192, 0.55), rgba(56, 178, 172, 0.55))';
                                                        e.currentTarget.style.transform = 'scale(1.05)';
                                                        e.currentTarget.style.color = '#fff';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.background = 'linear-gradient(135deg, rgba(75, 192, 192, 0.35), rgba(56, 178, 172, 0.35))';
                                                        e.currentTarget.style.transform = 'scale(1)';
                                                        e.currentTarget.style.color = '#4bc0c0';
                                                    }}
                                                >
                                                    <i className="fa fa-search-plus" style={{ fontSize: '10px' }}></i>
                                                    詳情
                                                </span>
                                            </td>
                                            {this.state.jpInUnionRevenue && (
                                            <td
                                                style={{ ...cellCentered, cursor: (item.jp_net_breakdown && item.jp_net_breakdown.applicable) ? 'pointer' : 'default' }}
                                                onClick={() => {
                                                    if (item.jp_net_breakdown && item.jp_net_breakdown.applicable) {
                                                        this.toggleTinyRow(item.week, 'jp');
                                                    }
                                                }}
                                            >
                                                {(() => {
                                                    const jp = item.jp_net_breakdown || {};
                                                    if (!jp || !jp.applicable) {
                                                        return <span style={{ color: '#9aa4bb' }}>-</span>;
                                                    }
                                                    const v = Math.round(jp.total || 0);
                                                    const color = v >= 0 ? '#2dce89' : '#ff6b6b';
                                                    return (
                                                        <span style={{ color, fontWeight: 'bold' }}>
                                                            {v >= 0 ? '+' : '-'}{numberWithCommas(Math.abs(v))}
                                                            <i className={`fa fa-chevron-${isExpanded === 'jp' ? 'up' : 'down'} ml-2`} style={{ fontSize: '10px' }}></i>
                                                        </span>
                                                    );
                                                })()}
                                            </td>
                                            )}
                                            <td style={{ ...cellCentered, fontWeight: 'bold', color: adjusted.finalRevenue >= 0 ? '#2fbf2f' : '#ff6b6b' }}>
                                                {numberWithCommas(Math.round(adjusted.finalRevenue || 0))}
                                            </td>
                                        </tr>
                                        {/* 聯盟總水細項 */}
                                        {isExpanded === 'union' && (
                                            <tr>
                                                <td colSpan={colSpanTotal} style={{ padding: 0, backgroundColor: 'rgba(225, 78, 202, 0.05)' }}>
                                                    <div className="p-3">
                                                        <h6 className="mb-3" style={{ color: '#e14eca' }}>
                                                            <i className="fa fa-diamond mr-2"></i>聯盟總水細項
                                                        </h6>
                                                        <Row>
                                                            {this.renderBreakdownItem('NLH + PLO', unionBreakdown.ring_game, '#e14eca')}
                                                            {this.renderBreakdownItem('AOF', unionBreakdown.aof, '#e14eca')}
                                                            {this.renderBreakdownItem('SNG', unionBreakdown.sng, '#e14eca')}
                                                            {this.renderBreakdownItem('MTT', unionBreakdown.mtt, '#e14eca')}
                                                        </Row>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                        {/* Bot總水細項：上排 EcoBot、下排自營Bot（v2.28.0） */}
                                        {isExpanded === 'eco' && (
                                            <tr>
                                                <td colSpan={colSpanTotal} style={{ padding: 0, backgroundColor: 'rgba(255, 193, 7, 0.05)' }}>
                                                    <div className="p-3">
                                                        <h6 className="mb-3" style={{ color: '#ffc107' }}>
                                                            <i className="fa fa-users mr-2"></i>EcoBot 總水
                                                            <small className="ml-2" style={{ color: '#8a8a8a', fontWeight: 400 }}>
                                                                小計 {numberWithCommas(Math.round(ecoBreakdown.total || 0))}
                                                            </small>
                                                        </h6>
                                                        <Row>
                                                            {this.renderBreakdownItem('NLH + PLO', ecoBreakdown.ring_game, '#ffc107')}
                                                            {this.renderBreakdownItem('AOF', ecoBreakdown.aof, '#ffc107')}
                                                            {this.renderBreakdownItem('SNG', ecoBreakdown.sng, '#ffc107')}
                                                            {this.renderBreakdownItem('MTT', ecoBreakdown.mtt, '#ffc107')}
                                                        </Row>

                                                        <h6 className="mb-3 mt-3" style={{ color: '#00d6b4' }}>
                                                            <i className="fa fa-android mr-2"></i>自營Bot 總水
                                                            <small className="ml-2" style={{ color: '#8a8a8a', fontWeight: 400 }}>
                                                                小計 {numberWithCommas(Math.round(selfBotBreakdown.total || 0))}
                                                            </small>
                                                        </h6>
                                                        <Row>
                                                            {this.renderBreakdownItem('NLH + PLO', selfBotBreakdown.ring_game, '#00d6b4')}
                                                            {this.renderBreakdownItem('AOF', selfBotBreakdown.aof, '#00d6b4')}
                                                            {this.renderBreakdownItem('SNG', selfBotBreakdown.sng, '#00d6b4')}
                                                            {this.renderBreakdownItem('MTT', selfBotBreakdown.mtt, '#00d6b4')}
                                                        </Row>

                                                        {/* 對 EcoBot 的帳單裡，自營Bot 的水算「真人水」照抽 5% ——
                                                            我方沒告訴他們桌上有自營Bot，這是刻意吞下的成本。
                                                            純提示不進任何加總，但每週一眼看得到付了多少。 */}
                                                        <div className="mt-3 p-2" style={{
                                                            borderLeft: '3px solid #ff922b',
                                                            background: 'rgba(255, 146, 43, 0.08)',
                                                            fontSize: '12px', color: '#c9c9c9'
                                                        }}>
                                                            <i className="fa fa-exclamation-triangle mr-2" style={{ color: '#ff922b' }}></i>
                                                            自營Bot 的水在 <b>EcoBot 帳單</b>中仍計入真人水、被抽 5% ＝
                                                            <b style={{ color: '#ff922b', marginLeft: 6 }}>
                                                                -{numberWithCommas(Math.round(((selfBotBreakdown.ring_game || 0) + (selfBotBreakdown.aof || 0)) * 0.05))}
                                                            </b>
                                                            <small className="ml-2" style={{ color: '#8a8a8a' }}>
                                                                （僅提示，已含在支出的 EcoBot 分潤裡，不另計）
                                                            </small>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                        {/* 真人總水細項 */}
                                        {isExpanded === 'real' && (
                                            <tr>
                                                <td colSpan={colSpanTotal} style={{ padding: 0, backgroundColor: 'rgba(54, 162, 235, 0.05)' }}>
                                                    <div className="p-3">
                                                        <h6 className="mb-3" style={{ color: '#36a2eb' }}>
                                                            <i className="fa fa-user mr-2"></i>真人總水細項
                                                        </h6>
                                                        <Row>
                                                            {this.renderBreakdownItem('NLH + PLO', realBreakdown.ring_game, '#36a2eb')}
                                                            {this.renderBreakdownItem('AOF', realBreakdown.aof, '#36a2eb')}
                                                            {this.renderBreakdownItem('SNG', realBreakdown.sng, '#36a2eb')}
                                                            {this.renderBreakdownItem('MTT', realBreakdown.mtt, '#36a2eb')}
                                                        </Row>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                        {/* 收入細項 */}
                                        {isExpanded === 'income' && (
                                            <tr>
                                                <td colSpan={colSpanTotal} style={{ padding: 0, backgroundColor: 'rgba(75, 192, 192, 0.05)' }}>
                                                    <div className="p-3">
                                                        {/* 真人服務費 */}
                                                        <h6 className="mb-3" style={{ color: '#36a2eb' }}>
                                                            <i className="fa fa-user mr-2"></i>真人服務費
                                                        </h6>
                                                        <Row className="mb-3">
                                                            <Col md="2" className="mb-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(255,255,255,0.05)' }}>
                                                                    <small className="text-muted">NLH + PLO</small>
                                                                    <div style={{ fontWeight: 'bold', color: '#36a2eb' }}>
                                                                        {numberWithCommas(Math.round(income.real_rg_rake || 0))}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col md="2" className="mb-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(255,255,255,0.05)' }}>
                                                                    <small className="text-muted">AOF</small>
                                                                    <div style={{ fontWeight: 'bold', color: '#36a2eb' }}>
                                                                        {numberWithCommas(Math.round(income.real_aof_rake || 0))}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col md="2" className="mb-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(255,255,255,0.05)' }}>
                                                                    <small className="text-muted">SNG</small>
                                                                    <div style={{ fontWeight: 'bold', color: '#36a2eb' }}>
                                                                        {numberWithCommas(Math.round(income.real_sng_rake || 0))}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col md="2" className="mb-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(255,255,255,0.05)' }}>
                                                                    <small className="text-muted">MTT</small>
                                                                    <div style={{ fontWeight: 'bold', color: '#36a2eb' }}>
                                                                        {numberWithCommas(Math.round(income.real_mtt_rake || 0))}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col md="2" className="mb-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(255,255,255,0.05)' }}>
                                                                    <small className="text-muted">保險</small>
                                                                    <div style={{ fontWeight: 'bold', color: '#36a2eb' }}>
                                                                        {numberWithCommas(Math.round(income.real_insurance || 0))}
                                                                    </div>
                                                                    {/* v2.50.1：20260921 週起真人保險含本部真人（之前本部那份從來沒進收入，
                                                                        由額外費用一次補登）。數字由後端算好，這裡只標組成。 */}
                                                                    {(item.real_insurance_breakdown || {}).hq ? (
                                                                        <small style={{ color: '#8a8a8a' }}>
                                                                            含本部 {numberWithCommas(Math.round(item.real_insurance_breakdown.hq))}
                                                                        </small>
                                                                    ) : null}
                                                                </div>
                                                            </Col>
                                                        </Row>

                                                        {/* eco 水前輸贏 */}
                                                        <h6 className="mb-3" style={{ color: '#ffc107' }}>
                                                            <i className="fa fa-users mr-2"></i>eco 水前輸贏
                                                        </h6>
                                                        <Row className="mb-3">
                                                            <Col md="3" className="mb-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(255,255,255,0.05)' }}>
                                                                    <small className="text-muted">Cash 水前輸贏 (NLH+PLO+AOF，扣除JP)</small>
                                                                    <div style={{ fontWeight: 'bold', color: (income.eco_cash_net || 0) >= 0 ? '#ffc107' : '#ff6b6b' }}>
                                                                        {numberWithCommas(Math.round(income.eco_cash_net || 0))}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col md="3" className="mb-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(255,255,255,0.05)' }}>
                                                                    <small className="text-muted">MTT 水前輸贏</small>
                                                                    <div style={{ fontWeight: 'bold', color: (income.eco_mtt_net || 0) >= 0 ? '#ffc107' : '#ff6b6b' }}>
                                                                        {numberWithCommas(Math.round(income.eco_mtt_net || 0))}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            {/* v2.50.1 保險（莊家收）：機器人付給莊家（我方）的保費。p_l 含保險，所以 Cash 水前輸贏
                                                                只記了機器人付出的那一側；收的這一側在這格，全退給 EcoBot 的那筆在支出 eco 夥伴分潤。
                                                                20260921 週起才有，之前的週沒有這個欄位顯示「—」（已由額外費用一次補登）。 */}
                                                            <Col md="3" className="mb-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(255,255,255,0.05)' }}>
                                                                    <small className="text-muted">保險（莊家收）</small>
                                                                    <div style={{ fontWeight: 'bold', color: (income.eco_insurance || 0) >= 0 ? '#ffc107' : '#ff6b6b' }}>
                                                                        {income.eco_insurance === undefined ? '—' : numberWithCommas(Math.round(income.eco_insurance))}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        </Row>

                                                        {/* v2.28.0 自營Bot 損益 = rake + 玩家輸贏（全遊戲種類、含 JP）。
                                                            自營 Bot 付的 rake 是聯盟付給聯盟自己（內部循環淨零），
                                                            所以口徑是水前而不是水後；p_l 本身已含 JP，banker 不受影響。
                                                            正數 = Bot 贏錢 = 我方賺。
                                                            v2.50.1：p_l 也已含保險，Bot 付的保費是我方莊家收的 → 另列「保險（莊家收）」
                                                            一格（20260921 週起），兩格相加 ＝ 自營Bot 數據頁的聯盟損益。

                                                            v2.28.4：這裡只留「聯盟損益」一格。原本的六格拆解
                                                            （Rake / 水後輸贏 / 桌面表現扣JP / JP fee·中獎 / 手數·帳號 / 保險）
                                                            全部在「自營Bot 數據」頁看得到（週趨勢表 + 機器人明細 Tab），
                                                            營收頁重複顯示只是把版面塞爆。 */}
                                                        <h6 className="mb-3" style={{ color: '#00d6b4' }}>
                                                            <i className="fa fa-android mr-2"></i>自營Bot 損益
                                                            <small className="ml-2" style={{ color: '#8a8a8a', fontWeight: 400 }}>
                                                                全遊戲種類的水錢輸贏（<b>含 JP、不扣 JP</b>）＝ Rake ＋ 輸贏 ＋ 保險（莊家收）
                                                            </small>
                                                        </h6>
                                                        <Row className="mb-3">
                                                            <Col md="3" className="mb-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(0,214,180,0.10)', border: '1px solid rgba(0,214,180,0.4)' }}>
                                                                    <small className="text-muted">Rake ＋ 輸贏（計入收入）</small>
                                                                    <div style={{ fontWeight: 'bold', fontSize: '1.15em', color: (income.self_bot_net || 0) >= 0 ? '#00d6b4' : '#ff6b6b' }}>
                                                                        {numberWithCommas(Math.round(income.self_bot_net || 0))}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col md="3" className="mb-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(0,214,180,0.10)', border: '1px solid rgba(0,214,180,0.4)' }}>
                                                                    <small className="text-muted">保險（莊家收，計入收入）</small>
                                                                    <div style={{ fontWeight: 'bold', fontSize: '1.15em', color: (income.self_bot_insurance || 0) >= 0 ? '#00d6b4' : '#ff6b6b' }}>
                                                                        {income.self_bot_insurance === undefined ? '—' : numberWithCommas(Math.round(income.self_bot_insurance))}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col md="6" className="mb-2 d-flex align-items-center">
                                                                <small style={{ color: '#8a8a8a' }}>
                                                                    Rake、水後輸贏、桌面表現(扣JP)、JP fee／中獎、手數／帳號、保險
                                                                    等每週細項請看「自營Bot 數據」頁。
                                                                </small>
                                                            </Col>
                                                        </Row>

                                                        {/* ecobot LB 回收 */}
                                                        <h6 className="mb-3" style={{ color: '#6ee7b7' }}>
                                                            <i className="fa fa-reply mr-2"></i>ecobot LB 回收
                                                        </h6>
                                                        <Row className="mb-3">
                                                            <Col md="3" className="mb-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(255,255,255,0.05)' }}>
                                                                    <small className="text-muted">ecobot 回收 LB</small>
                                                                    <div style={{ fontWeight: 'bold', color: '#6ee7b7' }}>
                                                                        {numberWithCommas(Math.round(income.ecobot_lb_recovery || 0))}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        
                                                        {/* 獎池回收（只有雙數周顯示） */}
                                                        <h6 className="mb-3" style={{ color: '#2fbf2f' }}>
                                                            <i className="fa fa-trophy mr-2"></i>
                                                            獎池回收
                                                            {!income.is_biweekly_settlement && (
                                                                <Badge color="secondary" className="ml-2" style={{ fontSize: '10px' }}>
                                                                    單數周不結算
                                                                </Badge>
                                                            )}
                                                        </h6>
                                                        {/* 三分類：本部 / eco(EcoBot) / 外部(Rebate+回收模式)；細項見雙週獎池頁 */}
                                                        <Row>
                                                            <Col md="4" className="mb-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(255,255,255,0.05)' }}>
                                                                    <small className="text-muted">本部回收獎池</small>
                                                                    <div style={{ fontWeight: 'bold', color: '#2fbf2f' }}>
                                                                        {numberWithCommas(Math.round(income.hq_pool_return || 0))}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col md="4" className="mb-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(255,255,255,0.05)' }}>
                                                                    <small className="text-muted">eco俱樂部回收獎池</small>
                                                                    <div style={{ fontWeight: 'bold', color: '#2fbf2f' }}>
                                                                        {numberWithCommas(Math.round(income.eco_pool_return || 0))}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col md="4" className="mb-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(155,81,224,0.10)', border: '1px solid rgba(155,81,224,0.4)' }}>
                                                                    <small className="text-muted">外部回收獎池（Rebate/回收模式）</small>
                                                                    <div style={{ fontWeight: 'bold', color: '#9b51e0' }}>
                                                                        {numberWithCommas(Math.round((income.rebate_pool_recovery || 0) + (income.pure_share_pool_recovery || 0)))}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            {/* v2.28.0：自營Bot 分到的獎池全額由我方回收（也是利潤），獨立顯示 */}
                                                            <Col md="4" className="mb-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(0,214,180,0.10)', border: '1px solid rgba(0,214,180,0.4)' }}>
                                                                    <small className="text-muted">自營Bot 回收獎池</small>
                                                                    <div style={{ fontWeight: 'bold', color: '#00d6b4' }}>
                                                                        {numberWithCommas(Math.round(income.self_bot_pool_recovery || 0))}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        </Row>

                                                        {/* v2.28.4：Tax & Rebate 自成一項 —— 它跟雙週獎池的回收是兩回事
                                                            （TR 是每週依 ratio 級距抽/補，獎池回收是雙週結算），
                                                            掛在「獎池回收」底下會被誤讀成獎池的一部分。 */}
                                                        {!!income.tr_tax && (
                                                            <>
                                                                <h6 className="mb-3 mt-3" style={{ color: '#727cf5' }}>
                                                                    <i className="fa fa-balance-scale mr-2"></i>Tax / Rebate
                                                                </h6>
                                                                <Row>
                                                                    <Col md="4" className="mb-2">
                                                                        <div className="p-2 rounded" style={{ background: 'rgba(114,124,245,0.10)', border: '1px solid rgba(114,124,245,0.4)' }}>
                                                                            <small className="text-muted" title="僅計 Ring Game（NLH / PLO / AOF），不含 MTT / SNG">
                                                                                TR Tax 收入
                                                                            </small>
                                                                            <div style={{ fontWeight: 'bold', color: '#727cf5' }}>
                                                                                {numberWithCommas(Math.round(income.tr_tax || 0))}
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                        {/* 支出細項 */}
                                        {isExpanded === 'expense' && (
                                            <tr>
                                                <td colSpan={colSpanTotal} style={{ padding: 0, backgroundColor: 'rgba(255, 159, 64, 0.05)' }}>
                                                    <div className="p-3">
                                                        <h6 className="mb-3" style={{ color: '#ff922b' }}>
                                                            <i className="fa fa-arrow-circle-up mr-2"></i>支出細項
                                                        </h6>
                                                        <Row>
                                                            <Col md="3" className="mb-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(255,255,255,0.05)' }}>
                                                                    <small className="text-muted">元老俱樂部固定分潤</small>
                                                                    <div style={{ fontWeight: 'bold', color: '#ff6b6b' }}>
                                                                        -{numberWithCommas(Math.round(expense.veteran_fixed_revenue || 0))}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col md="3" className="mb-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(255,255,255,0.05)' }}>
                                                                    <small className="text-muted">超級代理分潤</small>
                                                                    <div style={{ fontWeight: 'bold', color: '#ff6b6b' }}>
                                                                        -{numberWithCommas(Math.round(expense.super_agent_revenue || 0))}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col md="3" className="mb-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(255,255,255,0.05)' }}>
                                                                    <small className="text-muted">直屬代理分潤</small>
                                                                    <div style={{ fontWeight: 'bold', color: '#ff6b6b' }}>
                                                                        -{numberWithCommas(Math.round(expense.direct_agent_revenue || 0))}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col md="3" className="mb-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(255,255,255,0.05)' }}>
                                                                    <small className="text-muted">股東獎池分配</small>
                                                                    <div style={{ fontWeight: 'bold', color: '#ff6b6b' }}>
                                                                        -{numberWithCommas(Math.round(expense.shareholder_pool || 0))}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col md="3" className="mb-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(255,255,255,0.05)' }}>
                                                                    <small className="text-muted">eco夥伴分潤</small>
                                                                    {(() => {
                                                                        const pv = Math.round(expense.partner_revenue || 0);
                                                                        const isIncome = pv < 0;
                                                                        return (
                                                                            <div style={{ fontWeight: 'bold', color: isIncome ? '#2dce89' : '#ff6b6b' }}>
                                                                                {isIncome ? `+${numberWithCommas(Math.abs(pv))}` : `-${numberWithCommas(pv)}`}
                                                                            </div>
                                                                        );
                                                                    })()}
                                                                </div>
                                                            </Col>
                                                            <Col md="3" className="mb-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(255,255,255,0.05)' }}>
                                                                    <small className="text-muted">MTT Overlay 成本</small>
                                                                    <div style={{ fontWeight: 'bold', color: '#ff6b6b' }}>
                                                                        -{numberWithCommas(Math.round(expense.mtt_overlay_cost || 0))}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col md="3" className="mb-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(255,255,255,0.05)' }}>
                                                                    <small className="text-muted">Leaderboard 成本</small>
                                                                    <div style={{ fontWeight: 'bold', color: '#ff6b6b' }}>
                                                                        -{numberWithCommas(Math.round(expense.leaderboard_cost || 0))}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col md="3" className="mb-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(155,81,224,0.10)', border: '1px solid rgba(155,81,224,0.4)' }}>
                                                                    <small className="text-muted" title="v2.1.0 純 Rebate 模式：max(0, −水前輸贏) × 固定 rate%，取代分潤+獎池">一般純 Rebate 支出</small>
                                                                    <div style={{ fontWeight: 'bold', color: '#9b51e0' }}>
                                                                        -{numberWithCommas(Math.round(expense.total_rebate || 0))}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            {/* v2.25.0 Tax & Rebate：補貼側（支出）。僅計 Ring Game 含 AOF，不含 MTT/SNG */}
                                                            {!!expense.total_tr_rebate && (
                                                                <Col md="3" className="mb-2">
                                                                    <div className="p-2 rounded" style={{ background: 'rgba(114,124,245,0.10)', border: '1px solid rgba(114,124,245,0.4)' }}>
                                                                        <small className="text-muted" title="僅計 Ring Game（NLH / PLO / AOF），不含 MTT / SNG">
                                                                            TR Rebate 支出
                                                                        </small>
                                                                        <div style={{ fontWeight: 'bold', color: '#727cf5' }}>
                                                                            -{numberWithCommas(Math.round(expense.total_tr_rebate || 0))}
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                            )}
                                                        </Row>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                        {/* JP淨營收細項（20260511 起生效；OFF state 整 row 不顯示） */}
                                        {this.state.jpInUnionRevenue && isExpanded === 'jp' && (item.jp_net_breakdown && item.jp_net_breakdown.applicable) && (
                                            <tr>
                                                <td colSpan={colSpanTotal} style={{ padding: 0, backgroundColor: 'rgba(225, 78, 202, 0.05)' }}>
                                                    <div className="p-3">
                                                        <h6 className="mb-3" style={{ color: '#e14eca' }}>
                                                            <i className="fa fa-shield mr-2"></i>JP淨營收細項
                                                            <small className="ml-2" style={{ color: '#9aa4bb', fontWeight: 400 }}>
                                                                {/* v2.30.3：佔成依週期（20260511 起 50%），不再寫死 30% */}
                                                                聯盟 JP fee 收入 + eco {jpSharePct}% 佔成 − 聯盟 JP payout 支出 − eco {jpSharePct}% 佔成
                                                            </small>
                                                        </h6>
                                                        <Row>
                                                            <Col md="3" className="mb-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(255,255,255,0.05)' }}>
                                                                    <small className="text-muted">真人 JP FEE</small>
                                                                    <div style={{ fontWeight: 'bold', color: '#2dce89' }}>
                                                                        +{numberWithCommas(Math.round(item.jp_net_breakdown.real_jp_fee || 0))}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col md="3" className="mb-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(255,255,255,0.05)' }}>
                                                                    <small className="text-muted">真人 JP PAYOUT</small>
                                                                    <div style={{ fontWeight: 'bold', color: '#ff6b6b' }}>
                                                                        -{numberWithCommas(Math.round(item.jp_net_breakdown.real_jp_payout || 0))}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col md="3" className="mb-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(255,255,255,0.05)' }}>
                                                                    <small className="text-muted">eco JP FEE × {jpSharePct}%</small>
                                                                    <div style={{ fontWeight: 'bold', color: '#2dce89' }}>
                                                                        +{numberWithCommas(Math.round(item.jp_net_breakdown.eco_jp_fee_30 || 0))}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col md="3" className="mb-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(255,255,255,0.05)' }}>
                                                                    <small className="text-muted">eco JP PAYOUT × {jpSharePct}%</small>
                                                                    <div style={{ fontWeight: 'bold', color: '#ff6b6b' }}>
                                                                        -{numberWithCommas(Math.round(item.jp_net_breakdown.eco_jp_payout_30 || 0))}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col md="12" className="mt-2">
                                                                <div className="p-2 rounded" style={{ background: 'rgba(225, 78, 202, 0.08)', border: '1px solid rgba(225, 78, 202, 0.35)' }}>
                                                                    <small className="text-muted">JP淨營收總計</small>
                                                                    {(() => {
                                                                        const v = Math.round(item.jp_net_breakdown.total || 0);
                                                                        const color = v >= 0 ? '#e14eca' : '#ff6b6b';
                                                                        const sign = v >= 0 ? '+' : '-';
                                                                        return (
                                                                            <div style={{ fontWeight: 'bold', color, fontSize: '18px' }}>
                                                                                {sign}{numberWithCommas(Math.abs(v))}
                                                                            </div>
                                                                        );
                                                                    })()}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                        </tbody>
                    </Table>
                </div>
                <div className="d-md-none">
                    {tinyRevenueData.map((item, index) => {
                        const unionBreakdown = item.union_breakdown || {};
                        const ecoBreakdown = item.eco_breakdown || {};
                        const selfBotBreakdown = item.self_bot_breakdown || {};
                        const botTotal = (ecoBreakdown.total || 0) + (selfBotBreakdown.total || 0);
                        const realBreakdown = item.real_breakdown || {};
                        const income = item.income || {};
                        const expense = item.expense || {};
                        const adjusted = this.getAdjustedRevenue(item);
                        const finalRevenue = Math.round(adjusted.finalRevenue || 0);
                        const additionalTotal = Math.round(adjusted.additionalTotal || 0);
                        const jpNet = item.jp_net_breakdown || { applicable: false };
                        const jpNetTotal = jpNet.applicable ? Math.round(jpNet.total || 0) : null;
                        return (
                            <div key={`tiny-mobile-${item.week}-${index}`} className="tiny-revenue-mobile-card">
                                <div className="tiny-revenue-mobile-head">
                                    <div>
                                        <div className="tiny-revenue-mobile-week">{this.renderTinyWeekLabel(item.week, index, tinyRevenueData)}</div>
                                        <div className="tiny-revenue-mobile-rank">#{index + 1}</div>
                                    </div>
                                    <div className={`tiny-revenue-mobile-final ${finalRevenue >= 0 ? 'profit' : 'loss'}`}>
                                        {numberWithCommas(finalRevenue)}
                                    </div>
                                </div>
                                <div className="tiny-revenue-mobile-grid">
                                    <div className="tiny-kpi tiny-kpi-union"><small>聯盟總水</small><strong>{numberWithCommas(Math.round(unionBreakdown.total || 0))}</strong></div>
                                    <div className="tiny-kpi tiny-kpi-eco"><small>Bot總水</small><strong>{numberWithCommas(Math.round(botTotal))}</strong></div>
                                    <div className="tiny-kpi tiny-kpi-real"><small>真人總水</small><strong>{numberWithCommas(Math.round(realBreakdown.total || 0))}</strong></div>
                                    <div className="tiny-kpi tiny-kpi-income"><small>收入總和</small><strong>{numberWithCommas(Math.round(income.total || 0))}</strong></div>
                                    <div className="tiny-kpi tiny-kpi-expense"><small>支出總和</small><strong>-{numberWithCommas(Math.round(expense.total || 0))}</strong></div>
                                    {this.state.jpInUnionRevenue && (
                                    <div className="tiny-kpi tiny-kpi-additional">
                                        <small>JP淨營收</small>
                                        {jpNetTotal === null ? (
                                            <strong style={{ color: '#9aa4bb' }}>-</strong>
                                        ) : (
                                            <strong style={{ color: jpNetTotal >= 0 ? '#e14eca' : '#ff6b6b' }}>
                                                {jpNetTotal >= 0
                                                    ? `+${numberWithCommas(jpNetTotal)}`
                                                    : `-${numberWithCommas(Math.abs(jpNetTotal))}`}
                                            </strong>
                                        )}
                                    </div>
                                    )}
                                    <div className="tiny-kpi tiny-kpi-additional">
                                        <small>額外費用</small>
                                        <strong className={additionalTotal >= 0 ? 'loss' : 'profit'}>
                                            {additionalTotal >= 0
                                                ? `-${numberWithCommas(additionalTotal)}`
                                                : `+${numberWithCommas(Math.abs(additionalTotal))}`}
                                        </strong>
                                    </div>
                                </div>
                                <div className="tiny-revenue-mobile-actions">
                                    <Button size="sm" className="tiny-action-btn tiny-action-btn-detail" onClick={() => this.openTinyDetailModal(item.week, item)}>
                                        <i className="fa fa-search-plus mr-1" />
                                        詳情
                                    </Button>
                                    <Button size="sm" className="tiny-action-btn tiny-action-btn-expense" onClick={() => this.openExpenseModal(item.week)}>
                                        <i className="fa fa-edit mr-1" />
                                        額外費用
                                    </Button>
                                </div>
                                <div className="tiny-revenue-mobile-notes">
                                    {this.renderTinyWeekNoteTitles(item.week)}
                                </div>
                            </div>
                        );
                    })}
                </div>
                </>
                )}
                
                {/* 費用編輯 Modal */}
                {this.renderExpenseModal()}
                {/* 詳情 Modal */}
                {this.renderTinyDetailModal()}
                {this.renderTinyNoteTooltip()}
                <style>{`
                    .tiny-revenue-table-wrap {
                        border: 1px solid rgba(255, 255, 255, 0.08);
                        border-radius: 10px;
                        overflow: visible;
                    }
                    .tiny-revenue-main-table thead th {
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    .tiny-revenue-main-table tbody td {
                        white-space: nowrap;
                        vertical-align: middle;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    .tiny-revenue-main-table {
                        table-layout: fixed;
                        width: 100%;
                    }
                    .tiny-revenue-main-table th:nth-child(1),
                    .tiny-revenue-main-table td:nth-child(1) { width: 112px; }
                    .tiny-revenue-main-table th:nth-child(2),
                    .tiny-revenue-main-table td:nth-child(2),
                    .tiny-revenue-main-table th:nth-child(3),
                    .tiny-revenue-main-table td:nth-child(3),
                    .tiny-revenue-main-table th:nth-child(4),
                    .tiny-revenue-main-table td:nth-child(4),
                    .tiny-revenue-main-table th:nth-child(5),
                    .tiny-revenue-main-table td:nth-child(5),
                    .tiny-revenue-main-table th:nth-child(6),
                    .tiny-revenue-main-table td:nth-child(6),
                    .tiny-revenue-main-table th:nth-child(7),
                    .tiny-revenue-main-table td:nth-child(7) { width: 91px; }
                    .tiny-revenue-main-table th:nth-child(8),
                    .tiny-revenue-main-table td:nth-child(8) { width: 132px; }
                    .tiny-revenue-main-table th:nth-child(9),
                    .tiny-revenue-main-table td:nth-child(9) { width: 68px; }
                    .tiny-revenue-main-table td:nth-child(9) {
                        overflow: visible !important;
                        text-overflow: clip !important;
                    }
                    .tiny-detail-btn {
                        white-space: nowrap;
                    }
                    .tiny-revenue-main-table th:nth-child(10),
                    .tiny-revenue-main-table td:nth-child(10) { width: 96px; }
                    .tiny-revenue-main-table th:nth-child(11),
                    .tiny-revenue-main-table td:nth-child(11) { width: 96px; }
                    .tiny-toggle-label-compact {
                        display: none;
                    }
                    .tiny-week-main {
                        color: #e6efff;
                        font-weight: 700;
                        letter-spacing: 0.2px;
                    }
                    .tiny-year-separator-row td {
                        padding: 8px 12px !important;
                        background: linear-gradient(90deg, rgba(64, 97, 160, 0.22), rgba(50, 74, 122, 0.18));
                        border-top: 1px solid rgba(146, 180, 241, 0.18);
                        border-bottom: 1px solid rgba(146, 180, 241, 0.12);
                    }
                    .tiny-year-separator {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                    }
                    .tiny-year-separator-line {
                        height: 1px;
                        flex: 1;
                        background: linear-gradient(90deg, rgba(166, 195, 246, 0), rgba(166, 195, 246, 0.5), rgba(166, 195, 246, 0));
                    }
                    .tiny-year-separator-pill {
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        min-width: 76px;
                        font-size: 10px;
                        color: #edf4ff;
                        border: 1px solid rgba(183, 209, 255, 0.44);
                        border-radius: 999px;
                        padding: 3px 12px;
                        background: linear-gradient(135deg, rgba(86, 126, 210, 0.5), rgba(64, 91, 153, 0.4));
                        letter-spacing: 0.7px;
                        font-weight: 700;
                        box-shadow: 0 6px 14px rgba(17, 31, 59, 0.28), inset 0 1px 0 rgba(255, 255, 255, 0.12);
                    }
                    .tiny-revenue-main-table tbody tr.tiny-main-row > td {
                        height: 46px;
                        min-height: 46px;
                        vertical-align: middle;
                    }
                    .tiny-week-notes-list {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: center;
                        width: auto;
                        margin: 0 auto;
                    }
                    .tiny-week-note-row {
                        position: relative;
                        width: auto;
                        max-width: none;
                    }
                    .tiny-week-note-chip {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 0;
                        border-radius: 8px;
                        padding: 3px 10px;
                        font-size: 11px;
                        font-weight: 700;
                        color: #f0f5ff;
                        border: 1px solid rgba(141, 164, 255, 0.48);
                        background: linear-gradient(135deg, rgba(93, 126, 245, 0.42), rgba(71, 95, 188, 0.27));
                        box-shadow: 0 6px 14px rgba(56, 78, 156, 0.3), inset 0 1px 0 rgba(255,255,255,0.1);
                        line-height: 1.1;
                        cursor: help;
                        transition: transform 0.16s ease, filter 0.16s ease;
                        width: fit-content;
                        max-width: 100%;
                        position: relative;
                    }
                    .tiny-week-note-icon {
                        color: #cfe1ff;
                        font-size: 9px;
                        opacity: 0.9;
                        flex: 0 0 auto;
                        display: none;
                    }
                    .tiny-week-note-chip:hover {
                        transform: translateY(-1px);
                        filter: brightness(1.06);
                    }
                    .tiny-week-note-title {
                        display: block;
                        min-width: 0;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        text-align: center;
                        max-width: 100%;
                    }
                    .tiny-week-note-chip.has-more .tiny-week-note-title {
                        padding-right: 30px;
                    }
                    .tiny-week-note-more {
                        position: absolute;
                        right: 6px;
                        top: 50%;
                        transform: translateY(-50%);
                        border-radius: 999px;
                        padding: 1px 6px;
                        font-size: 10px;
                        font-weight: 700;
                        color: #d6e6ff;
                        background: rgba(18, 35, 73, 0.62);
                        border: 1px solid rgba(170, 198, 255, 0.42);
                    }
                    .tiny-floating-note-tooltip {
                        position: fixed;
                        z-index: 5000;
                        width: min(380px, calc(100vw - 24px));
                        border: 1px solid rgba(143, 167, 224, 0.28);
                        border-radius: 14px;
                        background: linear-gradient(180deg, rgba(20, 30, 51, 0.98), rgba(18, 26, 44, 0.98));
                        box-shadow: 0 20px 48px rgba(7, 12, 25, 0.52);
                        padding: 0;
                        pointer-events: none;
                        overflow: hidden;
                    }
                    .tiny-floating-note-title {
                        color: #eaf2ff;
                        font-size: 13px;
                        font-weight: 700;
                        padding: 10px 12px;
                        border-bottom: 1px solid rgba(143, 167, 224, 0.2);
                    }
                    .tiny-floating-note-text {
                        color: #dce8ff;
                        max-height: 320px;
                        overflow: auto;
                        padding: 10px 12px 12px;
                    }
                    .tiny-floating-note-item {
                        border: 1px solid rgba(141, 164, 255, 0.28);
                        border-radius: 10px;
                        padding: 10px 12px;
                        background: linear-gradient(135deg, rgba(76, 110, 192, 0.18), rgba(53, 77, 147, 0.12));
                        margin-bottom: 8px;
                    }
                    .tiny-floating-note-item:last-child {
                        margin-bottom: 0;
                    }
                    .tiny-floating-note-item-head {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        gap: 10px;
                        margin-bottom: 6px;
                    }
                    .tiny-floating-note-item-title {
                        color: #e6efff;
                        font-size: 12px;
                        font-weight: 700;
                    }
                    .tiny-floating-note-item-idx {
                        color: #a7c0f8;
                        font-size: 10px;
                        border: 1px solid rgba(166, 192, 248, 0.34);
                        border-radius: 999px;
                        padding: 1px 7px;
                    }
                    .tiny-floating-note-item-desc {
                        color: #c8d9ff;
                        font-size: 12px;
                        line-height: 1.45;
                        white-space: pre-wrap;
                        word-break: break-word;
                    }
                    .tiny-week-note-empty {
                        color: #9bb2d8;
                        font-size: 11px;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        gap: 5px;
                        height: 26px;
                        border-radius: 999px;
                        padding: 0 10px;
                        border: 1px solid rgba(131, 155, 199, 0.28);
                        background: rgba(39, 57, 92, 0.25);
                    }
                    .tiny-week-notes-modal .modal-content {
                        border: 1px solid rgba(143, 167, 224, 0.22);
                        border-radius: 14px;
                        background: linear-gradient(180deg, rgba(20, 30, 51, 0.98), rgba(18, 26, 44, 0.98));
                        box-shadow: 0 20px 48px rgba(7, 12, 25, 0.48);
                    }
                    .tiny-week-notes-list-modal {
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                        max-height: min(58vh, 460px);
                        overflow: auto;
                        padding-right: 2px;
                    }
                    .tiny-week-note-item {
                        border: 1px solid rgba(141, 164, 255, 0.28);
                        border-radius: 10px;
                        padding: 10px 12px;
                        background: linear-gradient(135deg, rgba(76, 110, 192, 0.18), rgba(53, 77, 147, 0.12));
                    }
                    .tiny-week-note-item-head {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        gap: 10px;
                        margin-bottom: 6px;
                    }
                    .tiny-week-note-item-title {
                        color: #e6efff;
                        font-size: 13px;
                        font-weight: 700;
                    }
                    .tiny-week-note-item-idx {
                        color: #a7c0f8;
                        font-size: 10px;
                        border: 1px solid rgba(166, 192, 248, 0.34);
                        border-radius: 999px;
                        padding: 1px 7px;
                    }
                    .tiny-week-note-item-desc {
                        color: #c8d9ff;
                        font-size: 12px;
                        line-height: 1.45;
                        white-space: pre-wrap;
                        word-break: break-word;
                    }
                    .tiny-revenue-mobile-card {
                        border: 1px solid rgba(139, 162, 214, 0.14);
                        border-radius: 12px;
                        padding: 12px;
                        margin-bottom: 10px;
                        background: linear-gradient(180deg, rgba(27, 36, 58, 0.95), rgba(23, 31, 50, 0.95));
                        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04), 0 8px 18px rgba(8, 14, 28, 0.22);
                    }
                    .tiny-revenue-mobile-head {
                        display: flex;
                        align-items: flex-start;
                        justify-content: space-between;
                        gap: 12px;
                        margin-bottom: 10px;
                    }
                    .tiny-revenue-mobile-week {
                        font-weight: 700;
                        color: #f4f8ff;
                        line-height: 1.2;
                        font-size: 24px;
                    }
                    .tiny-revenue-mobile-rank {
                        font-size: 11px;
                        color: #9ab0cf;
                        margin-top: 2px;
                    }
                    .tiny-revenue-mobile-final {
                        font-size: 16px;
                        font-weight: 700;
                    }
                    .tiny-revenue-mobile-grid {
                        display: grid;
                        grid-template-columns: repeat(2, minmax(0, 1fr));
                        gap: 8px 10px;
                    }
                    .tiny-revenue-mobile-grid small {
                        display: block;
                        color: #8ea4c3;
                        font-size: 11px;
                        margin-bottom: 3px;
                        letter-spacing: 0.2px;
                    }
                    .tiny-revenue-mobile-grid strong {
                        color: #fff;
                        font-size: 16px;
                        font-weight: 700;
                        letter-spacing: 0.2px;
                        text-shadow: 0 0 10px rgba(0, 0, 0, 0.22);
                    }
                    .tiny-kpi {
                        border-radius: 8px;
                        padding: 6px 7px;
                        background: linear-gradient(180deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.01));
                        border: 1px solid rgba(255, 255, 255, 0.06);
                    }
                    .tiny-kpi-union { border-left: 2px solid rgba(225, 78, 202, 0.72); }
                    .tiny-kpi-union strong { color: #e14eca; }
                    .tiny-kpi-eco { border-left: 2px solid rgba(255, 193, 7, 0.78); }
                    .tiny-kpi-eco strong { color: #ffc107; }
                    .tiny-kpi-real { border-left: 2px solid rgba(54, 162, 235, 0.8); }
                    .tiny-kpi-real strong { color: #36a2eb; }
                    .tiny-kpi-income { border-left: 2px solid rgba(75, 192, 192, 0.8); }
                    .tiny-kpi-income strong { color: #4bc0c0; }
                    .tiny-kpi-expense { border-left: 2px solid rgba(255, 159, 64, 0.84); }
                    .tiny-kpi-expense strong { color: #ff9f40; }
                    .tiny-kpi-additional { border-left: 2px solid rgba(255, 99, 132, 0.76); }
                    .tiny-revenue-mobile-actions {
                        display: flex;
                        gap: 8px;
                        margin-top: 10px;
                        margin-bottom: 8px;
                    }
                    .tiny-action-btn {
                        border: none !important;
                        color: #fff !important;
                        font-weight: 700 !important;
                        border-radius: 8px !important;
                        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.28);
                        padding: 5px 10px !important;
                        font-size: 12px !important;
                        transition: transform 0.15s ease, filter 0.15s ease;
                    }
                    .tiny-action-btn:hover {
                        transform: translateY(-1px);
                        filter: brightness(1.06);
                    }
                    .tiny-action-btn-detail {
                        background: linear-gradient(135deg, #23b6e6, #1d8fcf) !important;
                    }
                    .tiny-action-btn-expense {
                        background: linear-gradient(135deg, #ff8d72, #fb6340) !important;
                    }
                    .tiny-revenue-mobile-notes {
                        color: #c7d5ea;
                        font-size: 12px;
                        border-top: 1px dashed rgba(134, 153, 195, 0.28);
                        padding-top: 8px;
                    }
                    .tiny-revenue-mobile-final.profit,
                    .tiny-revenue-mobile-grid strong.profit {
                        color: #2fbf2f;
                    }
                    .tiny-revenue-mobile-final.loss,
                    .tiny-revenue-mobile-grid strong.loss {
                        color: #ff6b6b;
                    }
                    @media (max-width: 1680px) {
                        .tiny-revenue-main-table th,
                        .tiny-revenue-main-table td {
                            font-size: 12px !important;
                            padding: 0.42rem 0.4rem !important;
                        }
                        .tiny-revenue-main-table th > div {
                            line-height: 1.2;
                        }
                    }
                    @media (min-width: 1600px) {
                        .tiny-revenue-main-table th,
                        .tiny-revenue-main-table td {
                            font-size: 13px !important;
                            padding: 0.55rem 0.52rem !important;
                        }
                    }
                    @media (max-width: 1599.98px) and (min-width: 1200px) {
                        .tiny-revenue-main-table th,
                        .tiny-revenue-main-table td {
                            font-size: 11.5px !important;
                            padding: 0.34rem 0.3rem !important;
                        }
                        .tiny-week-note-chip {
                            font-size: 10px;
                            padding: 3px 6px;
                        }
                    }
                    @media (max-width: 1499.98px) and (min-width: 1200px) {
                        .tiny-revenue-main-table th,
                        .tiny-revenue-main-table td {
                            font-size: 10.8px !important;
                            padding: 0.28rem 0.22rem !important;
                        }
                        .tiny-revenue-main-table th:nth-child(1),
                        .tiny-revenue-main-table td:nth-child(1) { width: 98px; }
                        .tiny-revenue-main-table th:nth-child(2),
                        .tiny-revenue-main-table td:nth-child(2),
                        .tiny-revenue-main-table th:nth-child(3),
                        .tiny-revenue-main-table td:nth-child(3),
                        .tiny-revenue-main-table th:nth-child(4),
                        .tiny-revenue-main-table td:nth-child(4),
                        .tiny-revenue-main-table th:nth-child(5),
                        .tiny-revenue-main-table td:nth-child(5),
                        .tiny-revenue-main-table th:nth-child(6),
                        .tiny-revenue-main-table td:nth-child(6),
                        .tiny-revenue-main-table th:nth-child(7),
                        .tiny-revenue-main-table td:nth-child(7) { width: 80px; }
                        .tiny-revenue-main-table th:nth-child(8),
                        .tiny-revenue-main-table td:nth-child(8) { width: 108px; }
                        .tiny-revenue-main-table th:nth-child(9),
                        .tiny-revenue-main-table td:nth-child(9) { width: 62px; }
                        .tiny-revenue-main-table th:nth-child(10),
                        .tiny-revenue-main-table td:nth-child(10) { width: 78px; }
                        .tiny-week-note-title {
                            font-size: 9.5px;
                        }
                        .tiny-bulk-expand,
                        .tiny-bulk-collapse {
                            font-size: 8px !important;
                            padding: 1px 4px !important;
                            gap: 2px !important;
                        }
                        .tiny-toggle-label-full {
                            display: none;
                        }
                        .tiny-toggle-label-compact {
                            display: inline;
                        }
                        .tiny-detail-btn {
                            font-size: 8px !important;
                            padding: 2px 5px !important;
                            gap: 2px !important;
                            border-radius: 3px !important;
                        }
                        .tiny-detail-btn i {
                            font-size: 8px !important;
                        }
                    }
                    @media (max-width: 1199.98px) and (min-width: 992px) {
                        .tiny-revenue-main-table th,
                        .tiny-revenue-main-table td {
                            font-size: 10.5px !important;
                            padding: 0.3rem 0.24rem !important;
                        }
                        .tiny-revenue-main-table th:nth-child(1),
                        .tiny-revenue-main-table td:nth-child(1) { width: 100px; }
                        .tiny-revenue-main-table th:nth-child(2),
                        .tiny-revenue-main-table td:nth-child(2),
                        .tiny-revenue-main-table th:nth-child(3),
                        .tiny-revenue-main-table td:nth-child(3),
                        .tiny-revenue-main-table th:nth-child(4),
                        .tiny-revenue-main-table td:nth-child(4),
                        .tiny-revenue-main-table th:nth-child(5),
                        .tiny-revenue-main-table td:nth-child(5),
                        .tiny-revenue-main-table th:nth-child(6),
                        .tiny-revenue-main-table td:nth-child(6),
                        .tiny-revenue-main-table th:nth-child(7),
                        .tiny-revenue-main-table td:nth-child(7) { width: 82px; }
                        .tiny-revenue-main-table th:nth-child(8),
                        .tiny-revenue-main-table td:nth-child(8) { width: 112px; }
                        .tiny-revenue-main-table th:nth-child(9),
                        .tiny-revenue-main-table td:nth-child(9) { width: 64px; }
                        .tiny-revenue-main-table th:nth-child(10),
                        .tiny-revenue-main-table td:nth-child(10) { width: 86px; }
                        .tiny-week-note-title {
                            font-size: 10px;
                        }
                        .tiny-toggle-label-full {
                            display: none;
                        }
                        .tiny-toggle-label-compact {
                            display: inline;
                        }
                        .tiny-bulk-expand,
                        .tiny-bulk-collapse {
                            font-size: 8px !important;
                            padding: 1px 4px !important;
                            gap: 2px !important;
                        }
                        .tiny-detail-btn {
                            font-size: 8px !important;
                            padding: 2px 5px !important;
                            gap: 2px !important;
                            border-radius: 3px !important;
                        }
                        .tiny-detail-btn i {
                            font-size: 8px !important;
                        }
                    }
                    @media (max-width: 1199.98px) and (min-width: 768px) {
                        .tiny-revenue-main-table th,
                        .tiny-revenue-main-table td {
                            font-size: 10px !important;
                            padding: 0.26rem 0.2rem !important;
                        }
                        .tiny-revenue-main-table th:nth-child(1),
                        .tiny-revenue-main-table td:nth-child(1) { width: 82px; }
                        .tiny-revenue-main-table th:nth-child(2),
                        .tiny-revenue-main-table td:nth-child(2),
                        .tiny-revenue-main-table th:nth-child(3),
                        .tiny-revenue-main-table td:nth-child(3),
                        .tiny-revenue-main-table th:nth-child(4),
                        .tiny-revenue-main-table td:nth-child(4),
                        .tiny-revenue-main-table th:nth-child(5),
                        .tiny-revenue-main-table td:nth-child(5),
                        .tiny-revenue-main-table th:nth-child(6),
                        .tiny-revenue-main-table td:nth-child(6),
                        .tiny-revenue-main-table th:nth-child(7),
                        .tiny-revenue-main-table td:nth-child(7) { width: 64px; }
                        .tiny-revenue-main-table th:nth-child(8),
                        .tiny-revenue-main-table td:nth-child(8) { width: 96px; }
                        .tiny-revenue-main-table th:nth-child(9),
                        .tiny-revenue-main-table td:nth-child(9) { width: 58px; }
                        .tiny-revenue-main-table th:nth-child(10),
                        .tiny-revenue-main-table td:nth-child(10) { width: 70px; }
                        .tiny-week-note-chip {
                            padding: 2px 6px;
                        }
                        .tiny-week-note-icon {
                            display: none;
                        }
                        .tiny-week-note-title {
                            font-size: 9.5px;
                        }
                        .tiny-toggle-label-full {
                            display: none;
                        }
                        .tiny-toggle-label-compact {
                            display: inline;
                        }
                        .tiny-bulk-expand,
                        .tiny-bulk-collapse {
                            font-size: 7.5px !important;
                            padding: 1px 3px !important;
                            gap: 1px !important;
                        }
                        .tiny-bulk-expand i,
                        .tiny-bulk-collapse i {
                            display: none !important;
                        }
                        .tiny-detail-btn {
                            font-size: 7.5px !important;
                            padding: 2px 4px !important;
                            gap: 1px !important;
                            border-radius: 3px !important;
                        }
                        .tiny-detail-btn i {
                            font-size: 7.5px !important;
                        }
                    }
                    @media (max-width: 767.98px) {
                        .tiny-revenue-mobile-grid {
                            grid-template-columns: repeat(2, minmax(0, 1fr));
                        }
                        .tiny-revenue-mobile-grid strong {
                            font-size: 15px;
                        }
                        .tiny-revenue-mobile-actions {
                            flex-wrap: wrap;
                        }
                    }
                `}</style>
            </>
        );
    }
    
    // 渲染遊戲類型細項
    renderBreakdownItem = (label, value, color) => {
        return (
            <Col md="3" className="mb-2">
                <div className="p-2 rounded" style={{ background: 'rgba(255,255,255,0.05)' }}>
                    <small className="text-muted">{label}</small>
                    <div style={{ fontWeight: 'bold', color: color }}>
                        {numberWithCommas(Math.round(value || 0))}
                    </div>
                </div>
            </Col>
        );
    }
    
    // 切換展開/收合
    toggleTinyRow = (week, type) => {
        this.setState(prevState => {
            const current = prevState.tinyExpandedRows[week];
            return {
                tinyExpandedRows: {
                    ...prevState.tinyExpandedRows,
                    [week]: current === type ? null : type
                }
            };
        });
    }
    
    // TinyPoker 全展開/全收起指定類型
    expandCollapseAllTiny = (type) => {
        const { tinyRevenueData = [] } = this.state;
        this.setState(prevState => {
            const newExpandedRows = {};
            if (type) {
                // 全展開：將所有週期的該類型設為展開
                tinyRevenueData.forEach(item => {
                    newExpandedRows[item.week] = type;
                });
            }
            // 全收起：空物件即可
            return { tinyExpandedRows: newExpandedRows };
        });
    }
    
    // 打開費用編輯 Modal
    openExpenseModal = async (week) => {
        this.setState({ expenseModalLoading: true, expenseModalWeek: week, showExpenseModal: true });
        try {
            const response = await axios.get(`/api/tiny/expenses?week=${week}`);
            if (response.data.code === 1) {
                this.setState({ 
                    expenseModalItems: response.data.data, 
                    expenseModalLoading: false 
                });
            }
        } catch (error) {
            console.error('Failed to load expenses:', error);
            this.setState({ expenseModalItems: [], expenseModalLoading: false });
        }
    }
    
    // 關閉費用 Modal
    closeExpenseModal = () => {
        this.setState({ showExpenseModal: false, expenseModalWeek: '', expenseModalItems: [] });
    }
    
    // 新增費用
    addExpense = async () => {
        const { expenseModalWeek, newExpenseName, newExpenseAmount, newExpenseCategory } = this.state;
        if (!newExpenseName || !newExpenseAmount) {
            alert('請填寫項目名稱和金額');
            return;
        }
        
        try {
            const response = await axios.post('/api/tiny/expenses', {
                week: expenseModalWeek,
                name: newExpenseName,
                amount: parseFloat(newExpenseAmount),
                category: newExpenseCategory || 'other'
            });
            if (response.data.code === 1) {
                this.setState({ newExpenseName: '', newExpenseAmount: '', newExpenseCategory: 'other' });
                this.openExpenseModal(expenseModalWeek);
                this.loadTinyRevenueData(); // 刷新數據
            } else {
                alert('新增失敗: ' + (response.data.msg || '未知錯誤'));
            }
        } catch (error) {
            console.error('Failed to add expense:', error);
            alert('新增失敗: ' + (error.response?.data?.msg || error.message));
        }
    }
    
    // 刪除費用
    deleteExpense = async (expenseId) => {
        if (!window.confirm('確定要刪除此費用項目？')) return;
        
        try {
            const response = await axios.delete(`/api/tiny/expenses/${expenseId}`);
            if (response.data.code === 1) {
                this.openExpenseModal(this.state.expenseModalWeek);
                this.loadTinyRevenueData(); // 刷新數據
            } else {
                alert('刪除失敗: ' + (response.data.msg || '未知錯誤'));
            }
        } catch (error) {
            console.error('Failed to delete expense:', error);
            alert('刪除失敗: ' + (error.response?.data?.msg || error.message));
        }
    }
    
    // 費用編輯 Modal
    renderExpenseModal = () => {
        const { showExpenseModal, expenseModalWeek, expenseModalItems = [], expenseModalLoading,
                newExpenseName, newExpenseAmount, newExpenseCategory, jpInUnionRevenue } = this.state;
        const { user } = this.props;

        if (!showExpenseModal) return null;

        const totalExpenseRaw = expenseModalItems.reduce((sum, item) => sum + (item.amount || 0), 0);
        // OFF 時總計排除 jp_compensation，跟主表「額外費用」欄、聯盟淨營收 都對得上
        const totalExpense = jpInUnionRevenue
            ? totalExpenseRaw
            : expenseModalItems
                .filter(it => (it.category || 'other') !== 'jp_compensation')
                .reduce((sum, item) => sum + (item.amount || 0), 0);
        const hasJpCompInList = expenseModalItems.some(it => (it.category || 'other') === 'jp_compensation');
        
        // 深色主題樣式
        const darkModalStyle = {
            content: { background: '#1e1e2f', color: '#fff', border: 'none' },
            header: { background: '#1e1e2f', color: '#fff', borderBottom: '1px solid #333' },
            body: { background: '#1e1e2f', color: '#fff' },
            footer: { background: '#1e1e2f', borderTop: '1px solid #333' },
            input: { background: '#2d2d44', color: '#fff', border: '1px solid #444' },
            select: { background: '#2d2d44', color: '#fff', border: '1px solid #444' },
            label: { color: '#aaa' }
        };
        
        return (
            <Modal isOpen={showExpenseModal} toggle={this.closeExpenseModal} size="lg" 
                   contentClassName="bg-dark text-white">
                <ModalHeader toggle={this.closeExpenseModal} 
                             style={darkModalStyle.header}
                             className="text-white border-secondary">
                    <i className="fa fa-edit mr-2" style={{ color: '#e14eca' }}></i>
                    編輯額外費用 - {expenseModalWeek}
                </ModalHeader>
                <ModalBody style={darkModalStyle.body}>
                    {/* v2.33.0：額外費用的編輯要有 edit_revenue cap。
                        ⚠️ 這裡只是不畫出來 —— 真正的把關在後端
                        api/tiny/expenses.py 那三支寫入端點的 @require_cap。 */}
                    {!hasCap(user, 'edit_revenue') && (
                        <div className="alert alert-secondary" role="alert">
                            <i className="fa fa-lock mr-2"></i>
                            你沒有「編輯營收數據」權限，以下為唯讀。需要的話請聯絡後臺管理員。
                        </div>
                    )}
                    {expenseModalLoading ? (
                        <TinyLoading text="載入中" variant="block" />
                    ) : (
                        <>
                            {/* 新增費用表單（需要 edit_revenue） */}
                            {hasCap(user, 'edit_revenue') && 
                            <div className="mb-4 p-3" style={{ background: '#2d2d44', borderRadius: '8px', border: '1px solid #444' }}>
                                <h6 className="mb-3" style={{ color: '#4bc0c0' }}>
                                    <i className="fa fa-plus-circle mr-2"></i>新增費用項目
                                </h6>
                                <Row className="align-items-end">
                                    <Col md="4">
                                        <FormGroup className="mb-0">
                                            <Label style={darkModalStyle.label}>項目名稱</Label>
                                            <Input 
                                                type="text" 
                                                value={newExpenseName || ''} 
                                                onChange={(e) => this.setState({ newExpenseName: e.target.value })}
                                                placeholder="例：刮刮樂活動成本"
                                                style={darkModalStyle.input}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="2">
                                        <FormGroup className="mb-0">
                                            <Label style={darkModalStyle.label}>金額</Label>
                                            <Input 
                                                type="number" 
                                                value={newExpenseAmount || ''} 
                                                onChange={(e) => this.setState({ newExpenseAmount: e.target.value })}
                                                placeholder="50000"
                                                style={darkModalStyle.input}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup className="mb-0">
                                            <Label style={darkModalStyle.label}>類別</Label>
                                            <Input 
                                                type="select" 
                                                value={newExpenseCategory || 'other'}
                                                onChange={(e) => this.setState({ newExpenseCategory: e.target.value })}
                                                style={darkModalStyle.select}
                                            >
                                                <option value="activity">活動成本</option>
                                                <option value="personnel">人事費用</option>
                                                <option value="operation">營運費用</option>
                                                <option value="marketing">行銷費用</option>
                                                <option value="jp_compensation">JP 補償</option>
                                                <option value="other">其他費用</option>
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <Button 
                                            onClick={this.addExpense} 
                                            block
                                            style={{ 
                                                background: 'linear-gradient(135deg, #4bc0c0, #36a2eb)',
                                                border: 'none',
                                                fontWeight: 'bold',
                                                fontSize: '14px',
                                                padding: '10px 16px',
                                                borderRadius: '6px',
                                                boxShadow: '0 4px 15px rgba(75, 192, 192, 0.3)',
                                                transition: 'all 0.3s ease',
                                                letterSpacing: '1px',
                                                whiteSpace: 'nowrap'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.boxShadow = '0 6px 20px rgba(75, 192, 192, 0.5)';
                                                e.target.style.transform = 'translateY(-1px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.boxShadow = '0 4px 15px rgba(75, 192, 192, 0.3)';
                                                e.target.style.transform = 'translateY(0)';
                                            }}
                                        >
                                            <i className="fa fa-plus mr-2"></i>新增
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                            }

                            {/* OFF 模式下，且該週有 jp_compensation 項目 → 提示 user */}
                            {!jpInUnionRevenue && hasJpCompInList && (
                                <div className="mb-3 p-2" style={{
                                    background: 'rgba(253, 93, 147, 0.10)',
                                    border: '1px solid rgba(253, 93, 147, 0.4)',
                                    borderRadius: '6px',
                                    color: '#ffd9b8',
                                    fontSize: '12px',
                                }}>
                                    <i className="fa fa-shield mr-2" style={{ color: '#fd5d93' }}></i>
                                    OFF 模式下 <strong>JP 補償</strong> 類別費用不計入聯盟淨營收（下方已 strike-through 標示）
                                </div>
                            )}

                            {/* 已有費用列表 */}
                            <h6 className="mb-3" style={{ color: '#ffc107' }}>
                                <i className="fa fa-list mr-2"></i>
                                費用列表 (共 {expenseModalItems.length} 項，總計
                                <span style={{ color: totalExpense >= 0 ? '#ff6b6b' : '#2fbf2f', marginLeft: '5px' }}>
                                    {totalExpense >= 0
                                        ? `-${numberWithCommas(Math.round(totalExpense))}`
                                        : `+${numberWithCommas(Math.abs(Math.round(totalExpense)))}`
                                    }
                                </span>{!jpInUnionRevenue && hasJpCompInList && (
                                    <span style={{ fontSize: '11px', color: '#9aa4bb', marginLeft: '6px', fontWeight: 400 }}>
                                        （OFF 模式總計，已排除 JP 補償）
                                    </span>
                                )})
                            </h6>
                            {expenseModalItems.length === 0 ? (
                                <div className="text-center py-5" style={{ color: '#666' }}>
                                    <i className="fa fa-inbox fa-3x mb-3"></i>
                                    <p>尚無費用項目</p>
                                </div>
                            ) : (
                                <Table className="tablesorter" size="sm" style={{ color: '#fff' }}>
                                    <thead>
                                        <tr style={{ borderBottom: '1px solid #444' }}>
                                            <th style={{ color: '#aaa' }}>項目名稱</th>
                                            <th style={{ textAlign: 'center', color: '#aaa' }}>類別</th>
                                            <th style={{ textAlign: 'right', color: '#aaa' }}>金額</th>
                                            <th style={{ textAlign: 'center', width: '80px', color: '#aaa' }}>操作</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {expenseModalItems.map((item, idx) => {
                                            const isJpComp = (item.category || 'other') === 'jp_compensation';
                                            const stripped = isJpComp && !jpInUnionRevenue;
                                            const baseAmountColor = (item.amount || 0) >= 0 ? '#ff6b6b' : '#2fbf2f';
                                            return (
                                                <tr key={item._id || idx} style={{
                                                    borderBottom: '1px solid #333',
                                                    background: stripped ? 'rgba(107, 115, 144, 0.08)' : 'transparent',
                                                }}>
                                                    <td style={{
                                                        color: stripped ? '#6b7390' : '#fff',
                                                        textDecoration: stripped ? 'line-through' : 'none',
                                                    }}>
                                                        {item.name}
                                                        {stripped && (
                                                            <span style={{ marginLeft: 6, fontSize: 10, color: '#e14eca', textDecoration: 'none' }}>
                                                                (OFF 模式不計入)
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td style={{ textAlign: 'center', opacity: stripped ? 0.55 : 1 }}>
                                                        <Badge
                                                            style={{
                                                                backgroundColor: this.getExpenseCategoryColorHex(item.category),
                                                                color: '#fff'
                                                            }}
                                                        >
                                                            {this.getExpenseCategoryName(item.category)}
                                                        </Badge>
                                                    </td>
                                                    <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'bold',
                                                        color: stripped ? '#6b7390' : baseAmountColor,
                                                        textDecoration: stripped ? 'line-through' : 'none',
                                                    }}>
                                                        {(item.amount || 0) >= 0
                                                            ? `-${numberWithCommas(Math.round(item.amount || 0))}`
                                                            : `+${numberWithCommas(Math.abs(Math.round(item.amount)))}`
                                                        }
                                                    </td>
                                                    <td style={{ textAlign: 'center' }}>
                                                        {hasCap(user, 'edit_revenue') ? (
                                                        <Button
                                                            color="danger"
                                                            size="sm"
                                                            onClick={() => this.deleteExpense(item._id)}
                                                            style={{ background: '#dc3545', border: 'none' }}
                                                        >
                                                            <i className="fa fa-trash"></i>
                                                        </Button>
                                                        ) : (
                                                            <span className="text-muted">—</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                            )}
                        </>
                    )}
                </ModalBody>
                <ModalFooter style={{ background: '#1e1e2f', borderTop: '1px solid #333' }}>
                    <Button 
                        onClick={this.closeExpenseModal}
                        style={{ background: '#2d2d44', border: '1px solid #444', color: '#fff' }}
                    >
                        關閉
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
    
    // 費用類別輔助方法
    getExpenseCategoryColor = (category) => {
        const colors = { activity: 'danger', personnel: 'info', operation: 'success', marketing: 'warning', jp_compensation: 'primary', other: 'secondary' };
        return colors[category] || 'secondary';
    }

    getExpenseCategoryColorHex = (category) => {
        const colors = {
            activity: '#ff6b6b',
            personnel: '#4dabf7',
            operation: '#69db7c',
            marketing: '#ffd43b',
            jp_compensation: '#e14eca',
            other: '#adb5bd'
        };
        return colors[category] || '#adb5bd';
    }

    getExpenseCategoryName = (category) => {
        const names = { activity: '活動成本', personnel: '人事費用', operation: '營運費用', marketing: '行銷費用', jp_compensation: 'JP 補償', other: '其他費用' };
        return names[category] || '其他費用';
    }

    // JP toggle selector：依「JP 是否計入聯盟營收」算出 adjusted 數字
    // OFF state 時排除 category === 'jp_compensation' 的額外費用 + 重算 final_revenue。
    // 回傳：{ finalRevenue, additionalTotal, jpCompensationItems, hasJpCompensation }
    getAdjustedRevenue = (item) => {
        const { jpInUnionRevenue } = this.state;
        const additional = item.additional_expenses || { total: 0, items: [] };
        const items = additional.items || [];
        const jpCompensationItems = items.filter(it => (it.category || 'other') === 'jp_compensation');
        const hasJpCompensation = jpCompensationItems.length > 0;
        if (jpInUnionRevenue) {
            return {
                finalRevenue: item.final_revenue || 0,
                additionalTotal: additional.total || 0,
                jpCompensationItems,
                hasJpCompensation,
            };
        }
        // OFF：排除 jp_compensation
        const jpCompTotal = jpCompensationItems.reduce((s, it) => s + (it.amount || 0), 0);
        const additionalTotal = (additional.total || 0) - jpCompTotal;
        const netRevenue = (item.net_revenue !== undefined && item.net_revenue !== null)
            ? item.net_revenue
            : (((item.income || {}).total || 0) - ((item.expense || {}).total || 0));
        const finalRevenue = netRevenue - additionalTotal;
        return { finalRevenue, additionalTotal, jpCompensationItems, hasJpCompensation };
    }

    // OFF state：JP 補償項目應該不可見於「未排除」的明細區，但要強調「已排除」狀態。
    // 統一 helper：給 expense items list，回 { visibleItems, strikethroughItems, effectiveTotal }
    splitExpenseItemsForToggle = (items = []) => {
        const { jpInUnionRevenue } = this.state;
        const safe = items || [];
        if (jpInUnionRevenue) {
            return { visibleItems: safe, strikethroughItems: [], effectiveTotal: safe.reduce((s, it) => s + (it.amount || 0), 0) };
        }
        const visible = safe.filter(it => (it.category || 'other') !== 'jp_compensation');
        const strike = safe.filter(it => (it.category || 'other') === 'jp_compensation');
        const total = visible.reduce((s, it) => s + (it.amount || 0), 0);
        return { visibleItems: visible, strikethroughItems: strike, effectiveTotal: total };
    }
    
    // 載入 JP 計入聯盟營收 系統設定（doc 不存在預設 true）
    loadJpInUnionRevenueSetting = async () => {
        try {
            // ⚠️ 用 axios 不用裸 fetch —— axiosConfig 的全域 interceptor 會帶 JWT。
            // v2.32.0 全站收緊後，裸 fetch 會 401（在那之前這條 GET 是公開的）。
            const res = await axios.get('/api/tiny/system-settings/jp_in_union_revenue');
            const result = res.data;
            if (result && result.code === 1 && result.data) {
                const v = result.data.value;
                // value 是 null（doc 不存在） / undefined → 預設 true
                const jpInUnionRevenue = (v === null || v === undefined) ? true : Boolean(v);
                this.setState({ jpInUnionRevenue });
            }
        } catch (e) {
            // 讀失敗就用預設 true，不擋頁面
            console.warn('Failed to load jp_in_union_revenue setting; default true', e);
        }
    }

    // 載入後臺登記的金流費用（切換週之後的總淨營收來源）
    //
    // 只要一個 request：後端已經把四項算好回傳，前端不需要知道 item_key 怎麼組成。
    // 「payFee 等於什麼」那條規則留在後端 —— 幣商 B 上線時 payFee 自動變成
    // 兩家佣金相加，這裡一行都不用改。
    loadCashflowExpenses = async () => {
        try {
            // 只取切換週之後 —— 之前的一律讀 Sheet，撈了也用不到
            const res = await axios.get('/api/tiny/cashflow/expenses'
                + `?from=${CASHFLOW_CUTOVER_WEEK}&to=99999999-99999999`);
            if (res.data?.code === 1) {
                this.setState({
                    cashflowExpenses: res.data.data || {},
                    cashflowExpensesLoaded: true,
                });
            }
        } catch (e) {
            // ⚠️ 讀失敗**不能當成「沒填」**。四項一起變 0 會讓總淨營收被灌高，
            // 而且畫面上看不出來 —— 那比整頁掛掉更危險。所以維持
            // cashflowExpensesLoaded=false，getWeekExpenses 會整段退回讀 Sheet，
            // 也就是退回改版前的行為（那組數字已驗證與新來源完全相同）。
            console.warn('Failed to load cashflow expenses; 退回讀 Google Sheet', e);
        }
    }

    // 總淨營收的四項費用 —— **單一來源**。
    //
    // ⚠️ 這段邏輯原本在兩個地方各寫一次（表格與圖表），而且其中一處的
    // payFee 分界是寫死的字串、另一處用變數。兩份手抄遲早會漂，所以抽出來。
    getWeekExpenses = (week, r2h) => {
        if (week >= CASHFLOW_CUTOVER_WEEK && this.state.cashflowExpensesLoaded) {
            const e = (this.state.cashflowExpenses || {})[week] || {};
            return {
                personnelCost: Math.round(e.personnel_cost || 0),
                publicExpense: Math.round(e.public_expense || 0),
                creditCardMisc: Math.round(e.credit_card_misc || 0),
                payFee: Math.round(e.pay_fee || 0),
                chainFee: Math.round(e.chain_fee || 0),
                // 畫面上的「金流費用」＝ 佣金 ＋ 歸集鏈上費用。
                // 🔑 **後端算好的**，前端不自己加 —— v2.30.0 那個 26 週
                //    3,507,674 沒進總淨營收的 bug，成因就是前端手抄費用公式漏欄位。
                cashflowCost: Math.round(e.cashflow_cost || 0),
                // 這一格涵蓋的歸集日期範圍。⚠️ 認列週 ≠ 費用發生週：歷史那一次
                // 是把 2026-03 ~ 08 的歸集一次性認列在一個尚未結算的週期上
                //（逐週回填會改動已經結掉的帳）。畫面上不講清楚的話，看的人會
                // 以為那是那一週花掉的 —— 所以把區間帶到前端來標記。
                chainFeeFrom: e.chain_fee_from || null,
                chainFeeTo: e.chain_fee_to || null,
                chainFeeNote: e.chain_fee_note || null,
                otherExpense: Math.round(e.other_expense || 0),
            };
        }
        // 切換週之前：維持原本的行為，一個字都不動（那些帳已經結了）
        const hasR2H = Object.keys(r2h || {}).length > 0;
        const legacyPayFee = !hasR2H ? 0
            : week >= PAYFEE_ANCHOR_WEEK
                ? parseInt(r2h["出金手"] || 0) + parseInt(r2h["租用帳戶"] || 0)
                : parseInt(r2h["水房"] || 0) + parseInt(r2h["水房推薦人+補助"] || 0)
                  + parseInt(r2h["水房/幣商"] || 0);
        return {
            personnelCost: parseInt(r2h["人事成本\n(植威填)"] || 0),
            publicExpense: parseInt(r2h["公費報帳"] || 0),
            creditCardMisc: parseInt(r2h["植威信用卡雜項\n(植威填)"] || 0),
            // 自營幣商的鏈上成本（歸集費用）—— 切換週之前一律 0。
            // 那段時期讀的是會計的 Google Sheet，而 Sheet 上從來沒有這一項
            //（這筆成本在 v2.31.0 之前根本沒進過報表系統）。
            // ⚠️ 不要為了「補歷史」而在這裡填值：那會改動已經結掉的週。
            // 歷史歸集費用是一次性認列在一個尚未結算的週期上的，見 cashflow_sweeps。
            chainFee: 0,
            // 切換週之前 chainFee 恆為 0，所以「金流費用」就等於 payFee 本身
            cashflowCost: legacyPayFee,
            chainFeeFrom: null,
            chainFeeTo: null,
            chainFeeNote: null,
            // ⚠️ 切換週之前一律 0，**不是**讀 Sheet 的「其他雜項」。
            // 那一欄早就被算進 Sheet 的 `聯盟營利` 公式裡
            //（`=B+C-D-H-E+I-M-G-J-K-L+F-O`，全部 213 列都有 `-M`），
            // 而 `聯盟營利` 經由 calculateR2HProfit 進了 r2hNetIncome。
            // 這裡再扣一次就是重複扣。
            otherExpense: 0,
            // 費用項目不受 R2H 截止影響，但 R2H 沒有該週資料則為 0
            //
            // 金流成本換過三個時代，會計每次都換一個欄位記：
            //   ① 外部幣商（前朝）      水房 · 水房推薦人+補助      ~2025-03-02
            //   ① 延續（新團隊接手後）  **水房/幣商**              2025-03-03 ~ 2025-08-31
            //   ② 自營幣商              出金手 · 租用帳戶(租金)     2025-09-22 ~ 2026-03-08
            //   ③ 再度外包（幣商A）     租用帳戶(佣金)              2025-12-17 起
            //
            // ⚠️ `水房/幣商` 原本被漏掉：新團隊接手後改用這個欄名記同一種費用
            //（跟 ① 是同一件事，只是換了欄位），但公式沒跟著加，導致
            // **2025-03-03 ~ 2025-08-31 那 26 週、共 3,507,674 元的金流費用
            // 從來沒有進過總淨營收**。畫面上那幾週只顯示 10,000，那是
            // `水房推薦人+補助` 剩下的 5 筆，看起來像有記到帳、其實漏了九成五。
            // 也確認過**不是**被 Sheet 的 `聯盟營利` 公式扣掉的（那 26 週的公式
            // 一週都沒有 `-P`），所以是真的少扣。
            //
            // `水房/幣商` 在 ① 期與 ② ③ 期都是 0，所以無條件加進這條分支
            // 只會影響該影響的那 26 週。
            payFee: legacyPayFee,
        };
    }

    // 總淨營收的「金流費用」格。
    //
    // 這一格是**兩種東西加起來**：付給外包幣商的佣金 ＋ 自營 USDT 幣商歸集的鏈上費用
    //（v2.34.0 決定「顯示合併、資料不合併」）。而鏈上費用的認列週又不等於費用發生週 ——
    // 歷史那 27 筆（2026-03 ~ 08）是一次性認列在 20260907-20260913。只看數字的人
    // 一定會問「這週怎麼突然多了一萬多」，所以有鏈上費用的格子帶一顆 ⓘ，
    // 滑過去把「是什麼、為什麼在這週、去哪裡看細項」一次講完。
    //
    // 原本只把後端的 note 掛在原生 title 上：延遲一秒才出現、不能排版、
    // 觸控裝置看不到，等於沒說。改用 TinyTooltip。
    renderCashflowCostCell = (item) => {
        const cellCentered = { textAlign: 'center' };
        const total = numberWithCommas(Math.round(item.cashflowCost || 0));
        const chainFee = Math.round(item.chainFee || 0);
        if (!chainFee) {
            return <td style={cellCentered}>{total}</td>;
        }
        const payFee = Math.round(item.payFee || 0);
        // 認列週的起日（20260907-20260913 → 2026-09-07）。
        // 涵蓋區間的起日早於這一週 ⇒ 這是把**過去**發生的歸集補認列在本週，
        // 不是這一週花掉的錢 —— 這句一定要講，否則會被讀成本週支出暴增。
        const weekStart = /^\d{8}-\d{8}$/.test(item.date || '')
            ? `${item.date.slice(0, 4)}-${item.date.slice(4, 6)}-${item.date.slice(6, 8)}`
            : null;
        const span = item.chainFeeFrom && item.chainFeeTo
            ? `${item.chainFeeFrom} ~ ${item.chainFeeTo}` : null;
        const isBackfill = !!(span && weekStart && item.chainFeeFrom < weekStart);
        const hi = { color: '#ffd9b8', fontWeight: 600 };
        const hr = <hr style={{ margin: '7px 0', borderColor: 'rgba(255,255,255,0.15)' }} />;
        return (
            <td style={cellCentered}>
                {total}
                <TinyTooltip
                    maxWidth={420}
                    content={(
                        <>
                            <strong style={{ color: '#fd5d93' }}>金流費用 ＝ 幣商佣金 ＋ 歸集鏈上費用</strong>
                            <br />
                            幣商佣金 <span style={hi}>{numberWithCommas(payFee)}</span>
                            ＋ 歸集鏈上費用 <span style={hi}>{numberWithCommas(chainFee)}</span>
                            {hr}
                            <strong>歸集鏈上費用是什麼</strong>
                            <br />
                            自營 USDT 幣商的玩家入金只打進子錢包、出金從主錢包出，所以要定期把
                            子錢包的 USDT「歸集」到主錢包。每次歸集付給錢包服務商（GasFree）的
                            手續費就是這筆成本：首次激活的錢包收 2 USDT（激活 1 ＋ 轉帳 1），
                            之後每次轉帳收單價。幣商只給 USDT，逐筆用歸集當日匯率換成台幣。
                            {hr}
                            {isBackfill ? (
                                <>
                                    <strong style={{ color: '#fd5d93' }}>⚠️ 一次性認列，不是這一週花掉的</strong>
                                    <br />
                                    這筆涵蓋 <span style={hi}>{span}</span> 之間發生的所有歸集，
                                    全部認列在本週。歷史費用刻意不逐週回填 —— 那會改動已經結掉的帳 ——
                                    所以集中掛在認列當時還沒結算的這一週；之後每週只認列新發生的歸集。
                                </>
                            ) : (
                                <>
                                    {span
                                        ? <>涵蓋 <span style={hi}>{span}</span> 之間發生的歸集，於本週認列。</>
                                        : <>本週認列的歸集鏈上費用。</>}
                                </>
                            )}
                            {item.chainFeeNote && (
                                <>
                                    {hr}
                                    <span style={{ color: 'rgba(255,255,255,0.6)' }}>{item.chainFeeNote}</span>
                                </>
                            )}
                            {hr}
                            逐筆細項在「金流數據」頁切到 USDT 幣別看。那邊按實際發生日期分期、
                            這裡按認列週，兩頁數字對不起來是正常的。
                        </>
                    )}
                >
                    <i className="fa fa-info-circle" style={{ marginLeft: 6, color: '#fd5d93', fontSize: 13 }} />
                </TinyTooltip>
            </td>
        );
    }

    // 載入 TinyPoker 營收數據
    loadTinyRevenueData = async () => {
        this.setState({ tinyLoading: true });
        // 並行載 setting（不 await，避免擋住主資料）
        this.loadJpInUnionRevenueSetting();
        try {
            // 同上：改用 axios 才會帶 token（這支是營收資料，收緊後必須有 view_revenue）
            const response = await axios.get('/api/tiny/analytics/revenue-history?weeks=52');
            const result = response.data;
            if (result.code === 1) {
                const tinyRevenueData = result.data || [];
                const weeks = tinyRevenueData.map(item => item.week).filter(Boolean);
                this.setState({ tinyRevenueData, tinyLoading: false });
                this.loadTinyRevenueNotes(weeks);
            } else {
                this.setState({ tinyRevenueData: [], tinyLoading: false });
            }
        } catch (error) {
            console.error('Failed to load TinyPoker revenue:', error);
            this.setState({ tinyRevenueData: [], tinyLoading: false });
        }
    }

    loadTinyRevenueNotes = async (weeks = []) => {
        if (!weeks.length) {
            this.setState({ tinyNotesByWeek: {} });
            return;
        }
        try {
            const weeksParam = encodeURIComponent(weeks.join(','));
            const res = await axios.get(`/api/tiny/revenue-notes?weeks=${weeksParam}`);
            if (res.data.code === 1) {
                const grouped = res.data.data?.grouped_by_week || {};
                this.setState({ tinyNotesByWeek: grouped });
            } else {
                this.setState({ tinyNotesByWeek: {} });
            }
        } catch (error) {
            console.error('Failed to load tiny revenue notes:', error);
            this.setState({ tinyNotesByWeek: {} });
        }
    }

    openTinyDetailModal = (week, data) => {
        this.setState({
            showTinyDetailModal: true,
            tinyDetailWeek: week,
            tinyDetailData: data,
            tinyNoteTitle: '',
            tinyNoteDescription: ''
        });
    }

    closeTinyDetailModal = () => {
        this.setState({
            showTinyDetailModal: false,
            tinyDetailWeek: '',
            tinyDetailData: null,
            tinyNoteTitle: '',
            tinyNoteDescription: ''
        });
    }

    addTinyRevenueNote = async () => {
        const { tinyDetailWeek, tinyNoteTitle, tinyNoteDescription, tinySavingNote } = this.state;
        if (tinySavingNote) return;
        if (!tinyDetailWeek || !tinyNoteTitle || !tinyNoteDescription) {
            alert('請填寫標題與內容');
            return;
        }
        this.setState({ tinySavingNote: true });
        try {
            const res = await axios.post('/api/tiny/revenue-notes', {
                week: tinyDetailWeek,
                title: tinyNoteTitle,
                description: tinyNoteDescription,
                created_by: 'web'
            });
            if (res.data.code === 1) {
                const weeks = (this.state.tinyRevenueData || []).map(item => item.week).filter(Boolean);
                await this.loadTinyRevenueNotes(weeks);
                this.setState({ tinyNoteTitle: '', tinyNoteDescription: '' });
            } else {
                alert('新增備註失敗: ' + (res.data.msg || '未知錯誤'));
            }
        } catch (error) {
            console.error('Failed to add tiny revenue note:', error);
            alert('新增備註失敗: ' + (error.response?.data?.msg || error.message));
        } finally {
            this.setState({ tinySavingNote: false });
        }
    }

    deleteTinyRevenueNote = async (noteId) => {
        if (!window.confirm('確定刪除此備註？')) return;
        try {
            const res = await axios.delete(`/api/tiny/revenue-notes/${noteId}`);
            if (res.data.code === 1) {
                const weeks = (this.state.tinyRevenueData || []).map(item => item.week).filter(Boolean);
                await this.loadTinyRevenueNotes(weeks);
            } else {
                alert('刪除備註失敗: ' + (res.data.msg || '未知錯誤'));
            }
        } catch (error) {
            console.error('Failed to delete tiny revenue note:', error);
            alert('刪除備註失敗: ' + (error.response?.data?.msg || error.message));
        }
    }

    parseTinyWeekRange = (week) => {
        const m = /^(\d{4})(\d{2})(\d{2})-(\d{4})(\d{2})(\d{2})$/.exec(week || '');
        if (!m) return null;
        const [, sy, sm, sd, ey, em, ed] = m;
        return {
            startYear: sy,
            startMonth: sm,
            startDay: sd,
            endYear: ey,
            endMonth: em,
            endDay: ed
        };
    }

    formatTinyWeekCompact = (week) => {
        const parsed = this.parseTinyWeekRange(week);
        if (!parsed) return week || '-';
        return `${parsed.startMonth}/${parsed.startDay}-${parsed.endMonth}/${parsed.endDay}`;
    }

    getTinyWeekYearTag = (week) => {
        const parsed = this.parseTinyWeekRange(week);
        if (!parsed) return '';
        return parsed.startYear === parsed.endYear ? parsed.startYear : `${parsed.startYear}/${parsed.endYear}`;
    }

    renderTinyWeekLabel = (week) => {
        const compact = this.formatTinyWeekCompact(week);
        const isOpeningWeek = week === '20251213-20251221';
        return (
            <span className="tiny-week-main">
                {compact}
                {isOpeningWeek && (
                    <span
                        style={{ marginLeft: '5px', fontSize: '10px', color: '#ffc107', cursor: 'help' }}
                        title="開幕週：含提前 2 天營運，共 9 天"
                    >
                        <i className="fa fa-star"></i>
                    </span>
                )}
            </span>
        );
    }

    renderTinyWeekNoteTitles = (week) => {
        const notes = (this.state.tinyNotesByWeek || {})[week] || [];
        if (!notes.length) {
            return (
                <span className="tiny-week-note-chip tiny-week-note-empty">
                    無備註
                </span>
            );
        }
        const first = notes[0] || {};
        const firstTitle = first.title || '未命名備註';
        const remainCount = Math.max(0, notes.length - 1);

        return (
            <div className="tiny-week-notes-list">
                <div className="tiny-week-note-row" key={first._id || `${week}-summary`}>
                    <span
                        className={`tiny-week-note-chip ${remainCount > 0 ? 'has-more' : ''}`}
                        onMouseEnter={(e) => this.showTinyNoteTooltip(e, notes)}
                        onMouseMove={this.moveTinyNoteTooltip}
                        onMouseLeave={this.hideTinyNoteTooltip}
                    >
                        <span className="tiny-week-note-title">{firstTitle}</span>
                        {remainCount > 0 && <span className="tiny-week-note-more">+{remainCount}</span>}
                    </span>
                </div>
            </div>
        );
    }

    showTinyNoteTooltip = (event, notes) => {
        if (!notes || !notes.length) return;
        this.setState({
            tinyNoteTooltip: {
                visible: true,
                notes,
                x: event.clientX,
                y: event.clientY
            }
        });
    }

    moveTinyNoteTooltip = (event) => {
        this.setState(prev => ({
            tinyNoteTooltip: {
                ...prev.tinyNoteTooltip,
                x: event.clientX,
                y: event.clientY
            }
        }));
    }

    hideTinyNoteTooltip = () => {
        this.setState(prev => ({
            tinyNoteTooltip: {
                ...prev.tinyNoteTooltip,
                visible: false
            }
        }));
    }

    renderTinyNoteTooltip = () => {
        const { tinyNoteTooltip } = this.state;
        if (!tinyNoteTooltip || !tinyNoteTooltip.visible || !tinyNoteTooltip.notes || !tinyNoteTooltip.notes.length) return null;

        const maxWidth = 340;
        const viewportWidth = typeof window !== 'undefined' ? window.innerWidth : 1280;
        const viewportHeight = typeof window !== 'undefined' ? window.innerHeight : 720;
        let left = tinyNoteTooltip.x + 14;
        let top = tinyNoteTooltip.y + 16;

        if (left + maxWidth > viewportWidth - 12) {
            left = Math.max(12, tinyNoteTooltip.x - maxWidth - 12);
        }
        if (top > viewportHeight - 140) {
            top = Math.max(12, tinyNoteTooltip.y - 120);
        }

        return (
            <div className="tiny-floating-note-tooltip" style={{ left, top }}>
                <div className="tiny-floating-note-title">週備註</div>
                <div className="tiny-floating-note-text">
                    {tinyNoteTooltip.notes.map((note, idx) => (
                        <div className="tiny-floating-note-item" key={note._id || `hover-note-${idx}`}>
                            <div className="tiny-floating-note-item-head">
                                <div className="tiny-floating-note-item-title">{note.title || '未命名備註'}</div>
                                <span className="tiny-floating-note-item-idx">#{idx + 1}</span>
                            </div>
                            <div className="tiny-floating-note-item-desc">{note.description || '-'}</div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    openTinyWeekNotesModal = (week) => {
        this.setState({
            showTinyWeekNotesModal: true,
            tinyWeekNotesModalWeek: week
        });
    }

    closeTinyWeekNotesModal = () => {
        this.setState({
            showTinyWeekNotesModal: false,
            tinyWeekNotesModalWeek: ''
        });
    }

    renderTinyWeekNotesModal = () => {
        const { showTinyWeekNotesModal, tinyWeekNotesModalWeek, tinyNotesByWeek } = this.state;
        if (!showTinyWeekNotesModal) return null;
        const notes = (tinyNotesByWeek || {})[tinyWeekNotesModalWeek] || [];
        return (
            <Modal
                isOpen={showTinyWeekNotesModal}
                toggle={this.closeTinyWeekNotesModal}
                className="tiny-week-notes-modal"
                size="md"
            >
                <ModalHeader toggle={this.closeTinyWeekNotesModal} style={{ color: '#eaf2ff', borderBottom: '1px solid rgba(143, 167, 224, 0.2)' }}>
                    備註清單 - {tinyWeekNotesModalWeek}
                </ModalHeader>
                <ModalBody style={{ color: '#dce8ff' }}>
                    {notes.length === 0 ? (
                        <div className="text-center" style={{ color: '#a2b7dd' }}>本週無備註</div>
                    ) : (
                        <div className="tiny-week-notes-list-modal">
                            {notes.map((note, idx) => (
                                <div className="tiny-week-note-item" key={note._id || `${tinyWeekNotesModalWeek}-${idx}`}>
                                    <div className="tiny-week-note-item-head">
                                        <div className="tiny-week-note-item-title">{note.title || '未命名備註'}</div>
                                        <span className="tiny-week-note-item-idx">#{idx + 1}</span>
                                    </div>
                                    <div className="tiny-week-note-item-desc">{note.description || '-'}</div>
                                </div>
                            ))}
                        </div>
                    )}
                </ModalBody>
                <ModalFooter style={{ borderTop: '1px solid rgba(143, 167, 224, 0.2)' }}>
                    <Button color="secondary" size="sm" onClick={this.closeTinyWeekNotesModal}>
                        關閉
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }

    renderTinyDetailModal = () => {
        const {
            showTinyDetailModal,
            tinyDetailWeek,
            tinyDetailData,
            tinyNoteTitle,
            tinyNoteDescription,
            tinySavingNote,
            tinyNotesByWeek
        } = this.state;
        if (!showTinyDetailModal || !tinyDetailData) return null;

        const union = tinyDetailData.union_breakdown || {};
        const eco = tinyDetailData.eco_breakdown || {};
        const selfBot = tinyDetailData.self_bot_breakdown || {};   // v2.28.0 自營Bot
        const real = tinyDetailData.real_breakdown || {};
        const income = tinyDetailData.income || {};
        const expense = tinyDetailData.expense || {};
        const additional = tinyDetailData.additional_expenses || {};
        const jpNet = tinyDetailData.jp_net_breakdown || { applicable: false };
        // 同上：舊資料沒有 eco_jp_share_rate → fallback 30%（標籤跟著已存的數字走）
        const detailJpSharePct = +(((jpNet.eco_jp_share_rate ?? 0.30) * 100).toFixed(2));
        const adjustedDetail = this.getAdjustedRevenue(tinyDetailData);
        const showJpCard = this.state.jpInUnionRevenue && jpNet.applicable;
        const notes = tinyNotesByWeek?.[tinyDetailWeek] || [];

        const renderAmount = (v, isExpense = false) => {
            if (typeof v === 'string') return v;
            const value = Math.round(v || 0);
            if (isExpense) {
                // 支出欄位若為負數 → 本週反為收入，顯示 +X
                if (value < 0) return `+${numberWithCommas(Math.abs(value))}`;
                return `-${numberWithCommas(value)}`;
            }
            return numberWithCommas(value);
        };

        // 支出值為負（反收入）時改用綠色，與「支出紅色」做視覺區隔
        const colorForAmount = (v, defaultColor, isExpense = false) => {
            if (!isExpense || typeof v !== 'number') return defaultColor;
            return v < 0 ? '#2dce89' : defaultColor;
        };

        const tintedCardStyle = (rgb) => ({
            background: `linear-gradient(135deg, rgba(${rgb}, 0.20), rgba(${rgb}, 0.08))`,
            border: `1px solid rgba(${rgb}, 0.35)`,
            borderRadius: '10px',
            padding: '12px',
            boxShadow: `0 8px 20px rgba(${rgb}, 0.16)`
        });
        const blockStyle = tintedCardStyle('255, 255, 255');
        const unionCardStyle = tintedCardStyle('225, 78, 202');
        const ecoCardStyle = tintedCardStyle('255, 193, 7');
        const realCardStyle = tintedCardStyle('54, 162, 235');
        const incomeCardStyle = tintedCardStyle('75, 192, 192');
        const expenseCardStyle = tintedCardStyle('255, 146, 43');
        const additionalCardStyle = tintedCardStyle('255, 107, 107');

        const sectionTitleStyle = (color) => ({
            color,
            fontSize: '13px',
            marginBottom: '10px',
            fontWeight: 'bold',
            letterSpacing: '0.3px'
        });

        const renderLine = (label, value, color, isExpense = false) => (
            <div className="d-flex justify-content-between align-items-center mb-1">
                <small style={{ color: '#c9d3e6', fontWeight: 600 }}>{label}</small>
                <span style={{ color: colorForAmount(value, color, isExpense), fontWeight: 'bold' }}>
                    {renderAmount(value, isExpense)}
                </span>
            </div>
        );

        const renderSectionTotal = (label, value, color, isExpense = false) => (
            <div style={{ marginTop: '10px', paddingTop: '10px', borderTop: `1px solid ${color}55` }}>
                <small style={{ color: '#d4ddf0', fontWeight: 600 }}>{label}</small>
                <div style={{ fontWeight: 'bold', color: colorForAmount(value, color, isExpense), fontSize: '28px', lineHeight: 1.1 }}>
                    {renderAmount(value, isExpense)}
                </div>
            </div>
        );

        return (
            <Modal isOpen={showTinyDetailModal} toggle={this.closeTinyDetailModal} size="xl" contentClassName="bg-dark text-white">
                <ModalHeader
                    toggle={this.closeTinyDetailModal}
                    className="border-secondary"
                    style={{
                        background: 'linear-gradient(135deg, rgba(35, 45, 75, 0.95), rgba(25, 30, 55, 0.95))',
                        borderBottom: '1px solid rgba(255,255,255,0.15)'
                    }}
                >
                    <i className="fa fa-list-alt mr-2" style={{ color: '#4bc0c0' }}></i>
                    TinyPoker 詳情 - {tinyDetailWeek}
                </ModalHeader>
                <ModalBody style={{ background: '#1b1f34' }}>
                    <Row className="mb-2">
                        <Col md={showJpCard ? "6" : "12"}>
                            <div style={{ ...blockStyle, borderColor: 'rgba(47, 191, 47, 0.38)' }}>
                                <small style={{ color: '#d4ddf0', fontWeight: 600 }}>聯盟淨營收</small>
                                <div style={{ fontWeight: 'bold', color: '#2fbf2f', fontSize: '32px', lineHeight: 1.1 }}>
                                    {renderAmount(adjustedDetail.finalRevenue)}
                                </div>
                            </div>
                        </Col>
                        {showJpCard && (
                            <Col md="6">
                                <div style={{ ...blockStyle, borderColor: 'rgba(225, 78, 202, 0.38)' }}>
                                    <small style={{ color: '#d4ddf0', fontWeight: 600 }}>JP淨營收</small>
                                    {(() => {
                                        const v = Math.round(jpNet.total || 0);
                                        const color = v >= 0 ? '#e14eca' : '#ff6b6b';
                                        const sign = v >= 0 ? '+' : '-';
                                        return (
                                            <div style={{ fontWeight: 'bold', color, fontSize: '32px', lineHeight: 1.1 }}>
                                                {sign}{numberWithCommas(Math.abs(v))}
                                            </div>
                                        );
                                    })()}
                                    <div style={{ fontSize: '11px', color: '#9aa4bb', marginTop: '6px' }}>
                                        真人 JP fee {numberWithCommas(Math.round(jpNet.real_jp_fee || 0))} − payout {numberWithCommas(Math.round(jpNet.real_jp_payout || 0))} ＋ eco JP fee×{detailJpSharePct}% {numberWithCommas(Math.round(jpNet.eco_jp_fee_30 || 0))} − payout×{detailJpSharePct}% {numberWithCommas(Math.round(jpNet.eco_jp_payout_30 || 0))}
                                    </div>
                                </div>
                            </Col>
                        )}
                    </Row>

                    <Row className="mb-3">
                        <Col md="4">
                            <div style={unionCardStyle}>
                                <h6 style={sectionTitleStyle('#e14eca')}>
                                    <i className="fa fa-diamond mr-2"></i>聯盟總水細項
                                </h6>
                                {renderLine('NLH + PLO', union.ring_game, '#e14eca')}
                                {renderLine('AOF', union.aof, '#e14eca')}
                                {renderLine('SNG', union.sng, '#e14eca')}
                                {renderLine('MTT', union.mtt, '#e14eca')}
                                {renderSectionTotal('聯盟總水總計', union.total, '#f06bdd')}
                            </div>
                        </Col>
                        <Col md="4">
                            {/* v2.28.0：Bot 總水 = EcoBot + 自營Bot。真人總水 = 聯盟 − 這一格 */}
                            <div style={ecoCardStyle}>
                                <h6 style={sectionTitleStyle('#ffc107')}>
                                    <i className="fa fa-users mr-2"></i>Bot總水細項
                                </h6>
                                {renderLine('EcoBot · NLH + PLO', eco.ring_game, '#ffc107')}
                                {renderLine('EcoBot · AOF', eco.aof, '#ffc107')}
                                {renderLine('EcoBot · SNG', eco.sng, '#ffc107')}
                                {renderLine('EcoBot · MTT', eco.mtt, '#ffc107')}
                                {renderSectionTotal('EcoBot 小計', eco.total, '#ffd54a')}
                                <div style={{ height: 10 }} />
                                {renderLine('自營Bot · NLH + PLO', selfBot.ring_game, '#00d6b4')}
                                {renderLine('自營Bot · AOF', selfBot.aof, '#00d6b4')}
                                {renderLine('自營Bot · SNG', selfBot.sng, '#00d6b4')}
                                {renderLine('自營Bot · MTT', selfBot.mtt, '#00d6b4')}
                                {renderSectionTotal('自營Bot 小計', selfBot.total, '#00d6b4')}
                                {renderSectionTotal('Bot總水總計', (eco.total || 0) + (selfBot.total || 0), '#ffd54a')}
                            </div>
                        </Col>
                        <Col md="4">
                            <div style={realCardStyle}>
                                <h6 style={sectionTitleStyle('#36a2eb')}>
                                    <i className="fa fa-user mr-2"></i>真人總水細項
                                </h6>
                                {renderLine('NLH + PLO', real.ring_game, '#36a2eb')}
                                {renderLine('AOF', real.aof, '#36a2eb')}
                                {renderLine('SNG', real.sng, '#36a2eb')}
                                {renderLine('MTT', real.mtt, '#36a2eb')}
                                {renderSectionTotal('真人總水總計', real.total, '#63bfff')}
                            </div>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col md="4">
                            <div style={incomeCardStyle}>
                                <h6 style={sectionTitleStyle('#4bc0c0')}>
                                    <i className="fa fa-plus-circle mr-2"></i>收入細項
                                </h6>
                                {renderLine('真人 NLH+PLO', income.real_rg_rake, '#4bc0c0')}
                                {renderLine('真人 AOF', income.real_aof_rake, '#4bc0c0')}
                                {renderLine('真人 SNG', income.real_sng_rake, '#4bc0c0')}
                                {renderLine('真人 MTT', income.real_mtt_rake, '#4bc0c0')}
                                {renderLine('真人保險', income.real_insurance, '#4bc0c0')}
                                {renderLine('eco Cash淨值', income.eco_cash_net, '#4bc0c0')}
                                {renderLine('eco MTT淨值', income.eco_mtt_net, '#4bc0c0')}
                                {renderLine('eco 保險(莊家收)', income.eco_insurance ?? '—', '#4bc0c0')}
                                {/* v2.28.4：只留聯盟損益一條（= Rake ＋ 輸贏，含JP 不扣JP）。
                                    桌面表現 / JP 淨等拆解看「自營Bot 數據」頁。 */}
                                {renderLine('自營Bot 損益(Rake+輸贏, 含JP)', income.self_bot_net, '#00d6b4')}
                                {renderLine('自營Bot 保險(莊家收)', income.self_bot_insurance ?? '—', '#00d6b4')}
                                {renderLine('ecobot LB回收', income.ecobot_lb_recovery, '#6ee7b7')}
                                <div style={{ marginTop: '8px', marginBottom: '6px' }}>
                                    <small style={{ color: '#d4ddf0', fontWeight: 600 }}>
                                        獎池回收
                                    </small>
                                    {!income.is_biweekly_settlement && (
                                        <Badge
                                            className="ml-2"
                                            style={{
                                                fontSize: '10px',
                                                fontWeight: 700,
                                                background: 'linear-gradient(135deg, rgba(92, 104, 138, 0.62), rgba(84, 97, 126, 0.52))',
                                                border: '1px solid rgba(159, 171, 204, 0.48)',
                                                color: '#e3eafc',
                                                borderRadius: '999px',
                                                padding: '3px 9px'
                                            }}
                                        >
                                            單數周不結算
                                        </Badge>
                                    )}
                                </div>
                                {income.is_biweekly_settlement ? (
                                    <>
                                        {/* 三分類：本部 / eco(EcoBot) / 外部(Rebate+回收模式)；細項見雙週獎池頁 */}
                                        {renderLine('本部回收', income.hq_pool_return, '#4bc0c0')}
                                        {renderLine('eco獎池回收', income.eco_pool_return, '#4bc0c0')}
                                        {renderLine('外部回收獎池', (income.rebate_pool_recovery || 0) + (income.pure_share_pool_recovery || 0), '#9b51e0')}
                                        {renderLine('自營Bot 回收獎池', income.self_bot_pool_recovery, '#00d6b4')}
                                    </>
                                ) : (
                                    <>
                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                            <small style={{ color: '#c9d3e6', fontWeight: 600 }}>本部回收</small>
                                            <span style={{ color: '#9aa4bb', fontWeight: 'bold' }}>-</span>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                            <small style={{ color: '#c9d3e6', fontWeight: 600 }}>eco獎池回收</small>
                                            <span style={{ color: '#9aa4bb', fontWeight: 'bold' }}>-</span>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                            <small style={{ color: '#c9d3e6', fontWeight: 600 }}>外部回收獎池</small>
                                            <span style={{ color: '#9aa4bb', fontWeight: 'bold' }}>-</span>
                                        </div>
                                    </>
                                )}
                                {/* v2.28.4：Tax & Rebate 自成一項擺最後 —— 跟雙週獎池回收是兩回事，
                                    夾在獎池回收前面會被誤讀成獎池的一部分。 */}
                                {!!income.tr_tax && (
                                    <>
                                        <div style={{ marginTop: '8px', marginBottom: '6px' }}>
                                            <small style={{ color: '#d4ddf0', fontWeight: 600 }}>Tax / Rebate</small>
                                        </div>
                                        {renderLine('TR Tax 收入', income.tr_tax, '#727cf5')}
                                    </>
                                )}
                                {renderSectionTotal('收入總和', income.total, '#70dddd')}
                            </div>
                        </Col>
                        <Col md="4">
                            <div style={expenseCardStyle}>
                                <h6 style={sectionTitleStyle('#ff922b')}>
                                    <i className="fa fa-minus-circle mr-2"></i>支出細項
                                </h6>
                                {renderLine('元老俱樂部分潤', expense.veteran_fixed_revenue, '#ff922b', true)}
                                {renderLine('超級代理分潤', expense.super_agent_revenue, '#ff922b', true)}
                                {renderLine('直屬代理分潤', expense.direct_agent_revenue, '#ff922b', true)}
                                {renderLine('股東獎池分配', expense.shareholder_pool, '#ff922b', true)}
                                {renderLine('eco夥伴分潤', expense.partner_revenue, '#ff922b', true)}
                                {renderLine('MTT Overlay 成本', expense.mtt_overlay_cost, '#ff922b', true)}
                                {renderLine('Leaderboard 成本', expense.leaderboard_cost, '#ff922b', true)}
                                {renderLine('一般純 Rebate 支出', expense.total_rebate, '#9b51e0', true)}
                                {renderLine('TR Rebate 支出', expense.total_tr_rebate, '#727cf5', true)}
                                {renderSectionTotal('支出總和', expense.total, '#ffae5a', true)}
                            </div>
                        </Col>
                        <Col md="4">
                            <div style={additionalCardStyle}>
                                <h6 style={sectionTitleStyle('#ff6b6b')}>
                                    <i className="fa fa-edit mr-2"></i>額外費用細項
                                </h6>
                                {(additional.items || []).length === 0 ? (
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                        <small style={{ color: '#c9d3e6', fontWeight: 600 }}>尚無額外費用</small>
                                        <span style={{ color: '#9aa4bb', fontWeight: 'bold' }}>-</span>
                                    </div>
                                ) : (
                                    (additional.items || []).map((item, idx) => {
                                        const isJpComp = (item.category || 'other') === 'jp_compensation';
                                        const stripped = isJpComp && !this.state.jpInUnionRevenue;
                                        return (
                                            <div key={`additional-item-${idx}`} className="d-flex justify-content-between align-items-center mb-1">
                                                <small style={{
                                                    color: stripped ? '#6b7390' : '#c9d3e6',
                                                    fontWeight: 600,
                                                    paddingRight: '8px',
                                                    textDecoration: stripped ? 'line-through' : 'none'
                                                }}>
                                                    {item.name || item.category || `項目 ${idx + 1}`}
                                                    {stripped && <span style={{ marginLeft: 6, fontSize: 10, color: '#e14eca' }}>(已排除)</span>}
                                                </small>
                                                <span style={{
                                                    color: stripped ? '#6b7390' : ((item.amount || 0) >= 0 ? '#ff6b6b' : '#2fbf2f'),
                                                    fontWeight: 'bold',
                                                    textDecoration: stripped ? 'line-through' : 'none'
                                                }}>
                                                    {(item.amount || 0) >= 0
                                                        ? `-${numberWithCommas(Math.round(item.amount || 0))}`
                                                        : `+${numberWithCommas(Math.abs(Math.round(item.amount || 0)))}`}
                                                </span>
                                            </div>
                                        );
                                    })
                                )}
                                <div style={{ marginTop: '10px', paddingTop: '10px', borderTop: '1px solid rgba(255, 107, 107, 0.35)' }}>
                                    <small style={{ color: '#d4ddf0', fontWeight: 600 }}>額外費用總計</small>
                                    <div
                                        style={{
                                            fontWeight: 'bold',
                                            color: (adjustedDetail.additionalTotal || 0) >= 0 ? '#ff8d8d' : '#67d667',
                                            fontSize: '28px',
                                            lineHeight: 1.1
                                        }}
                                    >
                                        {(adjustedDetail.additionalTotal || 0) >= 0
                                            ? `-${numberWithCommas(Math.round(adjustedDetail.additionalTotal || 0))}`
                                            : `+${numberWithCommas(Math.abs(Math.round(adjustedDetail.additionalTotal || 0)))}`}
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <div style={{ ...blockStyle, marginBottom: '12px', borderColor: 'rgba(74, 144, 226, 0.35)' }}>
                        <h6 style={sectionTitleStyle('#9ad0ff')}>
                            <i className="fa fa-sticky-note mr-2"></i>週備註（可多筆）
                        </h6>
                        <Row className="mb-2">
                            <Col md="4">
                                <Input
                                    type="text"
                                    placeholder="備註標題（外表格會顯示）"
                                    value={tinyNoteTitle}
                                    onChange={(e) => this.setState({ tinyNoteTitle: e.target.value })}
                                    style={{ background: '#2d2d44', color: '#fff', border: '1px solid #4a5c7a' }}
                                />
                            </Col>
                            <Col md="6">
                                <Input
                                    type="text"
                                    placeholder="備註內容（只在詳情 Modal 顯示）"
                                    value={tinyNoteDescription}
                                    onChange={(e) => this.setState({ tinyNoteDescription: e.target.value })}
                                    style={{ background: '#2d2d44', color: '#fff', border: '1px solid #4a5c7a' }}
                                />
                            </Col>
                            <Col md="2">
                                <Button
                                    block
                                    onClick={this.addTinyRevenueNote}
                                    disabled={tinySavingNote}
                                    style={{
                                        background: 'linear-gradient(135deg, rgba(75, 192, 192, 0.85), rgba(56, 178, 172, 0.85))',
                                        border: '1px solid rgba(75, 192, 192, 0.6)',
                                        color: '#fff',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    {tinySavingNote ? <TinyBusy light style={{ marginRight: 4 }} /> : <i className="fa fa-plus mr-1"></i>}新增
                                </Button>
                            </Col>
                        </Row>
                        {notes.length === 0 ? (
                            <div className="text-muted">尚無備註</div>
                        ) : (
                            <Table size="sm" className="tablesorter mb-0" style={{ color: '#fff', tableLayout: 'fixed', width: '100%' }}>
                                <thead>
                                    <tr>
                                        <th style={{ color: '#aaa', width: '180px' }}>標題</th>
                                        <th style={{ color: '#aaa' }}>內容</th>
                                        <th style={{ color: '#aaa', width: '80px', textAlign: 'center' }}>操作</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {notes.map(note => (
                                        <tr key={note._id}>
                                            <td style={{ maxWidth: '180px' }}>
                                                <Badge
                                                    style={{
                                                        maxWidth: '100%',
                                                        display: 'inline-block',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        background: 'linear-gradient(135deg, rgba(126, 154, 255, 0.35), rgba(115, 135, 255, 0.24))',
                                                        border: '1px solid rgba(154, 173, 255, 0.45)',
                                                        color: '#e7eeff',
                                                        fontWeight: 700,
                                                        fontSize: '11px',
                                                        padding: '5px 10px',
                                                        borderRadius: '999px',
                                                        boxShadow: '0 2px 8px rgba(90, 110, 210, 0.25)'
                                                    }}
                                                    title={note.title}
                                                >
                                                    {note.title}
                                                </Badge>
                                            </td>
                                            <td style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{note.description}</td>
                                            <td style={{ textAlign: 'center' }}>
                                                <Button color="danger" size="sm" onClick={() => this.deleteTinyRevenueNote(note._id)}>
                                                    <i className="fa fa-trash"></i>
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        )}
                    </div>
                </ModalBody>
                <ModalFooter className="border-secondary" style={{ background: '#1b1f34' }}>
                    <Button
                        color="secondary"
                        onClick={this.closeTinyDetailModal}
                        style={{
                            background: 'rgba(140,140,160,0.25)',
                            border: '1px solid rgba(180,180,200,0.35)',
                            color: '#ddd',
                            fontWeight: 'bold'
                        }}
                    >
                        關閉
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
    
    // 生成 TinyPoker Chart 數據
    generateTinyChartData = () => {
        const { tinyRevenueData = [], timeIntervalTiny } = this.state;
        
        if (tinyRevenueData.length === 0) return null;
        
        // 手動進行時間篩選（因為 TinyPoker 使用不同的時間區間選項）
        let filteredData = [...tinyRevenueData];
        switch (timeIntervalTiny) {
            case 'last5weeks':
                filteredData = filteredData.slice(0, 5);
                break;
            case 'last10weeks':
                filteredData = filteredData.slice(0, 10);
                break;
            case 'last20weeks':
                filteredData = filteredData.slice(0, 20);
                break;
            case 'allTime':
            default:
                // 保持所有數據
                break;
        }
        
        // 按週期排序
        const chronologicalData = [...filteredData].sort((a, b) => {
            return a.week.localeCompare(b.week);
        });
        
        const labels = chronologicalData.map(item => item.week);
        
        // 生成數據集
        const datasets = [
            {
                label: '聯盟總水',
                data: chronologicalData.map(item => (item.union_breakdown?.total || 0)),
                borderColor: 'rgba(225, 78, 202, 1)',
                backgroundColor: 'rgba(225, 78, 202, 0.2)',
                tension: 0.3,
                fill: false
            },
            {
                // v2.28.0：Bot 總水 = EcoBot + 自營Bot（與表格欄位同口徑）
                label: 'Bot總水',
                data: chronologicalData.map(item =>
                    (item.eco_breakdown?.total || 0) + (item.self_bot_breakdown?.total || 0)),
                borderColor: 'rgba(255, 193, 7, 1)',
                backgroundColor: 'rgba(255, 193, 7, 0.2)',
                tension: 0.3,
                fill: false
            },
            {
                label: '自營Bot 總水',
                data: chronologicalData.map(item => (item.self_bot_breakdown?.total || 0)),
                borderColor: 'rgba(0, 214, 180, 1)',
                backgroundColor: 'rgba(0, 214, 180, 0.2)',
                borderDash: [5, 4],
                tension: 0.3,
                fill: false
            },
            {
                label: '真人總水',
                data: chronologicalData.map(item => (item.real_breakdown?.total || 0)),
                borderColor: 'rgba(54, 162, 235, 1)',
                backgroundColor: 'rgba(54, 162, 235, 0.2)',
                tension: 0.3,
                fill: false
            },
            {
                label: '收入總和',
                data: chronologicalData.map(item => (item.income?.total || 0)),
                borderColor: 'rgba(75, 192, 192, 1)',
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                tension: 0.3,
                fill: false
            },
            {
                label: '支出總和',
                data: chronologicalData.map(item => -(item.expense?.total || 0)),
                borderColor: 'rgba(255, 159, 64, 1)',
                backgroundColor: 'rgba(255, 159, 64, 0.2)',
                tension: 0.3,
                fill: false
            },
            {
                label: '聯盟淨營收',
                data: chronologicalData.map(item => (item.final_revenue || 0)),
                borderColor: 'rgba(47, 188, 47, 1)',
                backgroundColor: 'rgba(47, 188, 47, 0.2)',
                tension: 0.3,
                fill: false,
                borderWidth: 3
            }
        ];
        
        return { labels, datasets };
    }

    // Method to render the Rake2High table
    renderRake2HighTable = () => {
        const { r2h_revenue = [] } = this.props;
        const { expandedRows = {} } = this.state;
        
        // Extract common styling into constants
        const cellCentered = { textAlign: 'center' };
        const highlightCell = { ...cellCentered, backgroundColor: "#3d5c5c" };
        
        return (
            <div className="table-responsive">
                <Table className="tablesorter">
                    <thead className="text-primary">
                        <tr>
                            <th style={{ width: "200px", fontSize: '17px',...cellCentered }}>日期</th>
                            <th style={{ backgroundColor: 'rgba(153, 102, 255, 0.2)', textAlign: 'center', fontSize: '17px' }}>總營利</th> {/* 深紫色 */}
                            <th style={{ backgroundColor: 'rgba(54, 162, 235, 0.2)', textAlign: 'center', fontSize: '17px' }}>聯盟營利</th> {/* 深藍色 */}
                            <th style={{ backgroundColor: 'rgba(255, 99, 132, 0.2)', textAlign: 'center', fontSize: '17px' }}>俱樂部營利</th> {/* 深粉紅色 */}
                            <th style={{ backgroundColor: 'rgba(75, 192, 192, 0.2)', textAlign: 'center', fontSize: '17px' }}>MTT營利</th> {/* 深綠色 */}
                            <th style={{ position: 'relative', padding: '0' }}>
                                <div style={{ display: 'flex', height: '100%' }}>
                                    <div style={{ 
                                        flex: '0 0 40%', 
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: '15px 10px',
                                        fontSize: '17px',
                                        textAlign: 'center'
                                    }}>
                                        詳細資訊
                                    </div>
                                    <div style={{ 
                                        flex: '0 0 60%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        marginLeft: -10,
                                        marginBottom: 1.5
                                    }}>
                                        <Button 
                                            color="info" 
                                            size="sm" 
                                            style={{
                                                paddingLeft:2,
                                                paddingRight:2,
                                                marginBottom: '5px',
                                                width: "43%"
                                            }}
                                            onClick={() => this.expandCollapseAll(true)}
                                        >
                                            <span>全部展開 <i className="fa fa-chevron-down" aria-hidden="true"/></span>
                                        </Button>
                                        <Button 
                                            color="primary"
                                            size="sm"
                                            style={{
                                                paddingLeft:2,
                                                paddingRight:2,
                                                width: "43%"
                                            }}
                                            onClick={() => this.expandCollapseAll(false)}
                                        >
                                            <span>全部收起 <i className="fa fa-chevron-up" aria-hidden="true"/></span>
                                        </Button>
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {r2h_revenue.map((revenue, index) => {
                            const dateStr = revenue["月份/日期"];
                            const isAfterCutoff = this.isAfterR2HCutoff(dateStr);
                            
                            // R2H 截止後顯示 0
                            let outputProfitDict = isAfterCutoff 
                                ? { totalProfit: 0, unionProfit: 0, clubProfit: 0, MttProfit: 0 }
                                : this.calculateR2HProfit(revenue);
                            
                            return (
                                <React.Fragment key={`r2h-revenue-row-${index}`}>
                                    <tr>
                                        <td style={cellCentered}>{dateStr}</td>
                                        <td style={{backgroundColor: 'rgba(203, 183, 242, 0.2)',textAlign: 'center'}}>{numberWithCommas(Math.round(outputProfitDict['totalProfit']))}</td>
                                        <td style={cellCentered}>{numberWithCommas(Math.round(outputProfitDict['unionProfit']))}</td>
                                        <td style={cellCentered}>{numberWithCommas(Math.round(outputProfitDict['clubProfit']))}</td>
                                        <td style={cellCentered}>{numberWithCommas(Math.round(outputProfitDict['MttProfit']))}</td>
                                        <td style={{ position: 'relative', padding: '0' }}>
                                            <div style={{ display: 'flex', height: '100%' }}>
                                                <div style={{ 
                                                    flex: '0 0 40%', 
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    padding: '15px 10px',
                                                    textAlign: 'center'
                                                }}>
                                                    <Button 
                                                        color={expandedRows[index] ? "primary" : "info"}
                                                        size="sm" 
                                                        onClick={() => this.toggleExpandRow(index)}
                                                    >
                                                        {expandedRows[index] 
                                                            ? <span>收起 <i className="fa fa-chevron-up" aria-hidden="true"></i></span> 
                                                            : <span>展開 <i className="fa fa-chevron-down" aria-hidden="true"></i></span>
                                                        }
                                                    </Button>
                                                </div>
                                                <div className='m-1' style={{ 
                                                    flex: '0 0 60%',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'left',
                                                    paddingLeft: '10px'
                                                }}></div>
                                            </div>
                                        </td>
                                    </tr>
                                    {expandedRows[index] && (
                                        <tr>
                                            <td colSpan="7" className="p-0">
                                                <div className="p-3 bg-dark">
                                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                                        <h6 className="mb-0">Rake2High 詳細資訊 (服務費皆不包含MTT)</h6>
                                                        <Button 
                                                            color="primary"
                                                            size="sm"
                                                            onClick={() => this.toggleExpandRow(index)}
                                                        >
                                                            <span><i className="fa fa-times" aria-hidden="true"></i></span>
                                                        </Button>
                                                    </div>
                                                    <div className="d-flex flex-wrap mb-3">
                                                        {this.renderR2HDetailItem("非本部聯盟服務費+保險(不含ecobot)", parseInt(revenue["聯盟總水"])+parseInt(revenue["聯盟保險"]) || 0, "#00802b")}
                                                        {this.renderR2HDetailItem("俱樂部主交收", parseFloat(revenue["俱樂部主交付水/保險"] || 0) * -1, "#00802b")}
                                                        {this.renderR2HDetailItem("956147 服務費+保險", parseInt(revenue["俱樂部總水"])+parseInt(revenue["俱樂部保險"]) || 0, "#00802b")}
                                                        {this.renderR2HDetailItem("956147 代理交收", parseFloat(revenue["代理交付水/保險"] || 0) * -1, "#00802b")}
                                                    </div>
                                                    <div className="d-flex flex-wrap">
                                                        {this.renderR2HDetailItem("TAX", revenue["TAX"] || 0, "#00802b")}
                                                        {this.renderR2HDetailItem("BOT收入", parseFloat(revenue["BOT費用"] || 0), "#00802b")}
                                                        {this.renderR2HDetailItem("MTT FEE", parseFloat(revenue["錦標賽FEE"] || 0), "#00802b")}
                                                        {this.renderR2HDetailItem("MTT Overlay", parseFloat(revenue["Overlay"] || 0) * -1, "#00802b")}
                                                        {this.renderR2HDetailItem("OVB分潤", parseFloat(revenue["OVB分潤"] || 0) * -1 , "#00802b")}
                                                    </div>

                                                    {(revenue["備註"] || revenue["column_27"]) && (
                                                        <Col md="12" className="mb-3">
                                                            <div className="p-2 border rounded">
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <small style={{ fontSize: "14px" }}>備註</small>
                                                                    <div className="d-flex justify-content-end">
                                                                        {   
                                                                            revenue["備註"] &&
                                                                                <Badge style={{ 
                                                                                    fontSize: "12px", 
                                                                                    padding: "6px 8px",
                                                                                    backgroundColor: "#6c757d",
                                                                                    color: "white",
                                                                                    marginLeft: "10px",
                                                                                }}>
                                                                                    {revenue["備註"]}
                                                                                </Badge>
                                                                        }
                                                                        { 
                                                                            revenue["column_27"] &&
                                                                                <Badge style={{ 
                                                                                    fontSize: "12px", 
                                                                                    padding: "6px 8px",
                                                                                    backgroundColor: "#6c757d",
                                                                                    color: "white",
                                                                                    marginLeft: "10px",
                                                                                }}>
                                                                                    {revenue["column_27"]}
                                                                                </Badge>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </tbody>
                </Table>
            </div>
        );
    }

    // Modified renderMainTable method to handle Rake2High data
    renderMainTable = () => {
        // Destructure props and state for cleaner code
        const { revenue = [] } = this.props;
        const { expandedRows = {}, expandedMiscRows = {}, viewModeMain, activeProvider, showLegacyProviders } = this.state;
        
        // Extract common styling into constants
        const cellCentered = { textAlign: 'center' };
        const highlightCell = { ...cellCentered, backgroundColor: "#3d5c5c" };
        const providerAccent = {
            TinyPoker: '64,198,164',
            OtherFee: '64,198,164',
            MiscFee: '64,198,164',
            NetProfit: '64,198,164',
            OceanAtlas: '86,196,255',
            Rake2High: '255,194,86'
        };
        const reportBtnStyle = {
            borderRadius: '9px',
            border: '1px solid rgba(82,166,255,0.5)',
            background: 'linear-gradient(135deg, rgba(82,166,255,0.36), rgba(82,166,255,0.2))',
            color: '#ecf4ff',
            fontWeight: 600,
            boxShadow: '0 7px 16px rgba(82,166,255,0.24)',
            transition: 'all 0.18s ease'
        };
        const tabUiStyle = `
            .rev-main-tab-nav, .rev-seg-nav, .rev-legacy-nav, .rev-legacy-panel {
                background: rgba(23, 29, 46, 0.9);
                border: 1px solid rgba(136, 149, 182, 0.22);
                border-radius: 12px;
                padding: 4px;
                gap: 4px;
                display: inline-flex;
                flex-wrap: wrap;
                box-shadow: inset 0 1px 0 rgba(255,255,255,0.04);
            }
            .rev-main-tab-link, .rev-seg-link, .rev-legacy-link {
                border: 0 !important;
                border-radius: 9px;
                color: #aeb9d7 !important;
                font-weight: 600;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                gap: 7px;
                transition: all 0.18s ease;
                text-decoration: none !important;
                line-height: 1;
                vertical-align: middle;
            }
            .rev-main-tab-link {
                min-width: 146px;
                min-height: 48px;
                padding: 9px 14px !important;
            }
            .rev-main-tab-link i,
            .rev-seg-link i,
            .rev-legacy-link i {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                line-height: 1;
                font-size: 0.96em;
                margin-top: 0;
            }
            .rev-seg-link, .rev-legacy-link {
                padding: 7px 12px !important;
                font-size: 12px;
            }
            .rev-main-tab-link:hover, .rev-seg-link:hover, .rev-legacy-link:hover {
                color: #ecf2ff !important;
                background: rgba(var(--tab-accent, 120,170,255), 0.18);
                transform: translateY(-1px);
                box-shadow: 0 6px 14px rgba(var(--tab-accent, 120,170,255), 0.2);
            }
            .rev-main-tab-link.active, .rev-seg-link.active, .rev-legacy-link.active {
                color: #fff !important;
                background: linear-gradient(135deg, rgba(var(--tab-accent, 120,170,255), 0.5), rgba(var(--tab-accent, 120,170,255), 0.27)) !important;
                background-color: rgba(var(--tab-accent, 120,170,255), 0.45) !important;
                border-color: rgba(var(--tab-accent, 120,170,255), 0.65) !important;
                box-shadow: 0 7px 18px rgba(var(--tab-accent, 120,170,255), 0.3), inset 0 1px 0 rgba(255,255,255,0.16) !important;
                transform: translateY(-1px);
            }
            .rev-main-tab-link:hover,
            .rev-main-tab-link.active {
                transform: none;
            }
            .rev-more-zone {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                gap: 6px;
            }
            .rev-main-tab-logo {
                height: 20px;
                width: auto;
                object-fit: contain;
                display: block;
                flex: 0 0 auto;
            }
            .rev-report-link {
                color: #d6e3ff;
                font-size: 13px;
                opacity: 0.88;
            }
            .rev-report-link:hover {
                opacity: 1;
            }
        `;

        return (
            <>
                <style>{tabUiStyle}</style>

                {/* ⚠️ 這頁是 platform:"common"（OA 與 Tiny 共用），不在我先前
                    用 platform:"tiny" 圈出來的 23 頁裡 —— 但側欄對 common
                    是**永遠顯示**的，使用者看到的就是同一批頁面，所以一樣套公版。
                    🚫 底下那組 provider tab **刻意不動**：它是混合性質的導覽
                       （TinyPoker 是資料來源，金流數據 / 雜項費用 / 總淨營收 是視圖，
                       另外還有歷史聯盟），而且帶 logo 與各自的 accent。
                       要不要收進 TinyPageTabs 是獨立的判斷，待討論。 */}
                <TinyPageHeader
                    title="營收數據"
                    description="各平台的營收明細、金流費用、雜項費用與總淨營收。"
                />
                {/* ⚠️ JP 的提醒原本是主 content 最上方一條整寬 banner。
                    它每一頁、每一個 tab 都在，但**只有 TinyPoker 那個 tab 受影響**
                    （JP 淨營收欄與 TinyJP 欄是那張表的東西）—— 在金流數據 / 雜項費用 /
                    總淨營收上顯示它只是佔版面。
                    已改成一顆小徽章，接在 TinyPoker 分頁的 Table/Chart 後面
                    （見 renderTinyPokerView）。 */}
                <Row>
                    <Col xs="12">
                        <Card>
                            <div className="d-flex flex-wrap justify-content-between align-items-start mt-3 mb-0 mx-3" style={{ gap: '10px' }}>
                                <div className="d-flex flex-wrap align-items-center mb-2" style={{ gap: '8px' }}>
                                <Nav pills className="rev-main-tab-nav mr-1">
                                    <NavItem style={{ "--tab-accent": providerAccent.TinyPoker }}>
                                        <NavLink href="#" className={classNames("rev-main-tab-link", { active: activeProvider === 'TinyPoker' })} onClick={(e) => { e.preventDefault(); this.toggleProvider('TinyPoker'); }}>
                                            <img src={tiny_logo} alt="Tiny" className="rev-main-tab-logo" style={{ filter: activeProvider === 'TinyPoker' ? 'brightness(1)' : 'brightness(0.82)' }} />
                                            TinyPoker
                                        </NavLink>
                                    </NavItem>
                                    <NavItem style={{ "--tab-accent": providerAccent.OtherFee }}>
                                        <NavLink href="#" className={classNames("rev-main-tab-link", { active: activeProvider === 'OtherFee' })} onClick={(e) => { e.preventDefault(); this.toggleProvider('OtherFee'); }}>
                                            <i className="fa fa-exchange"></i> 金流數據
                                        </NavLink>
                                    </NavItem>
                                    <NavItem style={{ "--tab-accent": providerAccent.MiscFee }}>
                                        <NavLink href="#" className={classNames("rev-main-tab-link", { active: activeProvider === 'MiscFee' })} onClick={(e) => { e.preventDefault(); this.toggleProvider('MiscFee'); }}>
                                            <i className="fa fa-list-ul"></i> 雜項費用
                                        </NavLink>
                                    </NavItem>
                                    <NavItem style={{ "--tab-accent": providerAccent.NetProfit }}>
                                        <NavLink href="#" className={classNames("rev-main-tab-link", { active: activeProvider === 'NetProfit' })} onClick={(e) => { e.preventDefault(); this.toggleProvider('NetProfit'); }}>
                                            <i className="fa fa-line-chart"></i> 總淨營收
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                                {activeProvider === 'Rake2High' && (
                                    <div className="mr-2 mb-2 d-flex align-items-center">
                                        <div className="mr-2 rev-report-link">
                                            <i className="fa fa-refresh mr-1"></i> 每五分鐘從 R2H 雲端報表刷新
                                        </div>
                                        <Button 
                                            color="info"
                                            size="sm"
                                            onClick={() => window.open('https://docs.google.com/spreadsheets/d/1ilxlmLoxuRPJciOCe-jukgrd3Y5NVxHxEnhFaEL-A38/edit?gid=1137411345#gid=1137411345', '_blank')}
                                            style={reportBtnStyle}
                                        >
                                            <i className="fa fa-table mr-1"></i> 前往報表
                                        </Button>
                                    </div>
                                )}
                                {/* ⚠️ 雜項費用頁**刻意不放**「前往報表」按鈕。
                                    這一頁是人事成本 / 信用卡雜項 / 公費報帳的**新填寫入口**，
                                    而那顆按鈕會直接開啟營利表的「明細表格」分頁 ——
                                    同樣那三個欄位的**舊入口**。在新入口旁邊放一扇通往舊入口的門，
                                    會計很自然就填錯地方。
                                    Sheet 本身沒有退休（切換週 2026-04-06 之前仍是唯一真相，
                                    要修歷史還是直接改 Sheet），R2H 那個歷史 tab 的按鈕也留著。 */}
                                </div>
                                <div className="rev-more-zone mb-2">
                                    <Nav pills className="rev-legacy-nav" style={{ "--tab-accent": "145,124,255" }}>
                                        <NavItem>
                                            <NavLink href="#" className={classNames("rev-legacy-link", { active: showLegacyProviders })} onClick={(e) => { e.preventDefault(); this.setState(prev => ({ showLegacyProviders: !prev.showLegacyProviders })); }}>
                                                <i className={`fa ${showLegacyProviders ? 'fa-angle-up' : 'fa-ellipsis-h'}`}></i>
                                                更多歷史聯盟
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                    {showLegacyProviders && (
                                        <Nav pills className="rev-legacy-panel">
                                            <NavItem style={{ "--tab-accent": providerAccent.OceanAtlas }}>
                                                <NavLink href="#" className={classNames("rev-legacy-link", { active: activeProvider === 'OceanAtlas' })} onClick={(e) => { e.preventDefault(); this.toggleProvider('OceanAtlas'); }}>
                                                    <img src={oa_logo} alt="OceanAtlas Logo" style={{ height: '14px', width: 'auto' }} />
                                                    OA
                                                </NavLink>
                                            </NavItem>
                                            <NavItem style={{ "--tab-accent": providerAccent.Rake2High }}>
                                                <NavLink href="#" className={classNames("rev-legacy-link", { active: activeProvider === 'Rake2High' })} onClick={(e) => { e.preventDefault(); this.toggleProvider('Rake2High'); }}>
                                                    <img src={r2h_logo} alt="Rake2High Logo" style={{ height: '14px', width: 'auto' }} />
                                                    R2H
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                    )}
                                </div>
                            </div>
                                
                            
                            {/* TinyPoker 不需要這塊。
                                金流數據（非歷史檢視）與雜項費用有自己的控制列，
                                這個 CardHeader 對它們是空的 —— 整塊收掉，
                                不然主 tab 與子 tab 之間會留一段空白。 */}
                            {activeProvider !== 'TinyPoker'
                                && !(activeProvider === 'OtherFee' && this.state.cashflowView !== 'legacy')
                                && activeProvider !== 'MiscFee' && (
                            <CardHeader>
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center">
                                        <CardTitle tag="h4" className="mr-3 mb-0">Main Revenue Table</CardTitle>
                                        
                                        {/* View mode toggle - left aligned
                                            金流數據的「目前」檢視自己有 表格/總覽 切換，
                                            不用共用的 Table/Chart（那頁之後不會有 chart 按鈕）*/}
                                        <Nav pills className="rev-seg-nav" style={{ "--tab-accent": "116,132,255",
                                            display: ((activeProvider === 'OtherFee' && this.state.cashflowView !== 'legacy')
                                                || activeProvider === 'MiscFee') ? 'none' : undefined }}>
                                            <NavItem>
                                                <NavLink href="#" className={classNames("rev-seg-link", { active: viewModeMain === 'table' })} onClick={(e) => { e.preventDefault(); this.toggleViewMode('Main', 'table'); }}>
                                                    <i className="fa fa-th-large mr-1"></i> Table
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink href="#" className={classNames("rev-seg-link", { active: viewModeMain === 'chart' })} onClick={(e) => { e.preventDefault(); this.toggleViewMode('Main', 'chart'); }}>
                                                    <i className="fa fa-area-chart mr-1"></i> Chart
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                        
                                        {activeProvider === 'OtherFee' && this.state.cashflowView === 'legacy' && viewModeMain === 'table' && (
                                            <div className="d-flex align-items-center ml-3">
                                                {/* <div style={{ fontSize: '12px', color: '#aaa' }}>
                                                    <i className="fa fa-info-circle mr-1"></i> *備註：20250331-20250406此週以前之水房手續費為總台幣入金*2.3%，20250407-20250413以後調整為2.8%
                                                </div> */}
                                                <Nav pills className="rev-seg-nav ml-2" style={{ "--tab-accent": "255,194,86" }}>
                                                    <NavItem>
                                                        <NavLink href="#" className={classNames("rev-seg-link", { active: this.state.showFullChipDetails })} onClick={(e) => { e.preventDefault(); this.toggleChipDetailsMode(); }}>
                                                            <i className="fa fa-exchange mr-1"></i>
                                                            {this.state.showFullChipDetails ? "顯示NTD出入金數據" : "顯示USDT出入金數據"}
                                                        </NavLink>
                                                    </NavItem>
                                                </Nav>
                                            </div>
                                        )}
                                    </div>
                                    
                                    {/* Time interval selector - always right aligned, only visible in chart mode */}
                                    {viewModeMain === 'chart' && activeProvider !== 'MiscFee' && !(activeProvider === 'OtherFee' && this.state.cashflowView !== 'legacy') && (
                                        <Nav pills className="rev-seg-nav" style={{ "--tab-accent": "90,170,255" }}>
                                            <NavItem><NavLink href="#" className={classNames("rev-seg-link", { active: this.state.timeIntervalMain === 'allTime' })} onClick={(e) => { e.preventDefault(); this.setTimeInterval('allTime', 'Main'); }}>全部時間</NavLink></NavItem>
                                            <NavItem><NavLink href="#" className={classNames("rev-seg-link", { active: this.state.timeIntervalMain === 'recent52weeks' })} onClick={(e) => { e.preventDefault(); this.setTimeInterval('recent52weeks', 'Main'); }}>近一年</NavLink></NavItem>
                                            <NavItem><NavLink href="#" className={classNames("rev-seg-link", { active: this.state.timeIntervalMain === 'recent26weeks' })} onClick={(e) => { e.preventDefault(); this.setTimeInterval('recent26weeks', 'Main'); }}>近半年</NavLink></NavItem>
                                            <NavItem><NavLink href="#" className={classNames("rev-seg-link", { active: this.state.timeIntervalMain === 'recent12weeks' })} onClick={(e) => { e.preventDefault(); this.setTimeInterval('recent12weeks', 'Main'); }}>近一季</NavLink></NavItem>
                                            <NavItem><NavLink href="#" className={classNames("rev-seg-link", { active: this.state.timeIntervalMain === 'recent4weeks' })} onClick={(e) => { e.preventDefault(); this.setTimeInterval('recent4weeks', 'Main'); }}>近四周</NavLink></NavItem>
                                        </Nav>
                                    )}
                                </div>
                            </CardHeader>
                            )}
                            <CardBody>
                                {activeProvider === 'Rake2High' ? (
                                    // Render Rake2High content
                                    typeof this.props.r2h_revenue!=="undefined"?
                                    (
                                        viewModeMain === 'chart' ? (
                                            this.renderRake2HighChart()
                                        ) : (
                                            this.renderRake2HighTable()
                                        )
                                    )
                                    :
                                    (
                                        <TinyLoading text="載入資料" variant="block" />
                                    )
                                ) : activeProvider === 'OtherFee' ? (
                                    // v2.29.0 金流數據。舊的 OA / R2H 內容一行都沒刪，
                                    // 只是移到「歷史金流」切換後面 —— 它的資料源
                                    // cm_detail.json 停在 2026-01-11 且沒有任何程式在寫。
                                    <TinyCashflow
                                        view={this.state.cashflowView}
                                        onViewChange={(v) => this.setState({ cashflowView: v })}
                                        renderLegacy={() => (
                                            typeof this.props.r2h_revenue !== "undefined"
                                                ? (viewModeMain === 'chart'
                                                    ? this.renderChartView('OtherFee', this.generateOtherFeeChartData)
                                                    : this.renderOtherFeeTable())
                                                : <TinyLoading text="載入資料" variant="block" />
                                        )}
                                    />
                                ) : activeProvider === 'MiscFee' ? (
                                    // v2.29.0：改成後台直接填寫（原本是唯讀顯示會計 Sheet 爬回來的值）。
                                    // v2.37.0：週期清單改跟總淨營收同一份（見 getMiscFeeWeeks），
                                    //          所以要等 Tiny 營收載完才知道最新週是哪一週。
                                    this.state.tinyLoading
                                        ? <TinyLoading text="載入資料" variant="block" />
                                        : <TinyMiscFee weeks={this.getMiscFeeWeeks()} />
                                ) : activeProvider === 'MiscFeeLegacy' ? (
                                    typeof this.props.r2h_revenue!=="undefined"?
                                    (
                                        viewModeMain === 'chart' ? (
                                            this.renderChartView('MiscFee', this.generateMiscFeeChartData)
                                        ) : (
                                            this.renderMiscFeeTable()
                                        )
                                    )
                                    :
                                    (
                                        <TinyLoading text="載入資料" variant="block" />
                                    )
                                ) : activeProvider === 'TinyPoker' ? (
                                    // Render TinyPoker content
                                    this.renderTinyPokerContent()
                                ) : activeProvider === 'NetProfit' ? (
                                    // Render NetProfit content
                                    viewModeMain === 'chart' ? (
                                        this.renderChartView('NetProfit', this.generateNetProfitChartData)
                                    ) : (
                                        this.renderNetProfitTable()
                                    )
                                ) : viewModeMain === 'chart' ? (
                                    this.renderChartView('Main', this.generateMainChartData)
                                ) : (
                                    <div className="table-responsive">
                                            <Table className="tablesorter">
                                            <thead className="text-primary">
                                                <tr>
                                                    {/* <th style={{ width: "200px", ...cellCentered }}>日期</th>
                                                    <th style={highlightCell}>總淨收入</th>
                                                    <th style={cellCentered}>本部俱樂部收入</th>
                                                    <th style={cellCentered}>本部聯盟收入</th>
                                                    <th style={cellCentered}>超級聯盟收入</th> */}
                                                    <th style={{ width: "200px", textAlign: 'center', fontSize: '18px' }}>日期</th>
                                                    <th style={{ width: "180px", backgroundColor: 'rgba(75, 192, 192, 0.2)', textAlign: 'center', fontSize: '17px' }}>總淨收入</th>
                                                    <th style={{ width: "180px", backgroundColor: 'rgba(54, 162, 235, 0.2)', textAlign: 'center', fontSize: '17px' }}>本部俱樂部收入</th>
                                                    <th style={{ width: "180px", backgroundColor: 'rgba(255, 99, 132, 0.2)', textAlign: 'center', fontSize: '17px' }}>本部聯盟收入</th>
                                                    <th style={{ width: "180px", backgroundColor: 'rgba(153, 102, 255, 0.2)', textAlign: 'center', fontSize: '17px', position: 'relative' }}>
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '5px' }}>
                                                            <span style={{ marginBottom: '5px' }}>超級聯盟收入</span>
                                                            <div style={{ display: 'flex', gap: '3px' }}>
                                                                <Button 
                                                                    color="info" 
                                                                    size="sm"
                                                                    onClick={() => this.expandCollapseAll(true)}
                                                                    style={{
                                                                        padding: '2px 6px',
                                                                        fontSize: '9px',
                                                                        minWidth: '45px',
                                                                        height: '20px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '2px'
                                                                    }}
                                                                    title="展開所有超級聯盟收入詳細"
                                                                >
                                                                    <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                                                    <span>全展開</span>
                                                                </Button>
                                                                <Button 
                                                                    color="primary"
                                                                    size="sm"
                                                                    onClick={() => this.expandCollapseAll(false)}
                                                                    style={{
                                                                        padding: '2px 6px',
                                                                        fontSize: '9px',
                                                                        minWidth: '45px',
                                                                        height: '20px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '2px'
                                                                    }}
                                                                    title="收起所有超級聯盟收入詳細"
                                                                >
                                                                    <i className="fa fa-chevron-up" aria-hidden="true"></i>
                                                                    <span>全收起</span>
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </th>
                                                    <th style={{ width: "180px", backgroundColor: 'rgba(255, 206, 86, 0.2)', textAlign: 'center', fontSize: '17px', position: 'relative' }}>
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '5px' }}>
                                                            <span style={{ marginBottom: '5px' }}>超級聯盟雜項</span>
                                                            <div style={{ display: 'flex', gap: '3px', flexWrap: 'wrap', justifyContent: 'center' }}>
                                                                <Button 
                                                                    color="info" 
                                                                    size="sm"
                                                                    onClick={() => this.expandCollapseMiscAll(true)}
                                                                    style={{
                                                                        padding: '2px 6px',
                                                                        fontSize: '9px',
                                                                        minWidth: '45px',
                                                                        height: '20px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '2px'
                                                                    }}
                                                                    title="展開所有超級聯盟雜項詳細"
                                                                >
                                                                    <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                                                    <span>全展開</span>
                                                                </Button>
                                                                <Button 
                                                                    color="primary"
                                                                    size="sm"
                                                                    onClick={() => this.expandCollapseMiscAll(false)}
                                                                    style={{
                                                                        padding: '2px 6px',
                                                                        fontSize: '9px',
                                                                        minWidth: '45px',
                                                                        height: '20px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '2px'
                                                                    }}
                                                                    title="收起所有超級聯盟雜項詳細"
                                                                >
                                                                    <i className="fa fa-chevron-up" aria-hidden="true"></i>
                                                                    <span>全收起</span>
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </th>
                                                    <th style={{ textAlign: 'center', fontSize: '17px', width: '200px' }}>備註</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {revenue.map((revenue, index) => {
                                                    // Calculate super union net income with fallback
                                                    const superUnionNetIncome = typeof revenue.superUnionNetIncomeMinusCost !== "undefined" 
                                                        ? revenue.superUnionNetIncomeMinusCost 
                                                        : revenue.superUnionNetIncome;
                                                        
                                                    // Calculate total income
                                                    const totalIncome = revenue.homeUnionIncome + revenue.homeClubIncome + superUnionNetIncome;
                                                    
                                                    // Calculate super union core income (service fee + insurance + delivery)
                                                    const superUnionCoreIncome = (revenue.fee || 0) + (revenue.evCashout || 0) - (revenue.realFeeAndEv || 0);
                                                    
                                                    // Calculate super union miscellaneous (remaining items from expanded details)
                                                    // Note: Support items should be negative (expenses), income items should be positive
                                                    const miscSubtotal = (revenue.MTT || 0) + (revenue.Jackpot || 0) + (revenue.SpinUp || 0);
                                                    const routineActivityExpenses = -((revenue.chipRain || 0) + (revenue.rgRank || 0) + (revenue.cusRGRank || 0));
                                                    const largeActivityExpenses = -(revenue.ActivitySum || 0);
                                                    const additionalExchanges = -(typeof revenue.APsum !== "undefined" && typeof revenue.totalCost !== "undefined" ? 
                                                                               (revenue.APsum + revenue.totalCost) : 
                                                                               (typeof revenue.APsum !== "undefined" ? revenue.APsum : 
                                                                                   (typeof revenue.totalCost !== "undefined" ? revenue.totalCost : 0)));
                                                    
                                                    const superUnionMisc = -(revenue.fishPokerFee || 0) + 
                                                                           miscSubtotal + 
                                                                           routineActivityExpenses + 
                                                                           largeActivityExpenses + 
                                                                           additionalExchanges;
                                                    
                                                    return (
                                                        <React.Fragment key={`revenue-row-${index}`}>
                                                            <tr>
                                                                <td style={cellCentered}>{revenue.duration}</td>
                                                                <td style={{...highlightCell, width: '180px'}}>{numberWithCommas(Math.round(totalIncome))}</td>
                                                                <td style={{...cellCentered, width: '180px'}}>{numberWithCommas(Math.round(revenue.homeClubIncome))}</td>
                                                                <td style={{...cellCentered, width: '180px'}}>{numberWithCommas(Math.round(revenue.homeUnionIncome))}</td>
                                                                <td style={{...cellCentered, width: '180px'}}>
                                                                    <div className="d-flex align-items-center justify-content-center">
                                                                        <span style={{ marginRight: '8px' }}>{numberWithCommas(Math.round(superUnionCoreIncome))}</span>
                                                                        <Button 
                                                                            color={expandedRows[index] ? "primary" : "info"}
                                                                            size="sm" 
                                                                            onClick={() => this.toggleExpandRow(index)}
                                                                            style={{
                                                                                padding: '2px 6px',
                                                                                fontSize: '10px',
                                                                                minWidth: '20px',
                                                                                height: '20px'
                                                                            }}
                                                                        >
                                                                            <i className={`fa ${expandedRows[index] ? 'fa-chevron-up' : 'fa-chevron-down'}`} aria-hidden="true"></i>
                                                                        </Button>
                                                                    </div>
                                                                </td>
                                                                <td style={{...cellCentered, width: '180px'}}>
                                                                    <div className="d-flex align-items-center justify-content-center">
                                                                        <span style={{ marginRight: '8px' }}>{numberWithCommas(Math.round(superUnionMisc))}</span>
                                                                        <Button 
                                                                            color={expandedMiscRows[index] ? "primary" : "info"}
                                                                            size="sm" 
                                                                            onClick={() => this.toggleExpandMiscRow(index)}
                                                                            style={{
                                                                                padding: '2px 6px',
                                                                                fontSize: '10px',
                                                                                minWidth: '20px',
                                                                                height: '20px'
                                                                            }}
                                                                        >
                                                                            <i className={`fa ${expandedMiscRows[index] ? 'fa-chevron-up' : 'fa-chevron-down'}`} aria-hidden="true"></i>
                                                                        </Button>
                                                                    </div>
                                                                </td>
                                                                <td style={{ ...cellCentered, width: '200px', maxWidth: '200px' }}>
                                                                    <div className="d-flex justify-content-center">
                                                                        {revenue.noteContent ? (
                                                                            <div className="d-flex align-items-center justify-content-center" style={{ width: '100%' }}>
                                                                                <Badge  
                                                                                    style={{ 
                                                                                        overflow: 'hidden',
                                                                                        textOverflow: 'ellipsis',
                                                                                        fontSize: "12px", 
                                                                                        padding: "9px 8px", 
                                                                                        marginRight: "10px",
                                                                                        backgroundColor: "#cc5200",
                                                                                        color: "#e6e6e6"
                                                                                }}> {revenue.noteContent} </Badge>
                                                                                <Button 
                                                                                    color="info" 
                                                                                    size="sm" 
                                                                                    onClick={() => this.openNoteModal(revenue._id, revenue.noteContent || "")}
                                                                                    style={{
                                                                                        padding:"3px 8px",
                                                                                        width: "30px",
                                                                                        height: "30px",
                                                                                        display: "flex",
                                                                                        justifyContent: "center",
                                                                                        alignItems: "center",
                                                                                        minWidth: "30px",
                                                                                        flexShrink: 0
                                                                                    }}
                                                                                >
                                                                                    <i className="fa fa-eye" aria-hidden="true"></i>
                                                                                </Button>
                                                                            </div>
                                                                        ) : (
                                                                            <Button 
                                                                                color="info" 
                                                                                size="sm" 
                                                                                onClick={() => this.openNoteModal(revenue._id, revenue.noteContent || "")}
                                                                                style={{
                                                                                    padding:"3px 8px",
                                                                                    width: "30px",
                                                                                    height: "30px",
                                                                                    display: "flex",
                                                                                    justifyContent: "center",
                                                                                    alignItems: "center",
                                                                                    minWidth: "30px",
                                                                                    flexShrink: 0
                                                                                }}
                                                                            >
                                                                                <i className="fa fa-plus" aria-hidden="true"></i>
                                                                            </Button>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            {expandedRows[index] && (
                                                                <tr>
                                                                    <td colSpan="7" className="p-0">
                                                                        <div className="p-3 bg-dark">
                                                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                                                <h6 className="mb-0">超盟收入詳細資訊</h6>
                                                                                <Button 
                                                                                    color="primary"
                                                                                    size="sm"
                                                                                    onClick={() => this.toggleExpandRow(index)}
                                                                                >
                                                                                    <span><i className="fa fa-times" aria-hidden="true"></i></span>
                                                                                </Button>
                                                                            </div>
                                                                            <Row>
                                                                                <Col lg="3" md="6" className="mb-3">
                                                                                    <div className="p-2 border rounded">
                                                                                        <div className="d-flex justify-content-between align-items-center">
                                                                                            <small style={{ fontSize: "14px" }}>總服務費+總保險 (不含MTT)</small>
                                                                                            {this.renderBadge((revenue.fee || 0) + (revenue.evCashout || 0), "#00802b", false)}
                                                                                        </div>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col lg="3" md="6" className="mb-3">
                                                                                    <div className="p-2 border rounded">
                                                                                        <div className="d-flex justify-content-between align-items-center">
                                                                                            <small style={{ fontSize: "14px" }}>總交付</small>
                                                                                            {this.renderBadge(revenue.realFeeAndEv, "#00802b", true)}
                                                                                        </div>
                                                                                    </div>
                                                                                </Col>

                                                                            </Row>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                            {expandedMiscRows[index] && (
                                                                <tr>
                                                                    <td colSpan="7" className="p-0">
                                                                        <div className="p-3 bg-dark">
                                                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                                                <h6 className="mb-0">超盟雜項詳細資訊</h6>
                                                                                <Button 
                                                                                    color="primary"
                                                                                    size="sm"
                                                                                    onClick={() => this.toggleExpandMiscRow(index)}
                                                                                >
                                                                                    <span><i className="fa fa-times" aria-hidden="true"></i></span>
                                                                                </Button>
                                                                            </div>
                                                                            <Row>
                                                                                <Col lg="3" md="6" className="mb-3">
                                                                                    <div className="p-2 border rounded">
                                                                                        <div className="d-flex justify-content-between align-items-center">
                                                                                            <small style={{ fontSize: "14px" }}>FishPoker服務費</small>
                                                                                            {this.renderBadge(revenue.fishPokerFee, "#00802b", true)}
                                                                                        </div>
                                                                                    </div>
                                                                                </Col>
                                                                                
                                                                                <Col lg="3" md="6" className="mb-3">
                                                                                    <div className="p-2 border rounded">
                                                                                        <div className="d-flex justify-content-between align-items-center">
                                                                                            <small style={{ fontSize: "14px" }}>雜項</small>
                                                                                            <div>
                                                                                                <Button 
                                                                                                    color='info' 
                                                                                                    size='sm' 
                                                                                                    onClick={() => {
                                                                                                        this.setState({
                                                                                                            showMiscDetails: true,
                                                                                                            miscDetails: {
                                                                                                                MTT: revenue.MTT || 0,
                                                                                                                Jackpot: revenue.Jackpot || 0,
                                                                                                                SpinUp: revenue.SpinUp || 0
                                                                                                            }
                                                                                                        });
                                                                                                    }}
                                                                                                    style={{padding:"3px 8px"}}
                                                                                                >
                                                                                                    <i className="fa fa-eye" aria-hidden="true"></i>
                                                                                                </Button>
                                                                                                {this.renderBadge(
                                                                                                    (revenue.MTT || 0) + 
                                                                                                    (revenue.Jackpot || 0) + 
                                                                                                    (revenue.SpinUp || 0),
                                                                                                    "#00802b", 
                                                                                                    false
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </Col>
                                                                                
                                                                                <Col lg="3" md="6" className="mb-3">
                                                                                    <div className="p-2 border rounded">
                                                                                        <div className="d-flex justify-content-between align-items-center">
                                                                                            <small style={{ fontSize: "14px" }}>例行活動支出</small>
                                                                                            {this.renderBadge(revenue.chipRain + revenue.rgRank + revenue.cusRGRank, "#00802b", true)}
                                                                                        </div>
                                                                                    </div>
                                                                                </Col>
                                                                                
                                                                                <Col lg="3" md="6" className="mb-3">
                                                                                    <div className="p-2 border rounded">
                                                                                        <div className="d-flex justify-content-between align-items-center">
                                                                                            <small style={{ fontSize: "14px" }}>大型活動支出</small>
                                                                                            <div>
                                                                                                {typeof revenue.APsum !== 'undefined' ? (
                                                                                                    <>
                                                                                                        <Button 
                                                                                                            color='info' 
                                                                                                            size='sm' 
                                                                                                            onClick={() => this.openAPlistTable(revenue.Activitylist)}
                                                                                                            style={{padding:"3px 8px"}}
                                                                                                        >
                                                                                                            <i className="fa fa-eye" aria-hidden="true"></i>
                                                                                                        </Button>
                                                                                                        {this.renderBadge(revenue.ActivitySum,"#00802b", true)}
                                                                                                    </>
                                                                                                ) : (
                                                                                                    <Badge color="secondary" style={{ 
                                                                                                        fontSize: "12px", 
                                                                                                        padding: "6px 8px", 
                                                                                                        color: "#e6e6e6", 
                                                                                                        backgroundColor: "#00802b" 
                                                                                                    }}>N/A</Badge>
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </Col>
                                                                            </Row>
                                                                            <Row>
                                                                                <Col lg="3" md="6" className="mb-3">
                                                                                    <div className="p-2 border rounded">
                                                                                        <div className="d-flex justify-content-between align-items-center">
                                                                                            <small style={{ fontSize: "14px" }}>額外交收&支出</small>
                                                                                            <div>
                                                                                                <Button 
                                                                                                    color='info' 
                                                                                                    size='sm' 
                                                                                                    onClick={() => this.openCombinedLists(revenue)}
                                                                                                    style={{padding:"3px 8px"}}
                                                                                                >
                                                                                                    <i className="fa fa-eye" aria-hidden="true"></i>
                                                                                                </Button>
                                                                                                <Badge style={{ 
                                                                                                    fontSize: "12px", 
                                                                                                    padding: "6px 8px", 
                                                                                                    marginLeft: "10px",
                                                                                                    backgroundColor: typeof revenue.APsum !== "undefined" && typeof revenue.totalCost !== "undefined" ? 
                                                                                                        ((revenue.APsum + revenue.totalCost) >= 0 ? "#cc0000" : "#00802b") : 
                                                                                                        (typeof revenue.APsum !== "undefined" ? 
                                                                                                            (revenue.APsum >= 0 ? "#cc0000" : "#00802b") : 
                                                                                                            (typeof revenue.totalCost !== "undefined" ? 
                                                                                                                (revenue.totalCost >= 0 ? "#cc0000" : "#00802b") : 
                                                                                                                "#00802b")),
                                                                                                    color: "#e6e6e6"
                                                                                                }}>
                                                                                                    {typeof revenue.APsum !== "undefined" && typeof revenue.totalCost !== "undefined" ? 
                                                                                                        ((revenue.APsum + revenue.totalCost) >= 0 ? 
                                                                                                            numberWithCommas(Math.round(revenue.APsum + revenue.totalCost) * -1) : 
                                                                                                            numberWithCommas(Math.abs(Math.round(revenue.APsum + revenue.totalCost)))) : 
                                                                                                        (typeof revenue.APsum !== "undefined" ? 
                                                                                                            (revenue.APsum >= 0 ? 
                                                                                                                numberWithCommas(Math.round(revenue.APsum) * -1) : 
                                                                                                                numberWithCommas(Math.abs(Math.round(revenue.APsum)))) : 
                                                                                                            (typeof revenue.totalCost !== "undefined" ? 
                                                                                                                (revenue.totalCost >= 0 ? 
                                                                                                                    numberWithCommas(Math.round(revenue.totalCost) * -1) : 
                                                                                                                    numberWithCommas(Math.abs(Math.round(revenue.totalCost)))) : 
                                                                                                                0))}
                                                                                                </Badge>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col lg="3" md="6" className="mb-3">
                                                                                    <div className="p-2 border rounded">
                                                                                        <div className="d-flex justify-content-between align-items-center">
                                                                                            <small style={{ fontSize: "14px" }}>代理線生態審核</small>
                                                                                            <Button 
                                                                                                color='warning' 
                                                                                                size='sm' 
                                                                                                onClick={() => this.openAgentTaxEventModal(revenue.duration)}
                                                                                                style={{padding:"5px 12px", fontSize: "11px"}}
                                                                                                title="查看代理線生態審核名單"
                                                                                            >
                                                                                                <i className="fa fa-list-alt mr-1" aria-hidden="true"></i>
                                                                                                查看名單
                                                                                            </Button>
                                                                                        </div>
                                                                                    </div>
                                                                                </Col>
                                                                            </Row>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </React.Fragment>
                                                    );
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </>
        );
    }

    renderFlashLevelTable = () => {
        let headers = this.props.flash_level_col || []  ;
        let tableData = this.props.flash_level_data || [];
        let attribute = 'fee'
        if (this.state.flashDetailField === 'fee') {
            attribute = 'fee'
        } else if (this.state.flashDetailField === 'players') {
            attribute = 'players'
        } else if (this.state.flashDetailField === 'hands') {
            attribute = 'hands'
        } 
        
        // Calculate total for each row to compute percentages
        const dataWithTotals = tableData.map(rowData => {
            const total = headers.reduce((sum, header) => {
                return sum + (parseFloat(rowData[header]?.[attribute]) || 0);
            }, 0);
            return { ...rowData, _total: total };
        });
        
        return (
            <div className="table-responsive">
                <Table className="tablesorter">
                    <thead className="text-primary" style={{ backgroundColor: '#1e1e2f' }}>
                        <tr>
                        <th style={{ minWidth: "100px" }}>日期</th>
                        {headers.map((header, index) => (
                            <th key={index}>{header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {dataWithTotals.map((perData, index) => (
                        <tr key={index}>
                            <td>{perData.duration}</td>
                            {headers.map((header, index2) => {
                                const value = perData[header]?.[attribute] || 0;
                                const percentage = perData._total ? ((value / perData._total) * 100).toFixed(1) : 0;
                                return (
                                    <td key={index2}>
                                        {numberWithCommas(Math.round(value))}
                                        <div><span className="text-muted">({percentage}%)</span></div>
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
        )
    }                

    renderAllGamesTable = (headers, feeData) => {
        return (
            <div className="table-responsive">
                <Table className="tablesorter">
                    <thead className="text-primary" style={{ backgroundColor: '#1e1e2f' }}>
                        <tr>
                        <th style={{ minWidth: "100px" }}>日期</th>
                        {headers.map((header, index) => (
                            <th key={index}>{header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {feeData.map((perfeeData, index) => (
                        <tr key={index}>
                            <td>{perfeeData.duration}</td>
                            {headers.map((header, index2) => (
                                <td key={index2}>{numberWithCommas(Math.round(perfeeData[header]))}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
        )
    }
    
    renderUnionFeeTable = () => {
        let headers = (typeof this.props.unions_col !== "undefined") ? this.props.unions_col : [];
        let unions_fee = (typeof this.props.unions_fee !== "undefined") ? this.props.unions_fee : [];
        const { viewModeUnionFee } = this.state;
        
        // Group headers into chunks of 5 for responsiveness
        const chunkedHeaders = [];
        for (let i = 0; i < headers.length; i += 5) {
            chunkedHeaders.push(headers.slice(i, i + 5));
        }
        
        return (
            <Row>
                <Col xs="12">
                    <Card>
                        <CardHeader>
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <CardTitle tag="h4" className="mr-3 mb-0">Unions Fee Table</CardTitle>
                                    {/* View mode toggle buttons */}
                                    <ButtonGroup>
                                        <Button 
                                            color={viewModeUnionFee === 'table' ? 'warning' : 'secondary'} 
                                            onClick={() => this.toggleViewMode('UnionFee', 'table')}
                                            size="sm"
                                        >
                                            <i className="fa fa-table mr-1"></i> Table
                                        </Button>
                                        <Button 
                                            color={viewModeUnionFee === 'chart' ? 'warning' : 'secondary'} 
                                            onClick={() => this.toggleViewMode('UnionFee', 'chart')}
                                            size="sm"
                                        >
                                            <i className="fa fa-line-chart mr-1"></i> Chart
                                        </Button>
                                    </ButtonGroup>
                                </div>
                                
                                {/* Time interval selector - only visible in chart mode */}
                                {viewModeUnionFee === 'chart' && (
                                    <ButtonGroup>
                                        <Button 
                                            color={this.state.timeIntervalUnionFee === 'allTime' ? 'info' : 'secondary'} 
                                            onClick={() => this.setTimeInterval('allTime', 'UnionFee')}
                                            size="sm"
                                        >
                                            全部時間
                                        </Button>
                                        <Button 
                                            color={this.state.timeIntervalUnionFee === 'recent52weeks' ? 'info' : 'secondary'} 
                                            onClick={() => this.setTimeInterval('recent52weeks', 'UnionFee')}
                                            size="sm"
                                        >
                                            近一年
                                        </Button>
                                        <Button 
                                            color={this.state.timeIntervalUnionFee === 'recent26weeks' ? 'info' : 'secondary'} 
                                            onClick={() => this.setTimeInterval('recent26weeks', 'UnionFee')}
                                            size="sm"
                                        >
                                            近半年
                                        </Button>
                                        <Button 
                                            color={this.state.timeIntervalUnionFee === 'recent12weeks' ? 'info' : 'secondary'} 
                                            onClick={() => this.setTimeInterval('recent12weeks', 'UnionFee')}
                                            size="sm"
                                        >
                                            近一季
                                        </Button>
                                        <Button 
                                            color={this.state.timeIntervalUnionFee === 'recent4weeks' ? 'info' : 'secondary'} 
                                            onClick={() => this.setTimeInterval('recent4weeks', 'UnionFee')}
                                            size="sm"
                                        >
                                            近四周
                                        </Button>
                                    </ButtonGroup>
                                )}
                            </div>
                        </CardHeader>
                        <CardBody>
                            {viewModeUnionFee === 'chart' ? (
                                this.renderChartView('UnionFee', this.generateUnionFeeChartData)
                            ) : (
                                chunkedHeaders.length > 0 && (
                                    <>
                                        <EnhancedNav tabs className="mb-3">
                                            {chunkedHeaders.map((chunk, chunkIndex) => (
                                                <EnhancedNavItem key={`union-chunk-${chunkIndex}`}>
                                                    <EnhancedNavLink 
                                                        active={this.state.activeUnionFeeTab === chunkIndex}
                                                        className={classNames({ active: this.state.activeUnionFeeTab === chunkIndex })}
                                                        onClick={() => { this.setState({ activeUnionFeeTab: chunkIndex }) }}
                                                    >
                                                        Group {chunkIndex + 1}
                                                    </EnhancedNavLink>
                                                </EnhancedNavItem>
                                            ))}
                                        </EnhancedNav>
                                        
                                        <TabContent activeTab={String(this.state.activeUnionFeeTab || 0)}>
                                            {chunkedHeaders.map((chunk, chunkIndex) => (
                                                <TabPane key={`union-tabpane-${chunkIndex}`} tabId={String(chunkIndex)}>
                                                    <div className="table-responsive">
                                                        <Table className="tablesorter">
                                                            <thead className="text-primary" style={{ backgroundColor: '#1e1e2f' }}>
                                                                <tr>
                                                                    <th style={{ minWidth: "100px" }}>日期</th>
                                                                    {chunk.map((header, index) => (
                                                                        <th key={index}>{header.name}</th>
                                                                    ))}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {unions_fee.map((union_fee_data, index) => (
                                                                    <tr key={index}>
                                                                        <td>{union_fee_data.duration}</td>
                                                                        {chunk.map((header, index2) => (
                                                                            <td key={index2}>{numberWithCommas(Math.round(union_fee_data[header.id]))}</td>
                                                                        ))}
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                </TabPane>
                                            ))}
                                        </TabContent>
                                    </>
                                )
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        );
    }

    renderMainClubFeeTable = () => {
        let headers = (typeof this.props.main_club !== "undefined" && typeof this.props.main_club.clubs !== "undefined") 
            ? [...this.props.main_club.clubs] // Mutable copy
            : [];
        let feeData = (typeof this.props.main_club !== "undefined" && typeof this.props.main_club.sumData !== "undefined") 
            ? this.props.main_club.sumData 
            : [];
        const { viewModeClubFee, mainClubSortCriteria } = this.state; // Get sort criteria
        
        // 过滤重复的列（相同数据但名称不同）
        const duplicateMap = {};
        const filteredHeaders = [];
        
        // 检查数据内容是否相同来识别重复列
        if (headers.length > 0 && feeData.length > 0) {
            for (let i = 0; i < headers.length; i++) {
                const currentHeader = headers[i];
                let isDuplicate = false;
                
                // 已经添加的列的id
                const existingIds = filteredHeaders.map(h => h.id);
                
                // 遍历已过滤的列，检查数据是否相同
                for (const existingId of existingIds) {
                    let isDataIdentical = true;
                    
                    // 比较每行数据
                    for (const row of feeData) {
                        if (row[currentHeader.id] !== row[existingId]) {
                            isDataIdentical = false;
                            break;
                        }
                    }
                    
                    if (isDataIdentical) {
                        isDuplicate = true;
                        duplicateMap[currentHeader.id] = existingId; // 记录重复关系
                        break;
                    }
                }
                
                if (!isDuplicate) {
                    filteredHeaders.push(currentHeader);
                }
            }
        }
        
        // 使用过滤后的headers
        headers = filteredHeaders;
        
        // Calculate club totals based on sort criteria
        const clubTotals = {};
        if (headers.length > 0 && feeData.length > 0) {
            headers.forEach(header => { clubTotals[header.id] = 0; });

            const dataToSum = mainClubSortCriteria === 'last10weeks'
                ? feeData.slice(0, 10)
                : feeData;
            
            dataToSum.forEach(item => {
                headers.forEach(header => {
                    if (typeof item[header.id] !== 'undefined' && !isNaN(item[header.id])) {
                        clubTotals[header.id] += Math.round(item[header.id]);
                    }
                });
            });

            // Sort headers based on calculated totals
            headers.sort((a, b) => {
                const totalA = clubTotals[a.id] || 0;
                const totalB = clubTotals[b.id] || 0;
                if (totalA === 0 && totalB === 0) return String(a.id).localeCompare(String(b.id));
                if (totalA === 0) return 1;
                if (totalB === 0) return -1;
                return totalB - totalA;
            });
        }
        
        // Group sorted headers into chunks of 5 for responsiveness
        const chunkedHeaders = [];
        for (let i = 0; i < headers.length; i += 5) {
            chunkedHeaders.push(headers.slice(i, i + 5));
        }
        
        // 创建一个新的feeData副本，替换重复列的值
        // 此步骤可选，因为我们已经过滤了表头，可以保持原始数据不变
        
        return (
            <Row>
                <Col xs="12">
                    <Card>
                        <CardHeader>
                            <div className="d-flex justify-content-between align-items-center flex-wrap"> {/* Added flex-wrap */}
                                {/* Left side: Title and View Mode Toggle */}
                                <div className="d-flex align-items-center mb-2 mb-md-0"> {/* Added margin bottom for small screens */}
                                    <CardTitle tag="h4" className="mr-3 mb-0">Main Club of 9527 Fee Table</CardTitle>
                                    <ButtonGroup>
                                        <Button 
                                            color={viewModeClubFee === 'table' ? 'warning' : 'secondary'} 
                                            onClick={() => this.toggleViewMode('ClubFee', 'table')}
                                            size="sm"
                                        >
                                            <i className="fa fa-table mr-1"></i> Table
                                        </Button>
                                        <Button 
                                            color={viewModeClubFee === 'chart' ? 'warning' : 'secondary'} 
                                            onClick={() => this.toggleViewMode('ClubFee', 'chart')}
                                            size="sm"
                                        >
                                            <i className="fa fa-line-chart mr-1"></i> Chart
                                        </Button>
                                    </ButtonGroup>
                                </div>
                                
                                {/* Right side: Sorting Dropdown and Time Interval (if chart) */}
                                <div className="d-flex align-items-center">
                                    {/* Sorting Dropdown */}
                                    <div className="d-flex align-items-center mr-3">
                                        <span className="mr-2" style={{fontSize: '0.8rem', color: '#aaa'}}>Sort By:</span>
                                        <Input 
                                            type="select" 
                                            bsSize="sm" 
                                            value={mainClubSortCriteria} 
                                            onChange={this.handleMainClubSortChange} 
                                            style={{ maxWidth: '150px', backgroundColor: '#27293d', color: '#fff', borderColor: '#32325d' }}
                                            name="mainClubSort" 
                                            id="mainClubSort"
                                        >
                                            <option value="last10weeks">Last 10 Weeks</option>
                                            <option value="allTime">All Time</option>
                                        </Input>
                                    </div>

                                    {/* Time interval selector - only visible in chart mode */}
                                    {viewModeClubFee === 'chart' && (
                                        <ButtonGroup>
                                            <Button 
                                                color={this.state.timeIntervalClubFee === 'allTime' ? 'info' : 'secondary'} 
                                                onClick={() => this.setTimeInterval('allTime', 'ClubFee')}
                                                size="sm"
                                            >
                                                全部時間
                                            </Button>
                                            <Button 
                                                color={this.state.timeIntervalClubFee === 'recent52weeks' ? 'info' : 'secondary'} 
                                                onClick={() => this.setTimeInterval('recent52weeks', 'ClubFee')}
                                                size="sm"
                                            >
                                                近一年
                                            </Button>
                                            <Button 
                                                color={this.state.timeIntervalClubFee === 'recent26weeks' ? 'info' : 'secondary'} 
                                                onClick={() => this.setTimeInterval('recent26weeks', 'ClubFee')}
                                                size="sm"
                                            >
                                                近半年
                                            </Button>
                                            <Button 
                                                color={this.state.timeIntervalClubFee === 'recent12weeks' ? 'info' : 'secondary'} 
                                                onClick={() => this.setTimeInterval('recent12weeks', 'ClubFee')}
                                                size="sm"
                                            >
                                                近一季
                                            </Button>
                                            <Button 
                                                color={this.state.timeIntervalClubFee === 'recent4weeks' ? 'info' : 'secondary'} 
                                                onClick={() => this.setTimeInterval('recent4weeks', 'ClubFee')}
                                                size="sm"
                                            >
                                                近四周
                                            </Button>
                                        </ButtonGroup>
                                    )}
                                </div>
                            </div>
                        </CardHeader>
                        <CardBody>
                            {viewModeClubFee === 'chart' ? (
                                this.renderChartView('ClubFee', this.generateClubFeeChartData)
                            ) : (
                                chunkedHeaders.length > 0 && (
                                    <>
                                        <EnhancedNav tabs className="mb-3">
                                            {chunkedHeaders.map((chunk, chunkIndex) => (
                                                <EnhancedNavItem key={`club-chunk-${chunkIndex}`}>
                                                    <EnhancedNavLink 
                                                        active={this.state.activeClubFeeTab === chunkIndex}
                                                        className={classNames({ active: this.state.activeClubFeeTab === chunkIndex })}
                                                        onClick={() => { this.setState({ activeClubFeeTab: chunkIndex }) }}
                                                    >
                                                        Group {chunkIndex + 1}
                                                    </EnhancedNavLink>
                                                </EnhancedNavItem>
                                            ))}
                                        </EnhancedNav>
                                        
                                        <TabContent activeTab={String(this.state.activeClubFeeTab || 0)}>
                                            {chunkedHeaders.map((chunk, chunkIndex) => (
                                                <TabPane key={`club-tabpane-${chunkIndex}`} tabId={String(chunkIndex)}>
                                                    <div className="table-responsive">
                                                        <Table className="tablesorter">
                                                            <thead className="text-primary" style={{ backgroundColor: '#1e1e2f' }}>
                                                                <tr>
                                                                    <th style={{ minWidth: "100px" }}>日期</th>
                                                                    {chunk.map((header, index) => (
                                                                        <th key={index}>
                                                                            {header.name}
                                                                            {/* Optional: Display total sum used for sorting */}
                                                                            {/* <small style={{display: 'block', color: '#aaa', fontWeight: 'normal'}}>
                                                                                ({numberWithCommas(clubTotals[header.id] || 0)})
                                                                            </small> */}
                                                                        </th>
                                                                    ))}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {feeData.map((perfeeData, index) => ( // Use original feeData for rows
                                                                    <tr key={index}>
                                                                        <td>{perfeeData.duration}</td>
                                                                        {chunk.map((header, index2) => (
                                                                            <td key={index2}>{numberWithCommas(Math.round(perfeeData[header.id]))}</td>
                                                                        ))}
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                </TabPane>
                                            ))}
                                        </TabContent>
                                    </>
                                )
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        );
    }

    

    renderGamesFeeTable = () => {
        let headers = (typeof this.props.games_col !== "undefined") ? this.props.games_col : [];
        let feeData = (typeof this.props.games_fee !== "undefined") ? this.props.games_fee : [];
        const { viewModeGamesFee, flashDetailField } = this.state;
        
        return (
            <Row>
                <Col xs="12">
                    <ButtonGroup>
                        <Button 
                            color="#3d5c5c" 
                            className="d-flex align-items-center" 
                            style={{ 
                                backgroundColor: this.state.showFlashLevelView === 'AllGames' ? '#17a2b8' : 'transparent',
                                borderColor: this.state.showFlashLevelView === 'AllGames' ? '#17a2b8' : 'transparent',
                                color: this.state.showFlashLevelView === 'AllGames' ? '#fff' : 'rgba(255, 255, 255, 0.7)',
                                fontWeight: this.state.showFlashLevelView === 'AllGames' ? 'bold' : 'normal',
                                boxShadow: this.state.showFlashLevelView === 'AllGames' ? '0 3px 5px rgba(23, 162, 184, 0.5)' : 'none'
                            }}
                            onClick={() => this.toggleFlashLevelView("AllGames")}
                        >
                            全遊戲種類
                        </Button>
                        <Button 
                            color="#3d5c5c" 
                            className="d-flex align-items-center"
                            style={{ 
                                backgroundColor: this.state.showFlashLevelView === 'FlashLevel' ? '#17a2b8' : 'transparent',
                                borderColor: this.state.showFlashLevelView === 'FlashLevel' ? '#17a2b8' : 'transparent',
                                color: this.state.showFlashLevelView === 'FlashLevel' ? '#fff' : 'rgba(255, 255, 255, 0.7)',
                                fontWeight: this.state.showFlashLevelView === 'FlashLevel' ? 'bold' : 'normal',
                                boxShadow: this.state.showFlashLevelView === 'FlashLevel' ? '0 3px 5px rgba(23, 162, 184, 0.5)' : 'none'
                            }}
                            onClick={() => this.toggleFlashLevelView("FlashLevel")}
                        >
                           FLASH 各級別
                        </Button>
                    </ButtonGroup>
                    <Card className='mt-2'>
                        <CardHeader>
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <CardTitle tag="h4" className="mr-3 mb-0">{this.state.showFlashLevelView === 'FlashLevel' ? 'Flash Level Fee Table' : 'Games Fee Table'}</CardTitle>
                                    {/* View mode toggle buttons */}
                                    <ButtonGroup>
                                        <Button 
                                            color={viewModeGamesFee === 'table' ? 'warning' : 'secondary'} 
                                            onClick={() => this.toggleViewMode('GamesFee', 'table')}
                                            size="sm"
                                        >
                                            <i className="fa fa-table mr-1"></i> Table
                                        </Button>
                                        <Button 
                                            color={viewModeGamesFee === 'chart' ? 'warning' : 'secondary'} 
                                            onClick={() => this.toggleViewMode('GamesFee', 'chart')}
                                            size="sm"
                                        >
                                            <i className="fa fa-line-chart mr-1"></i> Chart
                                        </Button>
                                    </ButtonGroup>
                                </div>
                                {this.state.showFlashLevelView === 'FlashLevel' && this.state.flashDetailField === 'players' && (
                                    <div className="d-flex align-items-right">
                                        <span className="text-light mt-2"><h4>此為每天每桌玩家數的一周總和</h4></span>
                                    </div>
                                )}
                                {this.state.showFlashLevelView === 'FlashLevel' && (
                                    <div className="d-flex align-items-right">
                                        
                                    <ButtonGroup>
                                        <Button 
                                            color={ flashDetailField === 'fee' ? 'info' : 'secondary'} 
                                            onClick={() => this.changeFlashItem('fee')}
                                            size="sm"
                                        >
                                            服務費
                                        </Button>
                                        <Button 
                                            color={ flashDetailField === 'players' ? 'info' : 'secondary'} 
                                            onClick={() => this.changeFlashItem('players')}
                                            size="sm"
                                        >
                                            玩家數
                                        </Button>
                                        <Button 
                                            color={ flashDetailField === 'hands' ? 'info' : 'secondary'} 
                                            onClick={() => this.changeFlashItem('hands')}
                                            size="sm"
                                        >
                                           手數
                                        </Button>
                                        
                                    </ButtonGroup>
                                </div>
                                )}
                                {/* Time interval selector - only visible in chart mode */}
                                {viewModeGamesFee === 'chart' && (
                                    <ButtonGroup>
                                        <Button 
                                            color={this.state.timeIntervalGamesFee === 'allTime' ? 'info' : 'secondary'} 
                                            onClick={() => this.setTimeInterval('allTime', 'GamesFee')}
                                            size="sm"
                                        >
                                            全部時間
                                        </Button>
                                        <Button 
                                            color={this.state.timeIntervalGamesFee === 'recent52weeks' ? 'info' : 'secondary'} 
                                            onClick={() => this.setTimeInterval('recent52weeks', 'GamesFee')}
                                            size="sm"
                                        >
                                            近一年
                                        </Button>
                                        <Button 
                                            color={this.state.timeIntervalGamesFee === 'recent26weeks' ? 'info' : 'secondary'} 
                                            onClick={() => this.setTimeInterval('recent26weeks', 'GamesFee')}
                                            size="sm"
                                        >
                                            近半年
                                        </Button>
                                        <Button 
                                            color={this.state.timeIntervalGamesFee === 'recent12weeks' ? 'info' : 'secondary'} 
                                            onClick={() => this.setTimeInterval('recent12weeks', 'GamesFee')}
                                            size="sm"
                                        >
                                            近一季
                                        </Button>
                                        <Button 
                                            color={this.state.timeIntervalGamesFee === 'recent4weeks' ? 'info' : 'secondary'} 
                                            onClick={() => this.setTimeInterval('recent4weeks', 'GamesFee')}
                                            size="sm"
                                        >
                                            近四周
                                        </Button>
                                    </ButtonGroup>
                                )}
                            </div>
                        </CardHeader>
                        <CardBody>
                            {viewModeGamesFee === 'chart' ? (
                                this.state.showFlashLevelView === 'FlashLevel' ?
                                    this.renderChartView('GamesFee', this.generateFlashLevelChartData)
                                :
                                    this.renderChartView('GamesFee', this.generateGamesFeeChartData)
                            ) : (
                                this.state.showFlashLevelView === 'FlashLevel' ?
                                    this.renderFlashLevelTable()
                                    :
                                    this.renderAllGamesTable(headers, feeData)
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        );
    }

    renderMembershipTable = () => {
        let headers = (typeof this.props.membership_header !== "undefined") ? this.props.membership_header : [];
        let membership_sum = (typeof this.props.membership_sum !== "undefined") ? this.props.membership_sum : [];
        const { viewModeMembership } = this.state;
        
        // If there are too many columns, group headers into chunks of 5 for responsiveness
        const chunkedHeaders = [];
        for (let i = 0; i < headers.length; i += 5) {
          chunkedHeaders.push(headers.slice(i, i + 5));
        }
        
        return (
          <Row>
            <Col xs="12">
              <Card>
                <CardHeader>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                      <CardTitle tag="h4" className="mr-3 mb-0">Membership Card Table</CardTitle>
                      
                      {/* View mode toggle buttons */}
                      <ButtonGroup>
                        <Button 
                          color={viewModeMembership === 'table' ? 'warning' : 'secondary'} 
                          onClick={() => this.toggleViewMode('Membership', 'table')}
                          size="sm"
                        >
                          <i className="fa fa-table mr-1"></i> Table
                        </Button>
                        <Button 
                          color={viewModeMembership === 'chart' ? 'warning' : 'secondary'} 
                          onClick={() => this.toggleViewMode('Membership', 'chart')}
                          size="sm"
                        >
                          <i className="fa fa-line-chart mr-1"></i> Chart
                        </Button>
                      </ButtonGroup>
                    </div>
                    
                    {/* Time interval selector - only visible in chart mode */}
                    {viewModeMembership === 'chart' && (
                      <ButtonGroup>
                        <Button 
                          color={this.state.timeIntervalMembership === 'allTime' ? 'info' : 'secondary'} 
                          onClick={() => this.setTimeInterval('allTime', 'Membership')}
                          size = "sm"
                        >
                          全部時間
                        </Button>
                        <Button 
                          color={this.state.timeIntervalMembership === 'recent52weeks' ? 'info' : 'secondary'} 
                          onClick={() => this.setTimeInterval('recent52weeks', 'Membership')}
                          size = "sm"
                        >
                          近一年
                        </Button>
                        <Button 
                          color={this.state.timeIntervalMembership === 'recent26weeks' ? 'info' : 'secondary'} 
                          onClick={() => this.setTimeInterval('recent26weeks', 'Membership')}
                          size = "sm"
                        >
                          近半年
                        </Button>
                        <Button 
                          color={this.state.timeIntervalMembership === 'recent12weeks' ? 'info' : 'secondary'} 
                          onClick={() => this.setTimeInterval('recent12weeks', 'Membership')}
                          size = "sm"
                        >
                          近一季
                        </Button>
                        <Button 
                          color={this.state.timeIntervalMembership === 'recent4weeks' ? 'info' : 'secondary'} 
                          onClick={() => this.setTimeInterval('recent4weeks', 'Membership')}
                          size = "sm"
                        >
                          近四周
                        </Button>
                      </ButtonGroup>
                    )}
                  </div>
                </CardHeader>
                <CardBody>
                  {viewModeMembership === 'chart' ? (
                    this.renderChartView('Membership', this.generateMembershipChartData)
                  ) : (
                    // Display table view based on number of columns
                    headers.length <= 5 ? (
                      <div className="table-responsive">
                        <Table className="tablesorter">
                          <thead className="text-primary" style={{ backgroundColor: '#1e1e2f' }}>
                            <tr>
                              <th style={{ minWidth: "100px" }}>日期</th>
                              {headers.map((header, index) => (
                                <th key={index}>{header.name}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {membership_sum.map((data, index) => (
                              <tr key={index}>
                                <td>{data.duration}</td>
                                {headers.map((header, index2) => (
                                  <td key={index2}>{numberWithCommas(Math.round(data[header.id]))}</td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    ) : (
                      chunkedHeaders.length > 0 && (
                        <>
                          <EnhancedNav tabs className="mb-3">
                            {chunkedHeaders.map((chunk, chunkIndex) => (
                              <EnhancedNavItem key={`membership-chunk-${chunkIndex}`}>
                                <EnhancedNavLink 
                                  active={this.state.activeMembershipTab === chunkIndex}
                                  className={classNames({ active: this.state.activeMembershipTab === chunkIndex })}
                                  onClick={() => { this.setState({ activeMembershipTab: chunkIndex }) }}
                                >
                                  Group {chunkIndex + 1}
                                </EnhancedNavLink>
                              </EnhancedNavItem>
                            ))}
                          </EnhancedNav>
                          
                          <TabContent activeTab={String(this.state.activeMembershipTab || 0)}>
                            {chunkedHeaders.map((chunk, chunkIndex) => (
                              <TabPane key={`membership-tabpane-${chunkIndex}`} tabId={String(chunkIndex)}>
                                <div className="table-responsive">
                                  <Table className="tablesorter">
                                    <thead className="text-primary" style={{ backgroundColor: '#1e1e2f' }}>
                                      <tr>
                                        <th style={{ minWidth: "100px" }}>日期</th>
                                        {chunk.map((header, index) => (
                                          <th key={index}>{header.name}</th>
                                        ))}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {membership_sum.map((data, index) => (
                                        <tr key={index}>
                                          <td>{data.duration}</td>
                                          {chunk.map((header, index2) => (
                                            <td key={index2}>{numberWithCommas(Math.round(data[header.id]))}</td>
                                          ))}
                                        </tr>
                                      ))}
                                    </tbody>
                                  </Table>
                                </div>
                              </TabPane>
                            ))}
                          </TabContent>
                        </>
                      )
                    )
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        );
    }

    renderUnionMembershipTable = () => {
        let headers = (typeof this.props.unions_col !== "undefined") ? this.props.unions_col : [];
        let union_membership_amount = (typeof this.props.union_membership_amount !== "undefined") ? this.props.union_membership_amount : [];
        const { viewModeUnionMembership } = this.state;
        
        // Group headers into chunks of 5 for responsiveness
        const chunkedHeaders = [];
        for (let i = 0; i < headers.length; i += 5) {
            chunkedHeaders.push(headers.slice(i, i + 5));
        }
        
        return (
            <Row>
                <Col xs="12">
                    <Card>
                        <CardHeader>
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <CardTitle tag="h4" className="mr-3 mb-0">Union Membership Card Table</CardTitle>
                                    {/* View mode toggle buttons */}
                                    <ButtonGroup>
                                        <Button 
                                            color={viewModeUnionMembership === 'table' ? 'warning' : 'secondary'} 
                                            onClick={() => this.toggleViewMode('UnionMembership', 'table')}
                                            size="sm"
                                        >
                                            <i className="fa fa-table mr-1"></i> Table
                                        </Button>
                                        <Button 
                                            color={viewModeUnionMembership === 'chart' ? 'warning' : 'secondary'} 
                                            onClick={() => this.toggleViewMode('UnionMembership', 'chart')}
                                            size="sm"
                                        >
                                            <i className="fa fa-line-chart mr-1"></i> Chart
                                        </Button>
                                    </ButtonGroup>
                                </div>
                                
                                {/* Time interval selector - only visible in chart mode */}
                                {viewModeUnionMembership === 'chart' && (
                                    <ButtonGroup>
                                        <Button 
                                            color={this.state.timeIntervalUnionMembership === 'allTime' ? 'info' : 'secondary'} 
                                            onClick={() => this.setTimeInterval('allTime', 'UnionMembership')}
                                            size="sm"
                                        >
                                            全部時間
                                        </Button>
                                        <Button 
                                            color={this.state.timeIntervalUnionMembership === 'recent52weeks' ? 'info' : 'secondary'} 
                                            onClick={() => this.setTimeInterval('recent52weeks', 'UnionMembership')}
                                            size="sm"
                                        >
                                            近一年
                                        </Button>
                                        <Button 
                                            color={this.state.timeIntervalUnionMembership === 'recent26weeks' ? 'info' : 'secondary'} 
                                            onClick={() => this.setTimeInterval('recent26weeks', 'UnionMembership')}
                                            size="sm"
                                        >
                                            近半年
                                        </Button>
                                        <Button 
                                            color={this.state.timeIntervalUnionMembership === 'recent12weeks' ? 'info' : 'secondary'} 
                                            onClick={() => this.setTimeInterval('recent12weeks', 'UnionMembership')}
                                            size="sm"
                                        >
                                            近一季
                                        </Button>
                                        <Button 
                                            color={this.state.timeIntervalUnionMembership === 'recent4weeks' ? 'info' : 'secondary'} 
                                            onClick={() => this.setTimeInterval('recent4weeks', 'UnionMembership')}
                                            size="sm"
                                        >
                                            近四周
                                        </Button>
                                    </ButtonGroup>
                                )}
                            </div>
                        </CardHeader>
                        <CardBody>
                            {viewModeUnionMembership === 'chart' ? (
                                this.renderChartView('UnionMembership', this.generateUnionMembershipChartData)
                            ) : (
                                // Display either a simple table or a tabbed interface based on header count
                                headers.length <= 5 ? (
                                    <div className="table-responsive">
                                        <Table className="tablesorter">
                                            <thead className="text-primary" style={{ backgroundColor: '#1e1e2f' }}>
                                                <tr>
                                                    <th style={{ minWidth: "100px" }}>日期</th>
                                                    {headers.map((header, index) => (
                                                        <th key={index}>{header.name}</th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {union_membership_amount.map((data, index) => (
                                                    <tr key={index}>
                                                        <td>{data.duration}</td>
                                                        {headers.map((header, index2) => (
                                                            <td key={index2}>{numberWithCommas(Math.round(data[header.id]))}</td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                ) : (
                                    chunkedHeaders.length > 0 && (
                                        <>
                                            <EnhancedNav tabs className="mb-3">
                                                {chunkedHeaders.map((chunk, chunkIndex) => (
                                                    <EnhancedNavItem key={`union-membership-chunk-${chunkIndex}`}>
                                                        <EnhancedNavLink 
                                                            active={this.state.activeUnionMembershipTab === chunkIndex}
                                                            className={classNames({ active: this.state.activeUnionMembershipTab === chunkIndex })}
                                                            onClick={() => { this.setState({ activeUnionMembershipTab: chunkIndex }) }}
                                                        >
                                                            Group {chunkIndex + 1}
                                                        </EnhancedNavLink>
                                                    </EnhancedNavItem>
                                                ))}
                                            </EnhancedNav>
                                            
                                            <TabContent activeTab={String(this.state.activeUnionMembershipTab || 0)}>
                                                {chunkedHeaders.map((chunk, chunkIndex) => (
                                                    <TabPane key={`union-membership-tabpane-${chunkIndex}`} tabId={String(chunkIndex)}>
                                                        <div className="table-responsive">
                                                            <Table className="tablesorter">
                                                                <thead className="text-primary" style={{ backgroundColor: '#1e1e2f' }}>
                                                                    <tr>
                                                                        <th style={{ minWidth: "100px" }}>日期</th>
                                                                        {chunk.map((header, index) => (
                                                                            <th key={index}>{header.name}</th>
                                                                        ))}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {union_membership_amount.map((data, index) => (
                                                                        <tr key={index}>
                                                                            <td>{data.duration}</td>
                                                                            {chunk.map((header, index2) => (
                                                                                <td key={index2}>{numberWithCommas(Math.round(data[header.id]))}</td>
                                                                            ))}
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    </TabPane>
                                                ))}
                                            </TabContent>
                                        </>
                                    )
                                )
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        );
    }

    // Method to render the OtherFee table
    // 會計在 Google Sheet 上會預先建好一整年的未來週期列（一路到 20261026-20261101），
    // 那些列全是 0。舊表格照單全收會拉出一長串空白。
    // ⚠️ 這份資料是**由新到舊**排的，所以未來的空白列在陣列「開頭」——
    //    兩端都要砍，只砍尾端不會有任何效果。中間真的是 0 的週期不動。
    trimTrailingEmptyWeeks = (rows = [], numericKeys = []) => {
        const isEmpty = (r) => numericKeys.every((k) => {
            const v = r[k];
            return v === undefined || v === null || v === '' || Number(v) === 0;
        });
        let start = 0;
        let end = rows.length;
        while (start < end && isEmpty(rows[start])) start += 1;
        while (end > start && isEmpty(rows[end - 1])) end -= 1;
        return rows.slice(start, end);
    }

    // 雜項費用頁的週期清單 —— **跟總淨營收同一份**（getNetProfitWeeks），由新到舊。
    //
    // 🔴 v2.37.0 之前這裡讀的是會計 Google Sheet 的週鍵（r2h_revenue），再砍掉會計
    //    預建的未來空白列。Sheet 於 2026-09-08 正式退休、之後沒有人再填，於是
    //    「最新有值的一列」永遠停在 20260831-20260906 —— pipeline 每週長出新週，
    //    總淨營收有那一列、雜項費用卻沒有格子可以填。
    //
    // 🔑 三頁（金流數據 / 雜項費用 / 總淨營收）該出現哪些週，規則只能有一份：
    //    總淨營收 = OA ∪ Sheet ∪ Tiny 的週期，並以 pipeline 最新週截尾。
    //    雜項費用直接沿用，pipeline 跑完那一週自然就有列。
    //    比最早登記還舊的空白週由 TinyMiscFee 自己砍（它才知道哪幾週有資料）。
    //
    // ⚠️ Tiny 營收還沒載回來之前 latestTinyWeek 是 null、截尾失效，會把 Sheet 上
    //    預建到 20261026 的空白週全放出來。所以還沒載完就先回空清單。
    getMiscFeeWeeks = () => {
        const { revenue = [], r2h_revenue = [] } = this.props;
        const { tinyRevenueData = [] } = this.state;
        if (!tinyRevenueData.length) return [];
        return this.getNetProfitWeeks({ revenue, r2h_revenue, tinyRevenueData })
            .slice()
            .reverse();
    }

    renderOtherFeeTable = () => {
        const { r2h_revenue: r2h_revenue_raw = [], cm_detail = [] } = this.props;
        // 截掉尾端會計預建的未來空白週期列
        const r2h_revenue = this.trimTrailingEmptyWeeks(r2h_revenue_raw, [
            '水房', '水房實際交收', '水房推薦人+補助', '租用帳戶',
            '出金手', 'BOT費用', '其他雜項', '公費報帳',
        ]);
        const { showFullChipDetails } = this.state;
        
        // Extract common styling into constants
        const cellCentered = { textAlign: 'center' };
        const commonColumnStyle = { width: "10%", textAlign: 'center', fontSize: '17px' };
        const dateColumnStyle = { width: "16%", minWidth: "160px", textAlign: 'center', fontSize: '17px' };
        const widerColumnStyle = { width: "14%", textAlign: 'center', fontSize: '17px' }; // 更大的列宽
        
        // 日期基准点用于总出入金加成计算
        const pivotDate = "20250406"; // 2025/03/31-2025/04/06的结束日期
        const pivotDateAfter = "20250413"; // 2025/04/07-2025/04/13的结束日期
        const newSystemDate = "20250901-20250907"; // 联盟新制运行日期
        
        // 分离新制和旧制数据
        const newSystemData = r2h_revenue.filter(rev => rev["月份/日期"] >= newSystemDate);
        const oldSystemData = r2h_revenue.filter(rev => rev["月份/日期"] < newSystemDate);
        
        // 共用的数据处理函数
        const getCommonData = (revenue) => {
            // 查找对应日期的cm_detail数据
            const matchingCmDetail = cm_detail.find(item => 
                item.duration === revenue["月份/日期"] || 
                (item.duration && revenue["月份/日期"] && 
                 item.duration.replace(/\s+/g, '') === revenue["月份/日期"].replace(/\s+/g, ''))
            );
            
            // 获取入金出金数据
            const oaBuyChipAmount = matchingCmDetail ? matchingCmDetail.oa_buychip_amount || {} : {};
            const oaSellChipAmount = matchingCmDetail ? matchingCmDetail.oa_sellchip_amount || {} : {};
            const r2hBuyChipAmount = matchingCmDetail ? matchingCmDetail.r2h_buychip_amount || {} : {};
            const r2hSellChipAmount = matchingCmDetail ? matchingCmDetail.r2h_sellchip_amount || {} : {};
            
            // 获取TWD金额
            const oaBuyTWD = oaBuyChipAmount.ntd || oaBuyChipAmount.twd || 0;
            const oaSellTWD = oaSellChipAmount.ntd || oaSellChipAmount.twd || 0;
            const r2hBuyTWD = r2hBuyChipAmount.ntd || r2hBuyChipAmount.twd || 0;
            const r2hSellTWD = r2hSellChipAmount.ntd || r2hSellChipAmount.twd || 0;
            
            // 获取USDT金额
            const oaBuyUSDT = oaBuyChipAmount.usdt || 0;
            const oaSellUSDT = oaSellChipAmount.usdt || 0;
            const r2hBuyUSDT = r2hBuyChipAmount.usdt || 0;
            const r2hSellUSDT = r2hSellChipAmount.usdt || 0;
            
            return {
                oaBuyTWD, oaSellTWD, r2hBuyTWD, r2hSellTWD,
                oaBuyUSDT, oaSellUSDT, r2hBuyUSDT, r2hSellUSDT
            };
        };
        
        // 格式化显示文本
        const formatDisplay = (twd, usdt) => {
            if (showFullChipDetails) {
                return numberWithCommas(usdt || 0);
            } else {
                return numberWithCommas(twd || 0);
            }
        };
        
        // 渲染新制表格
        const renderNewSystemTable = () => {
            if (newSystemData.length === 0) return null;
            
            return (
                <>
                    <h5 style={{ marginTop: '20px', marginBottom: '15px', color: '#fff' }}>聯盟新制 (2025/09/01 之後)</h5>
                    <div style={{ overflow: 'visible' }}>
                        <Table className="tablesorter">
                            <thead className="text-primary">
                                <tr>
                                    <th style={{ ...dateColumnStyle }}>日期</th>
                                    <th style={{ ...commonColumnStyle, width: '10%', backgroundColor: 'rgba(153, 102, 255, 0.2)' }}>OA入金<br/>(NTD)</th>
                                    <th style={{ ...commonColumnStyle, width: '10%', backgroundColor: 'rgba(255, 99, 132, 0.2)' }}>OA出金<br/>(NTD)</th>
                                    <th style={{ ...commonColumnStyle, width: '10%', backgroundColor: 'rgba(75, 192, 192, 0.2)' }}>R2H入金<br/>(NTD)</th>
                                    <th style={{ ...commonColumnStyle, width: '10%', backgroundColor: 'rgba(54, 162, 235, 0.2)' }}>R2H出金<br/>(NTD)</th>
                                    <th style={{ ...commonColumnStyle, backgroundColor: 'rgba(239, 224, 16, 0.2)' }}>NTD餘額</th>
                                    <th style={{ ...commonColumnStyle, width: '10%', backgroundColor: 'rgba(153, 102, 255, 0.2)' }}>金流手費用</th>
                                    <th style={{ ...commonColumnStyle, width: '10%', backgroundColor: 'rgba(75, 192, 192, 0.2)' }}>租用帳戶</th>
                                </tr>
                            </thead>
                            <tbody>
                                {newSystemData.map((revenue, index) => {
                                    const data = getCommonData(revenue);
                                    const withdrawSalary = parseInt(revenue["出金手"] || 0);
                                    const accountRental = parseInt(revenue["租用帳戶"] || 0);
                                    const ntdTotal = data.oaBuyTWD + data.r2hBuyTWD - data.oaSellTWD - data.r2hSellTWD;
                                    
                                    return (
                                        <tr key={`new-system-row-${index}`}>
                                            <td style={cellCentered}>{revenue["月份/日期"]}</td>
                                            <td style={cellCentered}>{formatDisplay(data.oaBuyTWD, data.oaBuyUSDT)}</td>
                                            <td style={cellCentered}>{formatDisplay(data.oaSellTWD, data.oaSellUSDT)}</td>
                                            <td style={cellCentered}>{formatDisplay(data.r2hBuyTWD, data.r2hBuyUSDT)}</td>
                                            <td style={cellCentered}>{formatDisplay(data.r2hSellTWD, data.r2hSellUSDT)}</td>
                                            <td style={cellCentered}>{numberWithCommas(ntdTotal)}</td>
                                            <td style={cellCentered}>{numberWithCommas(withdrawSalary)}</td>
                                            <td style={cellCentered}>{numberWithCommas(accountRental)}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    </div>
                </>
            );
        };
        
        // 渲染旧制表格
        const renderOldSystemTable = () => {
            if (oldSystemData.length === 0) return null;
            
            return (
                <>
                    <h5 style={{ marginTop: '20px', marginBottom: '15px', color: '#fff' }}>舊制 (2025/09/01 之前)</h5>
                    <div style={{ overflow: 'visible' }}>
                        <Table className="tablesorter">
                            <thead className="text-primary">
                                <tr>
                                    <th style={{ ...dateColumnStyle }}>日期</th>
                                    <th style={{ ...commonColumnStyle, width: '8%', backgroundColor: 'rgba(153, 102, 255, 0.2)' }}>OA入金<br/>(NTD)</th>
                                    <th style={{ ...commonColumnStyle, width: '8%', backgroundColor: 'rgba(255, 99, 132, 0.2)' }}>OA出金<br/>(NTD)</th>
                                    <th style={{ ...commonColumnStyle, width: '8%', backgroundColor: 'rgba(75, 192, 192, 0.2)' }}>R2H入金<br/>(NTD)</th>
                                    <th style={{ ...commonColumnStyle, width: '8%', backgroundColor: 'rgba(54, 162, 235, 0.2)' }}>R2H出金<br/>(NTD)</th>
                                    <th style={{ ...commonColumnStyle, backgroundColor: 'rgba(239, 224, 16, 0.2)' }}>NTD餘額</th>
                                    <th style={{ ...widerColumnStyle, backgroundColor: 'rgba(255, 206, 86, 0.2)' }}>手續費計算值<br/>(總入金*趴數)</th>
                                    <th style={{ ...commonColumnStyle, width: '8%', backgroundColor: 'rgba(54, 162, 235, 0.2)' }}>手續費<br/>(雲端記錄)</th>
                                    <th style={{ ...commonColumnStyle, width: '8%', backgroundColor: 'rgba(95, 138, 167, 0.77)' }}>推薦人<br/>+補助</th>
                                    <th style={{ ...commonColumnStyle, backgroundColor: 'rgba(75, 192, 192, 0.2)' }}>實際交收<br/>(雲端記錄)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {oldSystemData.map((revenue, index) => {
                                    const data = getCommonData(revenue);
                                    const waterHouseActual = revenue["水房實際交收"] || 0;
                                    const waterHouseFee = revenue["水房"] ? parseFloat(revenue["水房"]): 0;
                                    const subsidy = revenue["水房推薦人+補助"] ? parseFloat(revenue["水房推薦人+補助"]) : 0;
                                    
                                    // 计算总出入金加成
                                    let bonusRate = 0.023; // 默认比率 2.3%
                                    let bonusRateDisplay = "2.3%";
                                    
                                    // 检查日期是否在分界点之后
                                    if (revenue["月份/日期"] && revenue["月份/日期"].includes("-")) {
                                        const endDate = revenue["月份/日期"].split("-")[1].replace(/\//g, "");
                                        const startDate = revenue["月份/日期"].split("-")[0].replace(/\//g, "");
                                        
                                        // After 20250413 will always be 3.3%
                                        if (startDate > "20250803") {
                                            bonusRate = 0.033;
                                            bonusRateDisplay = "3.3%";
                                        }
                                        // After 20250413 will always be 2.8%
                                        else if (startDate > "20250413" && startDate <= "20250803") {
                                            bonusRate = 0.028;
                                            bonusRateDisplay = "2.8%";
                                        }
                                        // 20250407-20250413 should be 2.8%
                                        else if (startDate === "20250407" || (startDate <= "20250413" && endDate >= "20250407")) {
                                            bonusRate = 0.028; // 2.8% for 20250407-20250413
                                            bonusRateDisplay = "2.8%";
                                        } 
                                        // 20250331-20250406 should be 2.5%
                                        else if (startDate === "20250331" || (startDate <= "20250406" && endDate >= "20250331")) {
                                            bonusRate = 0.025; // 2.5% for 20250331-20250406
                                            bonusRateDisplay = "2.5%";
                                        }
                                    }
                                    
                                    const totalBonus = Math.round((data.oaBuyTWD + data.r2hBuyTWD) * bonusRate);
                                    const ntdTotal = data.oaBuyTWD + data.r2hBuyTWD - data.oaSellTWD - data.r2hSellTWD;
                                    
                                    return (
                                        <tr key={`old-system-row-${index}`}>
                                            <td style={cellCentered}>{revenue["月份/日期"]}</td>
                                            <td style={cellCentered}>{formatDisplay(data.oaBuyTWD, data.oaBuyUSDT)}</td>
                                            <td style={cellCentered}>{formatDisplay(data.oaSellTWD, data.oaSellUSDT)}</td>
                                            <td style={cellCentered}>{formatDisplay(data.r2hBuyTWD, data.r2hBuyUSDT)}</td>
                                            <td style={cellCentered}>{formatDisplay(data.r2hSellTWD, data.r2hSellUSDT)}</td>
                                            <td style={cellCentered}>{numberWithCommas(ntdTotal)}</td>
                                            <td style={cellCentered}>{totalBonus > 0 ? numberWithCommas(totalBonus) : "-" } <span className='ml-1' style={{fontSize: '14px', color: '#888'}}>({bonusRateDisplay})</span></td>
                                            <td style={cellCentered}>{numberWithCommas(Math.round(waterHouseFee))}</td>
                                            <td style={cellCentered}>{numberWithCommas(subsidy)}</td>
                                            <td style={{...cellCentered, width: '15%', padding: '8px 5px'}}>{numberWithCommas(waterHouseActual)}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    </div>
                </>
            );
        };
        
        return (
            <div>
                {renderNewSystemTable()}
                {renderOldSystemTable()}
            </div>
        );
    }

    generateOtherFeeChartData = () => {
        const { r2h_revenue = [], cm_detail = [] } = this.props;
        
        if (r2h_revenue.length === 0) return { labels: [], datasets: [] };
        
        // 使用getFilteredData应用时间过滤
        const filteredData = this.getFilteredData(r2h_revenue, 'Main');
        
        // 创建按时间排序的数据（假设数据已按日期排序）
        const chronologicalData = [...filteredData];
        
        // 按日期排序
        chronologicalData.sort((a, b) => {
            const dateA = a["月份/日期"]; 
            const dateB = b["月份/日期"];
            return dateA.localeCompare(dateB);
        });
        
        const labels = chronologicalData.map(item => item["月份/日期"]);
        
        // 日期基准点用于总出入金加成计算
        const pivotDate = "20250406"; // 2025/03/31-2025/04/06的结束日期

        // 生成数据集
        const datasets = [
            {
                label: '實際交收',
                data: chronologicalData.map(item => item["水房實際交收"] || 0),
                borderColor: 'rgba(75, 192, 192, 1)',
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                tension: 0.3,
                fill: false
            },
            {
                label: '手續費登記',
                data: chronologicalData.map(item => item["水房"] ? parseFloat(item["水房"]) : 0),
                borderColor: 'rgba(54, 162, 235, 1)',
                backgroundColor: 'rgba(54, 162, 235, 0.2)',
                tension: 0.3,
                fill: false
            },
            {
                label: '手續費計算值',
                data: chronologicalData.map(item => {
                    // 查找对应日期的cm_detail数据
                    const matchingCmDetail = cm_detail.find(detail => 
                        detail.duration === item["月份/日期"] || 
                        (detail.duration && item["月份/日期"] && 
                         detail.duration.replace(/\s+/g, '') === item["月份/日期"].replace(/\s+/g, ''))
                    );
                    
                    // 获取TWD金额
                    const oaBuyTWD = matchingCmDetail && matchingCmDetail.oa_buychip_amount ? 
                                     (matchingCmDetail.oa_buychip_amount.ntd || matchingCmDetail.oa_buychip_amount.twd || 0) : 0;
                    const r2hBuyTWD = matchingCmDetail && matchingCmDetail.r2h_buychip_amount ? 
                                      (matchingCmDetail.r2h_buychip_amount.ntd || matchingCmDetail.r2h_buychip_amount.twd || 0) : 0;
                    
                    // 计算总出入金加成
                    let bonusRate = 0.023; // 默认比率
                    // 检查日期是否在分界点之后
                    if (item["月份/日期"] && item["月份/日期"].includes("-")) {
                        const endDate = item["月份/日期"].split("-")[1].replace(/\//g, "");
                        const startDate = item["月份/日期"].split("-")[0].replace(/\//g, "");
                        
                        // After 20250413 will always be 2.8%
                        if (startDate > "20250413") {
                            bonusRate = 0.028;
                        }
                        // 20250407-20250413 should be 2.8%
                        else if (startDate === "20250407" || (startDate <= "20250413" && endDate >= "20250407")) {
                            bonusRate = 0.028; // 2.8% for 20250407-20250413
                        } 
                        // 20250331-20250406 should be 2.5%
                        else if (startDate === "20250331" || (startDate <= "20250406" && endDate >= "20250331")) {
                            bonusRate = 0.025; // 2.5% for 20250331-20250406
                        }
                    }
                    
                    return Math.round((oaBuyTWD + r2hBuyTWD) * bonusRate);
                }),
                borderColor: 'rgba(255, 206, 86, 1)',
                backgroundColor: 'rgba(255, 206, 86, 0.2)',
                tension: 0.3,
                fill: false
            },
            {
                label: 'OA入金(TWD)',
                data: chronologicalData.map(item => {
                    // 查找对应日期的cm_detail数据
                    const matchingCmDetail = cm_detail.find(detail => 
                        detail.duration === item["月份/日期"] || 
                        (detail.duration && item["月份/日期"] && 
                         detail.duration.replace(/\s+/g, '') === item["月份/日期"].replace(/\s+/g, ''))
                    );
                    const chipData = matchingCmDetail ? (matchingCmDetail.oa_buychip_amount || {}) : {};
                    return chipData.ntd || chipData.twd || 0;
                }),
                borderColor: 'rgba(153, 102, 255, 1)',
                backgroundColor: 'rgba(153, 102, 255, 0.2)',
                tension: 0.3,
                fill: false,
                hidden: true // 默认隐藏
            },
            {
                label: 'OA入金(USDT)',
                data: chronologicalData.map(item => {
                    // 查找对应日期的cm_detail数据
                    const matchingCmDetail = cm_detail.find(detail => 
                        detail.duration === item["月份/日期"] || 
                        (detail.duration && item["月份/日期"] && 
                         detail.duration.replace(/\s+/g, '') === item["月份/日期"].replace(/\s+/g, ''))
                    );
                    const chipData = matchingCmDetail ? (matchingCmDetail.oa_buychip_amount || {}) : {};
                    return chipData.usdt || 0;
                }),
                borderColor: 'rgba(153, 102, 255, 0.7)',
                backgroundColor: 'rgba(153, 102, 255, 0.2)',
                tension: 0.3,
                fill: false,
                hidden: true // 默认隐藏
            },
            {
                label: 'OA出金(TWD)',
                data: chronologicalData.map(item => {
                    // 查找对应日期的cm_detail数据
                    const matchingCmDetail = cm_detail.find(detail => 
                        detail.duration === item["月份/日期"] || 
                        (detail.duration && item["月份/日期"] && 
                         detail.duration.replace(/\s+/g, '') === item["月份/日期"].replace(/\s+/g, ''))
                    );
                    const chipData = matchingCmDetail ? (matchingCmDetail.oa_sellchip_amount || {}) : {};
                    return chipData.ntd || chipData.twd || 0;
                }),
                borderColor: 'rgba(255, 99, 132, 1)',
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                tension: 0.3,
                fill: false,
                hidden: true // 默认隐藏
            },
            {
                label: 'OA出金(USDT)',
                data: chronologicalData.map(item => {
                    // 查找对应日期的cm_detail数据
                    const matchingCmDetail = cm_detail.find(detail => 
                        detail.duration === item["月份/日期"] || 
                        (detail.duration && item["月份/日期"] && 
                         detail.duration.replace(/\s+/g, '') === item["月份/日期"].replace(/\s+/g, ''))
                    );
                    const chipData = matchingCmDetail ? (matchingCmDetail.oa_sellchip_amount || {}) : {};
                    return chipData.usdt || 0;
                }),
                borderColor: 'rgba(255, 99, 132, 0.7)',
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                tension: 0.3,
                fill: false,
                hidden: true // 默认隐藏
            },
            {
                label: 'R2H入金(TWD)',
                data: chronologicalData.map(item => {
                    // 查找对应日期的cm_detail数据
                    const matchingCmDetail = cm_detail.find(detail => 
                        detail.duration === item["月份/日期"] || 
                        (detail.duration && item["月份/日期"] && 
                         detail.duration.replace(/\s+/g, '') === item["月份/日期"].replace(/\s+/g, ''))
                    );
                    const chipData = matchingCmDetail ? (matchingCmDetail.r2h_buychip_amount || {}) : {};
                    return chipData.ntd || chipData.twd || 0;
                }),
                borderColor: 'rgba(75, 192, 192, 1)',
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                tension: 0.3,
                fill: false,
                hidden: true // 默认隐藏
            },
            {
                label: 'R2H入金(USDT)',
                data: chronologicalData.map(item => {
                    // 查找对应日期的cm_detail数据
                    const matchingCmDetail = cm_detail.find(detail => 
                        detail.duration === item["月份/日期"] || 
                        (detail.duration && item["月份/日期"] && 
                         detail.duration.replace(/\s+/g, '') === item["月份/日期"].replace(/\s+/g, ''))
                    );
                    const chipData = matchingCmDetail ? (matchingCmDetail.r2h_buychip_amount || {}) : {};
                    return chipData.usdt || 0;
                }),
                borderColor: 'rgba(75, 192, 192, 0.7)',
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                tension: 0.3,
                fill: false,
                hidden: true // 默认隐藏
            },
            {
                label: 'R2H出金(TWD)',
                data: chronologicalData.map(item => {
                    // 查找对应日期的cm_detail数据
                    const matchingCmDetail = cm_detail.find(detail => 
                        detail.duration === item["月份/日期"] || 
                        (detail.duration && item["月份/日期"] && 
                         detail.duration.replace(/\s+/g, '') === item["月份/日期"].replace(/\s+/g, ''))
                    );
                    const chipData = matchingCmDetail ? (matchingCmDetail.r2h_sellchip_amount || {}) : {};
                    return chipData.ntd || chipData.twd || 0;
                }),
                borderColor: 'rgba(54, 162, 235, 1)',
                backgroundColor: 'rgba(54, 162, 235, 0.2)',
                tension: 0.3,
                fill: false,
                hidden: true // 默认隐藏
            },
            {
                label: 'R2H出金(USDT)',
                data: chronologicalData.map(item => {
                    // 查找对应日期的cm_detail数据
                    const matchingCmDetail = cm_detail.find(detail => 
                        detail.duration === item["月份/日期"] || 
                        (detail.duration && item["月份/日期"] && 
                         detail.duration.replace(/\s+/g, '') === item["月份/日期"].replace(/\s+/g, ''))
                    );
                    const chipData = matchingCmDetail ? (matchingCmDetail.r2h_sellchip_amount || {}) : {};
                    return chipData.usdt || 0;
                }),
                borderColor: 'rgba(54, 162, 235, 0.7)',
                backgroundColor: 'rgba(54, 162, 235, 0.2)',
                tension: 0.3,
                fill: false,
                hidden: true // 默认隐藏
            }
        ];
        
        return {
            labels,
            datasets
        };
    };

    // 添加备注相关的方法
    startEditingNote = (rowId) => {
        this.setState({ noteEditing: rowId });
    }

    saveNote = (rowId, noteContent) => {
        const { notes } = this.state;
        const updatedNotes = { ...notes, [rowId]: noteContent };
        this.setState({ 
            notes: updatedNotes,
            noteEditing: null 
        });
        // 这里可以添加将备注保存到服务器的代码
        // 例如: this.props.saveNoteToServer(rowId, noteContent);
    }

    deleteNote = (rowId) => {
        const { notes } = this.state;
        const updatedNotes = { ...notes };
        delete updatedNotes[rowId];
        this.setState({ notes: updatedNotes });
        // 这里可以添加从服务器删除备注的代码
        // 例如: this.props.deleteNoteFromServer(rowId);
    }

    // 添加备注弹窗渲染方法
    renderNoteModal = () => {
        const modalBgColor = "#001a33";
        
        return (
            <Modal 
                isOpen={this.state.openNoteModal}
                contentClassName='text-light'
                modalClassName="position-fixed"
                style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    maxWidth: '90%',
                    width: '600px',
                    margin: '0'
                }}
            >
                {/* 背景设置 */}
                <div style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: modalBgColor,
                    borderRadius: "0.3rem"
                }}>
                </div>
                
                <ModalHeader style={{backgroundColor: modalBgColor, borderColor: modalBgColor, position: "relative", zIndex: 1}}> 
                    <div style={{color: "white"}}>編輯備註</div>
                </ModalHeader>
                
                <ModalBody style={{
                    backgroundColor: modalBgColor, 
                    position: "relative", 
                    zIndex: 1,
                    maxHeight: '60vh', 
                    overflowY: 'auto'
                }}>
                    <FormGroup>
                        <Label for="noteText">備註內容</Label>
                        <Input 
                            type="textarea" 
                            id="noteText" 
                            rows="5"
                            className="bg-dark text-light"
                            value={this.state.currentNote}
                            onChange={this.handleNoteChange}
                            placeholder="在此輸入備註內容..."
                        />
                    </FormGroup>
                </ModalBody>
                
                <ModalFooter style={{
                    backgroundColor: modalBgColor, 
                    borderColor: modalBgColor,
                    display: "flex",
                    justifyContent: "flex-end",
                    position: "relative",
                    zIndex: 1
                }}>
                    <Button color="primary" size="sm" className="mr-2" onClick={this.saveNote}>
                        保存
                    </Button>
                    <Button color="secondary" size="sm" onClick={this.closeNoteModal}>
                        取消
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }

    // 日期｜總淨收入｜本部俱樂部收入 ｜本部聯盟收入｜超級聯盟收入 ( 附帶一個可縮放或是下層列表 )
    // 超級聯盟收入下層包含：總服務費｜總保險（EV Cash Out Pay）｜MTT 淨收入｜Jackpot 淨收入｜color game 淨收入｜lucky draw 淨收入｜總交付 ( 服務費 + EV Cash Out Pay )｜Fishpoker服務費｜遊戲內活動支出
    render() {
        const { user } = this.props;
        const canViewRevenue = hasCap(user, 'view_revenue');
        
        return <div className="content">
            {this.renderAPlistModal()}
            {this.renderCostListModal()}
            {this.renderCombinedListsModal()} {/* 添加新的组合模态框 */}
            {this.renderMiscDetailsModal()} {/* 添加雜項詳情模態框 */}
            {this.renderNoteModal()} {/* 添加备注模态框 */}
            {this.renderAgentTaxEventModal()} {/* 添加代理线生态审核名单模态框 */}
            {/* Revenue 頁面只顯示 Main tab，其他 tabs（Fee By Unions, Fee By Main Clubs, Fee By Games, Membership, MTT）移至 OA Fee Details 頁面 */}
            {canViewRevenue ? this.renderMainTable() : (
                <div className="text-center p-5">
                    <h3>沒有檢視營收數據的權限</h3>
                    <p className="text-muted">
                        需要「看得到營收數據」權限。請聯絡後臺管理員（使用者頁面可設定）。
                    </p>
                </div>
            )}
        </div>
    }



    // Add handler for main club sort criteria change
    handleMainClubSortChange = (event) => {
        this.setState({ mainClubSortCriteria: event.target.value });
    };

    // 添加备注相关方法
    openNoteModal = (rowId, existingNote) => {
        this.setState({
            openNoteModal: true,
            currentNoteId: rowId,
            currentNote: existingNote || ""
        });
    }
    
    closeNoteModal = () => {
        this.setState({
            openNoteModal: false,
            currentNoteId: "",
            currentNote: ""
        });
    }
    
    handleNoteChange = (e) => {
        this.setState({ currentNote: e.target.value });
    }
    
    saveNote = () => {
        const { currentNoteId, currentNote, notes } = this.state;
        
        if (currentNoteId) {
            // 更新备注
            const updatedNotes = { ...notes, [currentNoteId]: currentNote };
            this.setState({ 
                // notes: updatedNotes,
                openNoteModal: false,
                currentNoteId: "",
                currentNote: ""
            });
            
            // 这里可以添加将备注保存到服务器的代码
            this.props.saveNoteToServer(currentNoteId, currentNote);
        }
    }
    
    deleteNote = () => {
        const { currentNoteId } = this.state;
        this.props.onDeleteNote(currentNoteId);
        this.setState({
            openNoteModal: false,
            currentNote: "",
            currentNoteId: ""
        });
    }

    // OA MTT Table Renderer
    renderOAMTTTable = () => {
        const { revenue = [] } = this.props;
        const { viewModeMTT } = this.state;
        
        // Extract common styling into constants
        const cellCentered = { textAlign: 'center' };
        const highlightCell = { ...cellCentered, backgroundColor: "#3d5c5c" };
        
        // Table view - filter data based on time interval and sort from newest to oldest
        const filteredData = this.getFilteredData(revenue, 'MTT');
        
        // Sort from newest to oldest
        filteredData.sort((a, b) => {
            // 将日期字符串转换为可比较的格式
            const dateA = a.duration ? a.duration.split('-')[0] : '0';
            const dateB = b.duration ? b.duration.split('-')[0] : '0';
            return dateB.localeCompare(dateA); // 逆序排列，从新到旧
        });
        
        // Main table rendering - Just Date and MTT columns
        const mainTable = (
            <Card>
                <CardHeader>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                            <CardTitle tag="h4" className="mr-3 mb-0">OA MTT Table</CardTitle>
                            
                            {/* View mode toggle - left aligned */}
                            <ButtonGroup>
                                <Button 
                                    color={viewModeMTT === 'table' ? 'warning' : 'secondary'} 
                                    onClick={() => this.toggleViewMode('MTT','table')}
                                    size = "sm"
                                >
                                    <i className="fa fa-table mr-1"></i> Table
                                </Button>
                                <Button 
                                    color={viewModeMTT === 'chart' ? 'warning' : 'secondary'} 
                                    onClick={() => this.toggleViewMode('MTT','chart')}
                                    size = "sm"
                                >
                                    <i className="fa fa-line-chart mr-1"></i> Chart
                                </Button>
                            </ButtonGroup>
                        </div>
                        
                        {/* Time interval selector - always right aligned, only visible in chart mode */}
                        {viewModeMTT === 'chart' && (
                            <ButtonGroup>
                                <Button 
                                    color={this.state.timeIntervalMTT === 'allTime' ? 'info' : 'secondary'} 
                                    onClick={() =>this.setTimeInterval('allTime', 'MTT')}
                                    size = "sm"
                                >
                                    全部時間
                                </Button>
                                <Button 
                                    color={this.state.timeIntervalMTT === 'recent52weeks' ? 'info' : 'secondary'} 
                                    onClick={() => this.setTimeInterval('recent52weeks', 'MTT')}
                                    size = "sm"
                                >
                                    近一年
                                </Button>
                                <Button 
                                    color={this.state.timeIntervalMTT === 'recent26weeks' ? 'info' : 'secondary'} 
                                    onClick={() => this.setTimeInterval('recent26weeks', 'MTT')}
                                    size = "sm"
                                >
                                    近半年
                                </Button>
                                <Button 
                                    color={this.state.timeIntervalMTT === 'recent12weeks' ? 'info' : 'secondary'} 
                                    onClick={() => this.setTimeInterval('recent12weeks', 'MTT')}
                                    size = "sm"
                                >
                                    近一季
                                </Button>
                                <Button 
                                    color={this.state.timeIntervalMTT === 'recent4weeks' ? 'info' : 'secondary'} 
                                    onClick={() => this.setTimeInterval('recent4weeks', 'MTT')}
                                    size = "sm"
                                >
                                    近四周
                                </Button>
                            </ButtonGroup>
                        )}
                    </div>
                </CardHeader>
                <CardBody>
                    {viewModeMTT === 'chart' ? (
                        this.renderOAMTTChart()
                    ) : (
                        <Table responsive>
                            <thead>
                                <tr>
                                    <th style={{ width: "200px", fontSize: '17px', ...cellCentered }}>日期</th>
                                    <th style={{backgroundColor: 'rgba(75, 192, 192, 0.2)',fontSize: '17px', ...cellCentered}}>MTT營利</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.map((revenue, index) => {
                                    // 使用 revenue.MTT 而不是從 superAgentDetail 中查找
                                    const mttValue = revenue.MTT || 0;
                                    
                                    return (
                                        <tr key={`oa-mtt-row-${index}`}>
                                            <td style={cellCentered}>{revenue.duration}</td>
                                            <td style={cellCentered}>{numberWithCommas(Math.round(mttValue))}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    )}
                </CardBody>
            </Card>
        );
        
        return mainTable;
    }

    // OA MTT Chart Renderer
    renderOAMTTChart = () => {
        const chartData = this.generateOAMTTChartData();
        
        if (!chartData) {
            return (
                <div className="text-center p-5">
                    <h4>No data available</h4>
                </div>
            );
        }
        
        const chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: 'top',
                    labels: {
                        color: '#fff'
                    }
                },
                tooltip: {
                    mode: 'index',
                    intersect: false,
                    callbacks: {
                        label: function(context) {
                            let label = context.dataset.label || '';
                            if (label) {
                                label += ': ';
                            }
                            if (context.parsed.y !== null) {
                                label += numberWithCommas(Math.round(context.parsed.y));
                            }
                            return label;
                        }
                    }
                }
            },
            scales: {
                y: {
                    ticks: {
                        color: '#fff',
                        callback: function(value) {
                            return numberWithCommas(value);
                        }
                    },
                    grid: {
                        color: 'rgba(255, 255, 255, 0.1)'
                    }
                },
                x: {
                    ticks: {
                        color: '#fff'
                    },
                    grid: {
                        color: 'rgba(255, 255, 255, 0.1)'
                    }
                }
            }
        };
        
        return (
            <div style={{ height: '500px' }}>
                <Line data={chartData} options={chartOptions} />
            </div>
        );
    }

    // OA MTT Chart Data Generator
    generateOAMTTChartData = () => {
        const { revenue = [] } = this.props;
        
        if (revenue.length === 0) return null;
        
        // Use getFilteredData to apply time filtering
        const filteredData = this.getFilteredData(revenue, 'MTT');
        
        // Create chronologically sorted data
        const chronologicalData = [...filteredData];
        
        // Sort from oldest to newest for chart display
        chronologicalData.sort((a, b) => {
            const dateA = a.duration ? a.duration.split('-')[0] : '0';
            const dateB = b.duration ? b.duration.split('-')[0] : '0';
            return dateA.localeCompare(dateB); // 从旧到新
        });
        
        const labels = chronologicalData.map(item => item.duration);
        
        // Generate datasets
        const datasets = [
            {
                label: 'MTT',
                data: chronologicalData.map(item => {
                    // 使用 item.MTT 而不是從 superAgentDetail 中查找
                    return item.MTT || 0;
                }),
                borderColor: 'rgba(47, 188, 47, 0.76)',
                backgroundColor: 'rgba(47, 188, 47, 0.2)',
                tension: 0.3,
                fill: false
            }
        ];
        
        return {
            labels,
            datasets
        };
    }

    // R2H MTT Table Renderer
    renderR2HMTTTable = () => {
        const { r2h_revenue = [] } = this.props;
        const { viewModeMTT } = this.state;
        
        // Extract common styling into constants
        const cellCentered = { textAlign: 'center' };
        const highlightCell = { ...cellCentered, backgroundColor: "#3d5c5c" };
        
        // Table view - filter data based on time interval and sort from newest to oldest
        const filteredData = this.getFilteredData(r2h_revenue, 'MTT');
        
        // Sort from newest to oldest
        filteredData.sort((a, b) => {
            const dateA = a["月份/日期"]; 
            const dateB = b["月份/日期"];
            return dateB.localeCompare(dateA); // Reverse order for newest to oldest
        });
        
        // Main table rendering - Date, MTT營利, 錦標賽FEE, Overlay columns
        const mainTable = (
            <Card>
                <CardHeader>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                            <CardTitle tag="h4" className="mr-3 mb-0">R2H MTT Table</CardTitle>
                            
                            {/* View mode toggle - left aligned */}
                            <ButtonGroup>
                                <Button 
                                    color={viewModeMTT === 'table' ? 'warning' : 'secondary'} 
                                    onClick={() => this.toggleViewMode('MTT','table')}
                                    size = "sm"
                                >
                                    <i className="fa fa-table mr-1"></i> Table
                                </Button>
                                <Button 
                                    color={viewModeMTT === 'chart' ? 'warning' : 'secondary'} 
                                    onClick={() => this.toggleViewMode('MTT','chart')}
                                    size = "sm"
                                >
                                    <i className="fa fa-line-chart mr-1"></i> Chart
                                </Button>
                            </ButtonGroup>
                        </div>
                        
                        {/* Time interval selector - always right aligned, only visible in chart mode */}
                        {viewModeMTT === 'chart' && (
                            <ButtonGroup>
                                <Button 
                                    color={this.state.timeIntervalMTT === 'allTime' ? 'info' : 'secondary'} 
                                    onClick={() =>this.setTimeInterval('allTime', 'MTT')}
                                    size = "sm"
                                >
                                    全部時間
                                </Button>
                                <Button 
                                    color={this.state.timeIntervalMTT === 'recent52weeks' ? 'info' : 'secondary'} 
                                    onClick={() => this.setTimeInterval('recent52weeks', 'MTT')}
                                    size = "sm"
                                >
                                    近一年
                                </Button>
                                <Button 
                                    color={this.state.timeIntervalMTT === 'recent26weeks' ? 'info' : 'secondary'} 
                                    onClick={() => this.setTimeInterval('recent26weeks', 'MTT')}
                                    size = "sm"
                                >
                                    近半年
                                </Button>
                                <Button 
                                    color={this.state.timeIntervalMTT === 'recent12weeks' ? 'info' : 'secondary'} 
                                    onClick={() => this.setTimeInterval('recent12weeks', 'MTT')}
                                    size = "sm"
                                >
                                    近一季
                                </Button>
                                <Button 
                                    color={this.state.timeIntervalMTT === 'recent4weeks' ? 'info' : 'secondary'} 
                                    onClick={() => this.setTimeInterval('recent4weeks', 'MTT')}
                                    size = "sm"
                                >
                                    近四周
                                </Button>
                            </ButtonGroup>
                        )}
                    </div>
                </CardHeader>
                <CardBody>
                    {viewModeMTT === 'chart' ? (
                        this.renderR2HMTTChart()
                    ) : (
                        <Table responsive>
                            <thead>
                                <tr>
                                    <th style={{ width: "200px", fontSize: '17px', ...cellCentered }}>日期</th>
                                    <th style={{backgroundColor: 'rgba(75, 192, 192, 0.2)',fontSize: '17px', ...cellCentered}}>MTT營利</th>
                                    <th style={{backgroundColor: 'rgba(54, 162, 235, 0.2)',fontSize: '17px', ...cellCentered}}>錦標賽FEE</th>
                                    <th style={{backgroundColor: 'rgba(255, 99, 132, 0.2)',fontSize: '17px', ...cellCentered}}>Overlay</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.map((revenue, index) => {
                                    const mttProfit = revenue["正負"] || 0;
                                    const tournamentFee = revenue["錦標賽FEE"] || 0;
                                    const overlay = revenue["Overlay"] || 0;
                                    // Make overlay negative
                                    const overlayWithSign = Math.abs(overlay) ;
                                    
                                    return (
                                        <tr key={`r2h-mtt-row-${index}`}>
                                            <td style={cellCentered}>{revenue["月份/日期"]}</td>
                                            <td style={cellCentered}>{numberWithCommas(Math.round(mttProfit))}</td>
                                            <td style={cellCentered}>{numberWithCommas(Math.round(tournamentFee))}</td>
                                            <td style={cellCentered}>{numberWithCommas(Math.round(overlayWithSign))}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    )}
                </CardBody>
            </Card>
        );
        
        return mainTable;
    }

    // R2H MTT Chart Renderer
    renderR2HMTTChart = () => {
        const chartData = this.generateR2HMTTChartData();
        
        if (!chartData) {
            return (
                <div className="text-center p-5">
                    <h4>No data available</h4>
                </div>
            );
        }
        
        const chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: 'top',
                    labels: {
                        color: '#fff'
                    }
                },
                tooltip: {
                    mode: 'index',
                    intersect: false,
                    callbacks: {
                        label: function(context) {
                            let label = context.dataset.label || '';
                            if (label) {
                                label += ': ';
                            }
                            if (context.parsed.y !== null) {
                                label += numberWithCommas(Math.round(context.parsed.y));
                            }
                            return label;
                        }
                    }
                }
            },
            scales: {
                y: {
                    ticks: {
                        color: '#fff',
                        callback: function(value) {
                            return numberWithCommas(value);
                        }
                    },
                    grid: {
                        color: 'rgba(255, 255, 255, 0.1)'
                    }
                },
                x: {
                    ticks: {
                        color: '#fff'
                    },
                    grid: {
                        color: 'rgba(255, 255, 255, 0.1)'
                    }
                }
            }
        };
        
        return (
            <div style={{ height: '500px' }}>
                <Line data={chartData} options={chartOptions} />
            </div>
        );
    }

    // R2H MTT Chart Data Generator
    generateR2HMTTChartData = () => {

        const { r2h_revenue = [] } = this.props;

        if (r2h_revenue.length === 0) return null;

        const filteredData = this.getFilteredData(r2h_revenue, 'MTT');

        // Sort from oldest to newest for chart display
        const chronologicalData = [...filteredData];

        chronologicalData.sort((a, b) => {
            const dateA = a["月份/日期"];
            const dateB = b["月份/日期"];
            return dateA.localeCompare(dateB); // 从旧到新
        });

        // Generate datasets
        const datasets = [
            {
                label: 'MTT營利',
                data: chronologicalData.map(item => item["正負"] || 0),
                borderColor: 'rgba(47, 188, 47, 0.76)',
                backgroundColor: 'rgba(47, 188, 47, 0.2)',
                tension: 0.3,
                fill: false
            },
            {
                label: '錦標賽FEE',
                data: chronologicalData.map(item => item["錦標賽FEE"] || 0),
                borderColor: 'rgba(75, 192, 192, 1)',
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                tension: 0.3,
                fill: false
            },
            {
                label: 'Overlay',
                data: chronologicalData.map(item => {
                    // Make overlay negative
                    const overlay = item["Overlay"] || 0;
                    return Math.abs(overlay) ;
                }),
                borderColor: 'rgba(255, 99, 132, 1)',
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                tension: 0.3,
                fill: false
            }
        ];
        
        return {
            labels: chronologicalData.map(item => item["月份/日期"]),
            datasets
        };
    }

    // 關閉雜項詳情模態框
    closeMiscDetailsModal = () => {
        this.setState({
            showMiscDetails: false
        });
    }

    // 渲染雜項詳情模態框
    renderMiscDetailsModal = () => {
        const { miscDetails } = this.state;
        
        return (
            <Modal 
                isOpen={this.state.showMiscDetails} 
                toggle={this.closeMiscDetailsModal}
                contentClassName='text-light'
                modalClassName="position-fixed"
                style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    maxWidth: '90%',
                    width: '500px',
                    margin: '0'
                }}
            >
                <div style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "#001a33",
                    borderRadius: "0.3rem"
                }}></div>
                
                <ModalHeader style={{backgroundColor: "#001a33", borderColor: "#001a33", position: "relative", zIndex: 1}}>
                    <div style={{color: "white"}}>雜項詳細資訊</div>
                </ModalHeader>
                
                <ModalBody style={{
                    backgroundColor: "#001a33", 
                    position: "relative", 
                    zIndex: 1,
                    maxHeight: '60vh', 
                    overflowY: 'auto'
                }}>
                    <Row>
                        <Col lg="12" className="mb-2">
                            <div className="p-2 border rounded">
                                <div className="d-flex justify-content-between align-items-center">
                                    <small style={{ fontSize: "14px" }}>MTT</small>
                                    {this.renderBadge(miscDetails.MTT, "#00802b", false)}
                                </div>
                            </div>
                        </Col>
                        
                        <Col lg="12" className="mb-2">
                            <div className="p-2 border rounded">
                                <div className="d-flex justify-content-between align-items-center">
                                    <small style={{ fontSize: "14px" }}>Jackpot</small>
                                    {this.renderBadge(miscDetails.Jackpot, "#00802b", false)}
                                </div>
                            </div>
                        </Col>
                        
                        <Col lg="12" className="mb-2">
                            <div className="p-2 border rounded">
                                <div className="d-flex justify-content-between align-items-center">
                                    <small style={{ fontSize: "14px" }}>SpinUp</small>
                                    {this.renderBadge(miscDetails.SpinUp, "#00802b", false)}
                                </div>
                            </div>
                        </Col>
                        
                        <Col lg="12" className="mt-2">
                            <div className="p-2 border rounded" style={{ backgroundColor: "rgba(0, 128, 43, 0.1)" }}>
                                <div className="d-flex justify-content-between align-items-center">
                                    <small style={{ fontSize: "16px", fontWeight: "bold" }}>總計</small>
                                    {this.renderBadge(
                                        miscDetails.MTT + 
                                        miscDetails.Jackpot + 
                                        miscDetails.SpinUp,
                                        "#00802b", 
                                        false
                                    )}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </ModalBody>
                
                <ModalFooter style={{
                    backgroundColor: "#001a33",
                    borderColor: "#001a33",
                    display: "flex",
                    justifyContent: "flex-end",
                    position: "relative",
                    zIndex: 1
                }}>
                    <Button color="primary" size="sm" onClick={this.closeMiscDetailsModal}>
                        關閉
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }

    // 新增renderMiscFeeTable方法來顯示雜項費用
    renderMiscFeeTable = () => {
        const { r2h_revenue = [] } = this.props;
        
        // Extract common styling into constants
        const cellCentered = { textAlign: 'center' };
        
        return (
            <div className="table-responsive">
                <Table className="tablesorter">
                    <thead className="text-primary">
                        <tr>
                            <th style={{ width: "200px", fontSize: '17px',...cellCentered }}>日期</th>
                            <th style={{ backgroundColor: 'rgba(255, 99, 132, 0.2)', textAlign: 'center', fontSize: '17px' }}>人事成本(植威填)</th>
                            <th style={{ backgroundColor: 'rgba(153, 102, 255, 0.2)', textAlign: 'center', fontSize: '17px' }}>植威信用卡雜項(植威填)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {r2h_revenue.map((revenue, index) => {
                            // 獲取人事成本數據，如果不存在則為0
                            const personnelCost = revenue["人事成本\n(植威填)"] ? parseFloat(revenue["人事成本\n(植威填)"])  : 0;
                            
                            // 獲取植威信用卡雜項數據，如果不存在則為0
                            const creditCardMisc = revenue["植威信用卡雜項\n(植威填)"] ? parseFloat(revenue["植威信用卡雜項\n(植威填)"])  : 0;
                            
                            return (
                                <tr key={`misc-fee-row-${index}`}>
                                    <td style={cellCentered}>{revenue["月份/日期"]}</td>
                                    <td style={cellCentered}>{numberWithCommas(Math.round(personnelCost))}</td>
                                    <td style={cellCentered}>{numberWithCommas(Math.round(creditCardMisc))}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </div>
        );
    }

    renderNetProfitTable = () => {
        const { r2h_revenue = [], revenue = [] } = this.props;
        const { tinyRevenueData = [] } = this.state;
        const cellCentered = { textAlign: 'center' };
        const anchorDate = '20250901-20250907';
        const specialMarkerOldTeam = '20250303-20250309';
        
        // Create a map of revenue data by duration for easy lookup
        const revenueMap = revenue.reduce((acc, rev) => {
            acc[rev.duration] = rev;
            return acc;
        }, {});
        
        // Create a map of R2H revenue data by week
        const r2hMap = r2h_revenue.reduce((acc, r2h) => {
            acc[r2h["月份/日期"]] = r2h;
            return acc;
        }, {});
        
        // Create a map of Tiny revenue data by week for easy lookup
        // 用 selector adjusted finalRevenue —— OFF state 時排除 JP 補償後的數字
        const tinyRevenueMap = tinyRevenueData.reduce((acc, item) => {
            const adj = this.getAdjustedRevenue(item);
            acc[item.week] = adj.finalRevenue || 0;
            return acc;
        }, {});

        // TinyJP淨營收：OFF state 時整列視為 0（也不顯示欄位）
        const tinyJpMap = tinyRevenueData.reduce((acc, item) => {
            if (!this.state.jpInUnionRevenue) {
                acc[item.week] = 0;
                return acc;
            }
            const jb = item.jp_net_breakdown;
            acc[item.week] = (jb && jb.applicable && typeof jb.total === 'number') ? jb.total : 0;
            return acc;
        }, {});
        
        // OA週期 → Tiny週期 的特殊對應 (Tiny提早營業導致週期不同)
        const oaToTinyWeekMapping = {
            '20251215-20251221': '20251213-20251221'  // Tiny第一周(9天) 對應 OA標準周
        };

        const allWeeks = this.getNetProfitWeeks({
            revenue,
            r2h_revenue,
            tinyRevenueData
        });
        
        // Combine the data - 以 OA 週期為基礎
        const combinedData = allWeeks.map(currentDate => {
            const matchingRevenue = revenueMap[currentDate];

            const r2h = r2hMap[currentDate] || {};
            const isAfterCutoff = this.isAfterR2HCutoff(currentDate);
            
            // R2H 截止後顯示 0，或者 R2H 沒有該週數據也顯示 0
            let r2hProfit = { totalProfit: 0 };
            if (!isAfterCutoff && Object.keys(r2h).length > 0) {
                r2hProfit = this.calculateR2HProfit(r2h);
            }
            
            // 四項費用（人事成本 / 公費報帳 / 信用卡雜項 / payFee）走同一支，
            // 切換週之後讀後臺登記的金流資料，之前讀 Google Sheet。
            const expenses = this.getWeekExpenses(currentDate, r2h);
            
            // 從 Tiny 營收數據中查找對應週期的淨營收
            // 先檢查是否有特殊對應，再查標準週期
            const mappedTinyWeek = oaToTinyWeekMapping[currentDate];
            const tinyNetIncome = tinyRevenueMap[mappedTinyWeek] || tinyRevenueMap[currentDate] || 0;
            const tinyJpNetIncome = tinyJpMap[mappedTinyWeek] || tinyJpMap[currentDate] || 0;
            
            const oaNetIncome = matchingRevenue
                ? matchingRevenue.homeClubIncome + matchingRevenue.homeUnionIncome +
                  (matchingRevenue.superUnionNetIncomeMinusCost || matchingRevenue.superUnionNetIncome || 0)
                : 0;

            return {
                date: currentDate,
                oaNetIncome,
                r2hNetIncome: r2hProfit.totalProfit,
                // 費用四項（見 getWeekExpenses）
                ...expenses,
                tinyNetIncome: tinyNetIncome, // 從 Tiny 營收數據填入
                tinyJpNetIncome: tinyJpNetIncome, // Tiny JP淨營收（20260511 起才有值）
                tinyMappedWeek: mappedTinyWeek && tinyRevenueMap[mappedTinyWeek] ? mappedTinyWeek : null, // 記錄是否使用對應週期
                netProfit: 0 // Will be calculated below
            };
        });

        // Calculate net profit for each combined record
        // 截止前：OA + R2H - 費用
        // 截止後：OA + Tiny + TinyJP - 費用 (TinyJP 在 20260511 前為 0)
        combinedData.forEach(item => {
            item.netProfit = item.oaNetIncome + item.r2hNetIncome + item.tinyNetIncome + item.tinyJpNetIncome -
                           item.personnelCost - item.publicExpense - item.creditCardMisc -
                           (item.cashflowCost || 0) - (item.otherExpense || 0);
        });

        // 1. sort by date (oldest to newest)
        const sortedData = [...combinedData].sort((a, b) => a.date.localeCompare(b.date));
        // 2. find anchor index
        const anchorIndex = sortedData.findIndex(item => item.date === anchorDate);
        if (anchorIndex === -1) {
            // 若找不到錨點，直接按新到舊顯示全部資料
            const fallbackData = [...sortedData].sort((a, b) => b.date.localeCompare(a.date));
            return (
                <div className="table-responsive">
                    <Table className="tablesorter">
                        <thead className="text-primary">
                            <tr>
                                <th style={{ width: "200px", fontSize: '17px', ...cellCentered }}>日期</th>
                                <th style={{ backgroundColor: 'rgba(54, 162, 235, 0.2)', textAlign: 'center', fontSize: '17px' }}>OA淨營收</th>
                                <th style={{ backgroundColor: 'rgba(54, 162, 235, 0.2)', textAlign: 'center', fontSize: '17px' }}>R2H淨營收</th>
                                <th style={{ backgroundColor: 'rgba(225, 78, 202, 0.2)', textAlign: 'center', fontSize: '17px' }}>Tiny淨營收</th>
                                {this.state.jpInUnionRevenue && (<th style={{ backgroundColor: 'rgba(45, 206, 137, 0.2)', textAlign: 'center', fontSize: '17px' }}>TinyJP淨營收</th>)}
                                <th style={{ backgroundColor: 'rgba(255, 99, 132, 0.2)', textAlign: 'center', fontSize: '17px' }}>人事費用</th>
                                <th style={{ backgroundColor: 'rgba(255, 99, 132, 0.2)', textAlign: 'center', fontSize: '17px' }}>公費報帳</th>
                                <th style={{ backgroundColor: 'rgba(255, 99, 132, 0.2)', textAlign: 'center', fontSize: '17px' }}>信用卡雜項費用</th>
                                <th style={{ backgroundColor: 'rgba(255, 99, 132, 0.2)', textAlign: 'center', fontSize: '17px' }} title="付給外包幣商的佣金 ＋ 自營USDT幣商把子錢包歸集到主錢包的鏈上手續費。細項在「金流數據」頁切到 USDT 幣別看">金流費用</th>
                                <th style={{ backgroundColor: 'rgba(255, 99, 132, 0.2)', textAlign: 'center', fontSize: '17px' }}>其他費用</th>
                                <th style={{ width: "300px", backgroundColor: 'rgba(47, 188, 47, 0.3)', textAlign: 'center', fontSize: '17px', fontWeight: 'bold' }}>總淨營收</th>
                            </tr>
                        </thead>
                        <tbody>
                            {fallbackData.map((item, index) => (
                                <tr key={`net-profit-fallback-row-${index}`}>
                                    <td style={cellCentered}>{item.date}</td>
                                    <td style={cellCentered}>{numberWithCommas(Math.round(item.oaNetIncome))}</td>
                                    <td style={cellCentered}>{numberWithCommas(Math.round(item.r2hNetIncome))}</td>
                                    <td style={cellCentered}>{numberWithCommas(Math.round(item.tinyNetIncome || 0))}</td>
                                    {this.state.jpInUnionRevenue && (
                                    <td style={{ ...cellCentered, color: (item.tinyJpNetIncome || 0) > 0 ? '#2dce89' : ((item.tinyJpNetIncome || 0) < 0 ? '#ff6b6b' : '#9aa4bb'), fontWeight: (item.tinyJpNetIncome || 0) !== 0 ? 'bold' : 'normal' }}>
                                        {(item.tinyJpNetIncome || 0) === 0 ? '-' : numberWithCommas(Math.round(item.tinyJpNetIncome))}
                                    </td>
                                    )}
                                    <td style={cellCentered}>{numberWithCommas(Math.round(item.personnelCost))}</td>
                                    <td style={cellCentered}>{numberWithCommas(Math.round(item.publicExpense))}</td>
                                    <td style={cellCentered}>{numberWithCommas(Math.round(item.creditCardMisc))}</td>
                                    {this.renderCashflowCostCell(item)}
                                    <td style={cellCentered}>{numberWithCommas(Math.round(item.otherExpense || 0))}</td>
                                    <td style={cellCentered}>{numberWithCommas(Math.round(item.netProfit))}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            );
        }
        // 3. group before anchor (oldest to anchor-1) - 不再分組，保持原樣
        const before = sortedData.slice(0, anchorIndex);
        // 4. group after anchor (anchor to end) - 從錨點開始往後每4週分組
        const after = sortedData.slice(anchorIndex);
        
        // 5. 只對錨點之後（包括錨點）進行分組
        const periods = [];
        for (let i = 0; i < after.length; i += 4) {
            const group = after.slice(i, i + 4);
            periods.push(group);
        }
        
        // 6. 為每個區段賦予編號並計算總計
        let periodNumber = 1;
        const periodBlocks = periods.map(group => {
            // Each period's weeks should be sorted newest to oldest
            const groupSorted = [...group].sort((a, b) => b.date.localeCompare(a.date));
            // Calculate period total
            const periodTotal = groupSorted.reduce((acc, item) => {
                acc.oaNetIncome += item.oaNetIncome;
                acc.r2hNetIncome += item.r2hNetIncome;
                acc.tinyNetIncome += (item.tinyNetIncome || 0);
                acc.tinyJpNetIncome += (item.tinyJpNetIncome || 0);
                acc.personnelCost += item.personnelCost;
                acc.publicExpense += item.publicExpense;
                acc.creditCardMisc += item.creditCardMisc;
                acc.netProfit += item.netProfit;
                acc.payFee += item.payFee;
                acc.chainFee += (item.chainFee || 0);
                acc.cashflowCost += (item.cashflowCost || 0);
                acc.otherExpense += (item.otherExpense || 0);
                return acc;
            }, {
                date: `區段${periodNumber}總計`,
                oaNetIncome: 0,
                r2hNetIncome: 0,
                tinyNetIncome: 0,
                tinyJpNetIncome: 0,
                personnelCost: 0,
                publicExpense: 0,
                creditCardMisc: 0,
                netProfit: 0,
                payFee: 0,
                chainFee: 0,
                cashflowCost: 0,
                otherExpense: 0,
                isMonthly: true
            });
            const block = { periodNumber, data: [periodTotal, ...groupSorted] };
            periodNumber++;
            return block;
        });
        
        // 7. 組合最終數據：最新的 period 在最上面，然後是錨點之前的數據（從新到舊）
        const finalData = [];
        // 先加入分組的數據（從最新到最舊）
        for (let i = periodBlocks.length - 1; i >= 0; i--) {
            finalData.push(...periodBlocks[i].data);
        }
        // 再加入錨點之前的數據（從新到舊）
        const beforeSorted = [...before].sort((a, b) => b.date.localeCompare(a.date));
        finalData.push(...beforeSorted);

        return (
            <div className="table-responsive">
                <Table className="tablesorter">
                    <thead className="text-primary">
                        <tr>
                            <th style={{ width: "200px", fontSize: '17px', ...cellCentered }}>日期</th>
                            <th style={{ backgroundColor: 'rgba(54, 162, 235, 0.2)', textAlign: 'center', fontSize: '17px' }}>OA淨營收</th>
                            <th style={{ backgroundColor: 'rgba(54, 162, 235, 0.2)', textAlign: 'center', fontSize: '17px' }}>R2H淨營收</th>
                            <th style={{ backgroundColor: 'rgba(225, 78, 202, 0.2)', textAlign: 'center', fontSize: '17px' }}>Tiny淨營收</th>
                            {this.state.jpInUnionRevenue && (<th style={{ backgroundColor: 'rgba(45, 206, 137, 0.2)', textAlign: 'center', fontSize: '17px' }}>TinyJP淨營收</th>)}
                            <th style={{ backgroundColor: 'rgba(255, 99, 132, 0.2)', textAlign: 'center', fontSize: '17px' }}>人事費用</th>
                            <th style={{ backgroundColor: 'rgba(255, 99, 132, 0.2)', textAlign: 'center', fontSize: '17px' }}>公費報帳</th>
                            <th style={{ backgroundColor: 'rgba(255, 99, 132, 0.2)', textAlign: 'center', fontSize: '17px' }}>信用卡雜項費用</th>
                            <th style={{ backgroundColor: 'rgba(255, 99, 132, 0.2)', textAlign: 'center', fontSize: '17px' }} title="付給外包幣商的佣金 ＋ 自營USDT幣商把子錢包歸集到主錢包的鏈上手續費。細項在「金流數據」頁切到 USDT 幣別看">金流費用</th>
                            <th style={{ backgroundColor: 'rgba(255, 99, 132, 0.2)', textAlign: 'center', fontSize: '17px' }}>其他費用</th>
                            <th style={{ width: "300px", backgroundColor: 'rgba(47, 188, 47, 0.3)', textAlign: 'center', fontSize: '17px', fontWeight: 'bold' }}>總淨營收</th>
                        </tr>
                    </thead>
                    <tbody>
                        {finalData.map((item, index) => {
                            let rowStyle = {};
                            let dateDisplay = item.date;
                            let markerText = null;
                            let markerBgColor = null;
                            
                            if (item.date === anchorDate) {
                                markerText = '聯盟新制運行';
                                markerBgColor = 'rgba(153, 102, 255, 0.25)';
                            } else if (item.date === specialMarkerOldTeam) {
                                markerText = '新團隊接手';
                                markerBgColor = 'rgba(240, 164, 151, 0.25)';
                            } else if (item.isMonthly) {
                                rowStyle = { backgroundColor: 'rgba(47, 188, 47, 0.1)' };
                            }
                            
                            return (
                                <>
                                    <tr key={`net-profit-row-${index}`} style={rowStyle}>
                                        <td style={cellCentered}>{dateDisplay}</td>
                                        <td style={cellCentered}>{numberWithCommas(Math.round(item.oaNetIncome))}</td>
                                        <td style={cellCentered}>{numberWithCommas(Math.round(item.r2hNetIncome))}</td>
                                        <td style={cellCentered}>
                                            {numberWithCommas(Math.round(item.tinyNetIncome || 0))}
                                            {item.tinyMappedWeek && (
                                                <span
                                                    style={{
                                                        marginLeft: '5px',
                                                        fontSize: '10px',
                                                        color: '#e14eca',
                                                        cursor: 'help'
                                                    }}
                                                    title={`Tiny 開幕週（12/13-12/21，共 9 天），含提前 2 天營運數據，合併顯示於此週`}
                                                >
                                                    <i className="fa fa-info-circle"></i>
                                                </span>
                                            )}
                                        </td>
                                        {this.state.jpInUnionRevenue && (
                                        <td style={{ ...cellCentered, color: (item.tinyJpNetIncome || 0) > 0 ? '#2dce89' : ((item.tinyJpNetIncome || 0) < 0 ? '#ff6b6b' : '#9aa4bb'), fontWeight: (item.tinyJpNetIncome || 0) !== 0 ? 'bold' : 'normal' }}>
                                            {(item.tinyJpNetIncome || 0) === 0 ? '-' : numberWithCommas(Math.round(item.tinyJpNetIncome))}
                                        </td>
                                        )}
                                        <td style={cellCentered}>{numberWithCommas(Math.round(item.personnelCost))}</td>
                                        <td style={cellCentered}>{numberWithCommas(Math.round(item.publicExpense))}</td>
                                        <td style={cellCentered}>{numberWithCommas(Math.round(item.creditCardMisc))}</td>
                                        {this.renderCashflowCostCell(item)}
                                        <td style={cellCentered}>{numberWithCommas(Math.round(item.otherExpense || 0))}</td>
                                        <td style={cellCentered}>{numberWithCommas(Math.round(item.netProfit))}</td>
                                    </tr>
                                    {markerText && (
                                        <tr key={`marker-row-${index}`} style={{ backgroundColor: markerBgColor, height: '30px' }}>
                                            {/* 欄數：日期 + OA + R2H + Tiny (+TinyJP) + 人事 + 公費 + 信用卡 + 金流 + 其他 + 總淨營收
                                                ⚠️ 這個數字跟表頭的欄數綁在一起 —— 加欄位時兩邊都要改，
                                                否則 marker 那一列會少跨一格、表格右邊被擠掉。
                                                v2.34.0 把「鏈上費用」併進「金流費用」，所以少一欄。 */}
                                            <td colSpan={this.state.jpInUnionRevenue ? 11 : 10} style={{
                                                textAlign: 'center', 
                                                padding: '4px 8px', 
                                                fontSize: '14px',
                                                fontWeight: 'bold',
                                                height: '30px'
                                            }}>
                                                {markerText}
                                            </td>
                                        </tr>
                                    )}
                                </>
                            );
                        })}
                    </tbody>
                </Table>
            </div>
        );
    }

    // 為雜項費用創建圖表數據
    generateMiscFeeChartData = () => {
        const { r2h_revenue = [] } = this.props;
        
        if (r2h_revenue.length === 0) return { labels: [], datasets: [] };
        
        // 使用getFilteredData应用时间过滤
        const filteredData = this.getFilteredData(r2h_revenue, 'Main');
        
        // 创建按时间排序的数据（假设数据已按日期排序）
        const chronologicalData = [...filteredData];
        
        // 按日期排序
        chronologicalData.sort((a, b) => {
            const dateA = a["月份/日期"]; 
            const dateB = b["月份/日期"];
            return dateA.localeCompare(dateB);
        });
        
        const labels = chronologicalData.map(item => item["月份/日期"]);

        // 生成数据集
        const datasets = [
            {
                label: '人事成本(植威填)',
                data: chronologicalData.map(item => item["人事成本\n(植威填)"] ? parseFloat(item["人事成本\n(植威填)"]) : 0),
                borderColor: 'rgba(255, 99, 132, 1)',
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                tension: 0.3,
                fill: false
            },
            {
                label: '植威信用卡雜項(植威填)',
                data: chronologicalData.map(item => item["植威信用卡雜項\n(植威填)"] ? parseFloat(item["植威信用卡雜項\n(植威填)"]) : 0),
                borderColor: 'rgba(153, 102, 255, 1)',
                backgroundColor: 'rgba(153, 102, 255, 0.2)',
                tension: 0.3,
                fill: false
            }
        ];
        
        return {
            labels,
            datasets
        };
    };

    // 添加新的closeCombinedLists函数
    closeCombinedLists = () => {
        this.setState({
            openCombinedModal: false,
            viewList: [],
            viewCostList: [],
            editCostlist: { event: "", amount: "" },
            revenueID: ""
        });
    }

    // 添加新的renderCombinedListsModal函数
    renderCombinedListsModal = () => {
        const modalBgColor = "#001a33";
        
        // 计算Cost List中所有项目的总和
        const totalCost = this.state.viewCostList.reduce((total, item) => {
            return total + (parseFloat(item.amount) || 0);
        }, 0);
        
        return (
            <Modal 
                isOpen={this.state.openCombinedModal}
                contentClassName='text-light'
                modalClassName="position-fixed"
                style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    maxWidth: '90%',
                    width: '800px',
                    margin: '0'
                }}
            >
                {/* 背景 */}
                <div style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: modalBgColor,
                    borderRadius: "0.3rem"
                }}>
                </div>
                
                <ModalHeader style={{backgroundColor: modalBgColor, borderColor: modalBgColor, position: "relative", zIndex: 1}}> 
                    <div style={{color: "white"}}>額外交收 & 支出</div>
                </ModalHeader>
                
                <ModalBody style={{
                    backgroundColor: modalBgColor, 
                    position: "relative", 
                    zIndex: 1,
                    maxHeight: '60vh', 
                    overflowY: 'auto'
                }}>
                    {/* Additional Pay List */}
                    <h5 style={{color: "white", marginBottom: "15px"}}>Additional Pay List</h5>
                    <Table className="tablesorter" style={{marginBottom: "30px"}}>    
                        <thead>
                            <tr>
                                <th>聯盟ID</th>
                                <th>俱樂部ID</th>
                                <th>代理ID</th>
                                <th>子代理ID</th>
                                <th>項目</th>
                                <th>金額</th>
                            </tr>
                        </thead>               
                        <tbody>
                            {this.state.viewList.map((ap, index) => (
                                <tr key={index}>
                                    <td>{ap.unionID}</td>
                                    <td>{ap.clubID}</td>
                                    <td>{ap.agentID}</td>
                                    <td>{ap.subAgentID}</td>
                                    <td>{ap.APevent}</td>
                                    <td>
                                        <Badge style={{ 
                                            fontSize: "12px", 
                                            padding: "6px 8px",
                                            backgroundColor: ap.APamount >= 0 ? "#cc0000" : "#00802b",
                                            color: "#e6e6e6"
                                        }}>
                                            {ap.APamount >= 0 ? numberWithCommas(Math.round(ap.APamount) * -1) : numberWithCommas(Math.abs(Math.round(ap.APamount)))}
                                        </Badge>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    
                    {/* Cost List */}
                    <h5 style={{color: "white", marginBottom: "15px"}}>Cost List （*填寫邏輯：支出直接填數字就好，收入則須加負號）</h5>
                    <Table size="sm" className="tablesorter">
                        <thead className="text-primary">
                            <tr>
                                <th>Event</th>
                                <th>Amount</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <Input style={{height: 30}} className='bg-dark text-light' type='text' id={"event"} name={"event"} value={this.state.editCostlist.event || ""} onChange={this.handleChangeCost.bind(this)}/> 
                                </td>
                                <td>
                                    <Input style={{height: 30}} className='bg-dark text-light' type='text' id={"amount"} name={"amount"} value={this.state.editCostlist.amount || ""} onChange={this.handleChangeCost.bind(this)}/> 
                                </td>
                                <td>
                                    <Button style={{marginRight: 3}} size='sm' color="success" onClick={this.addTempCostList.bind(this)}> + </Button>
                                </td>
                            </tr>
                            {typeof this.state.viewCostList !== "undefined" && this.state.viewCostList.map((costlist, index) => (
                                <tr key={index}>
                                    <td>{costlist.event}</td>
                                    <td>
                                        <Badge style={{ 
                                            fontSize: "12px", 
                                            padding: "6px 8px",
                                            backgroundColor: parseFloat(costlist.amount) >= 0 ? "#cc0000" : "#00802b",
                                            color: "#e6e6e6"
                                        }}>
                                            {parseFloat(costlist.amount) >= 0 ? 
                                                numberWithCommas(Math.round(parseFloat(costlist.amount)) * -1) : 
                                                numberWithCommas(Math.abs(Math.round(parseFloat(costlist.amount))))
                                            }
                                        </Badge>
                                    </td>
                                    <td><Button style={{marginRight: 3}} id={index} size='sm' color="danger" onClick={this.deleteTempCostlist.bind(this)}> delete </Button></td>
                                </tr>
                            ))}
                            <tr>
                                <td colSpan="3" style={{textAlign: 'right', paddingTop: '15px'}}>
                                    <strong>Total: </strong>
                                    <Badge style={{ 
                                        fontSize: "14px", 
                                        padding: "6px 12px",
                                        backgroundColor: totalCost >= 0 ? "#cc0000" : "#00802b",
                                        color: "#e6e6e6",
                                        marginLeft: "10px"
                                    }}>
                                        {totalCost >= 0 ? 
                                            numberWithCommas(Math.round(totalCost) * -1) : 
                                            numberWithCommas(Math.abs(Math.round(totalCost)))
                                        }
                                    </Badge>
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </ModalBody>
                
                <ModalFooter style={{
                    backgroundColor: modalBgColor, 
                    borderColor: modalBgColor,
                    display: "flex",
                    justifyContent: "flex-end",
                    position: "relative",
                    zIndex: 1
                }}>
                    <Button color="primary" size="sm" className="mr-2" onClick={this.saveCostList.bind(this)}>
                        保存
                    </Button>
                    <Button color="secondary" size="sm" onClick={this.closeCombinedLists.bind(this)}>
                        取消
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }

    // 打开入金出金详情模态框
    openChipDetailModal = (title, content) => {
        this.setState({
            showChipDetailModal: true,
            chipDetailTitle: title,
            chipDetailContent: content
        });
    }
    
    // 关闭入金出金详情模态框
    closeChipDetailModal = () => {
        this.setState({
            showChipDetailModal: false,
            chipDetailTitle: "",
            chipDetailContent: ""
        });
    }

    // 渲染入金出金详情模态框
    renderChipDetailModal = () => {
        const modalBgColor = "#001a33";
        
        return (
            <Modal 
                isOpen={this.state.showChipDetailModal}
                toggle={this.closeChipDetailModal}
                contentClassName='text-light'
                modalClassName="position-fixed"
                style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    maxWidth: '90%',
                    width: '400px',
                    margin: '0'
                }}
            >
                {/* 背景设置 */}
                <div style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: modalBgColor,
                    borderRadius: "0.3rem"
                }}>
                </div>
                
                <ModalHeader style={{backgroundColor: modalBgColor, borderColor: modalBgColor, position: "relative", zIndex: 1}}> 
                    <div style={{color: "white"}}>{this.state.chipDetailTitle}</div>
                </ModalHeader>
                
                <ModalBody style={{
                    backgroundColor: modalBgColor, 
                    position: "relative", 
                    zIndex: 1,
                    maxHeight: '60vh', 
                    overflowY: 'auto'
                }}>
                    <h5 className="text-center">{this.state.chipDetailContent}</h5>
                </ModalBody>
                
                <ModalFooter style={{
                    backgroundColor: modalBgColor, 
                    borderColor: modalBgColor,
                    display: "flex",
                    justifyContent: "center",
                    position: "relative",
                    zIndex: 1
                }}>
                    <Button color="secondary" size="sm" onClick={this.closeChipDetailModal}>
                        關閉
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }

    // 渲染代理线生态审核名单Modal
    renderAgentTaxEventModal = () => {
        const modalBgColor = "rgb(39, 41, 61)";
        const agentTaxEventList = this.props.agent_tax_event_list || [];
        const isLoading = this.props.fetch_status?.status === 'loading' && 
                         this.props.fetch_status?.action === 'getAgentTaxEventList';
        
        return (
            <Modal
                isOpen={this.state.showAgentTaxEventModal}
                toggle={this.closeAgentTaxEventModal}
                size="lg"
                style={{
                    maxWidth: '90%',
                    width: '800px'
                }}
            >
                <div style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: modalBgColor,
                    borderRadius: "0.3rem"
                }}>
                </div>
                
                <ModalHeader 
                    style={{
                        backgroundColor: modalBgColor, 
                        borderColor: modalBgColor, 
                        position: "relative", 
                        zIndex: 1
                    }}
                    toggle={this.closeAgentTaxEventModal}
                > 
                    <div style={{color: "white"}}>
                        <i className="fa fa-list-alt mr-2"></i>
                        代理線生態審核名單
                    </div>
                </ModalHeader>
                
                <ModalBody style={{
                    backgroundColor: modalBgColor, 
                    position: "relative", 
                    zIndex: 1,
                    maxHeight: '70vh', 
                    overflowY: 'auto',
                    color: '#fff'
                }}>
                    {isLoading ? (
                        <TinyLoading text="載入中" variant="block" />
                    ) : agentTaxEventList.length === 0 ? (
                        <div className="text-center py-5">
                            <i className="fa fa-inbox fa-3x text-muted mb-3"></i>
                            <p className="text-muted">本週無代理線生態審核事件</p>
                        </div>
                    ) : (
                        <Table responsive hover className="tablesorter" style={{marginBottom: 0}}>
                            <thead className="text-primary">
                                <tr>
                                    <th style={{color: '#51cbce'}}>#</th>
                                    <th style={{color: '#51cbce'}}>聯盟ID</th>
                                    <th style={{color: '#51cbce'}}>事件</th>
                                    <th style={{color: '#51cbce'}}>金額</th>
                                </tr>
                            </thead>
                            <tbody>
                                {agentTaxEventList.map((event, index) => (
                                    <tr key={index}>
                                        <td style={{color: '#fff'}}>{index + 1}</td>
                                        <td style={{color: '#fff'}}>{event.unionID || '-'}</td>
                                        <td style={{color: '#fff', whiteSpace: 'pre-wrap'}}>{event.event || '-'}</td>
                                        <td style={{color: event.amount < 0 ? '#f5593d' : '#6bd098'}}>
                                            {event.amount ? numberWithCommas(event.amount) : '0'}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr style={{borderTop: '2px solid #51cbce'}}>
                                    <td colSpan="3" style={{textAlign: 'right', fontWeight: 'bold', color: '#51cbce'}}>
                                        總計:
                                    </td>
                                    <td style={{fontWeight: 'bold', color: '#51cbce'}}>
                                        {numberWithCommas(
                                            agentTaxEventList.reduce((sum, event) => sum + (event.amount || 0), 0)
                                        )}
                                    </td>
                                </tr>
                            </tfoot>
                        </Table>
                    )}
                </ModalBody>
                
                <ModalFooter style={{
                    backgroundColor: modalBgColor, 
                    borderColor: modalBgColor,
                    display: "flex",
                    justifyContent: "center",
                    position: "relative",
                    zIndex: 1
                }}>
                    <Button color="secondary" size="sm" onClick={this.closeAgentTaxEventModal}>
                        關閉
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }

    // 切换出入金详情显示模式
    toggleChipDetailsMode = () => {
        this.setState(prevState => ({
            showFullChipDetails: !prevState.showFullChipDetails
        }));
    }

    generateNetProfitChartData = () => {
        // 取得與 renderNetProfitTable 相同的資料處理邏輯
        const { r2h_revenue = [], revenue = [] } = this.props;
        const { tinyRevenueData = [] } = this.state;
        // 建立 revenueMap
        const revenueMap = revenue.reduce((acc, rev) => {
            acc[rev.duration] = rev;
            return acc;
        }, {});
        const r2hMap = r2h_revenue.reduce((acc, r2h) => {
            acc[r2h["月份/日期"]] = r2h;
            return acc;
        }, {});
        const tinyRevenueMap = tinyRevenueData.reduce((acc, item) => {
            const adj = this.getAdjustedRevenue(item);
            acc[item.week] = adj.finalRevenue || 0;
            return acc;
        }, {});
        const tinyJpMap = tinyRevenueData.reduce((acc, item) => {
            if (!this.state.jpInUnionRevenue) {
                acc[item.week] = 0;
                return acc;
            }
            const jb = item.jp_net_breakdown;
            acc[item.week] = (jb && jb.applicable && typeof jb.total === 'number') ? jb.total : 0;
            return acc;
        }, {});
        const oaToTinyWeekMapping = {
            '20251215-20251221': '20251213-20251221'
        };
        const allWeeks = this.getNetProfitWeeks({
            revenue,
            r2h_revenue,
            tinyRevenueData
        });

        // 合併資料（聯集）
        const combinedData = allWeeks.map(currentDate => {
            const matchingRevenue = revenueMap[currentDate];
            const r2h = r2hMap[currentDate] || {};
            const isAfterCutoff = this.isAfterR2HCutoff(currentDate);
            const r2hProfit = (!isAfterCutoff && Object.keys(r2h).length > 0)
                ? this.calculateR2HProfit(r2h)
                : { totalProfit: 0 };
            const mappedTinyWeek = oaToTinyWeekMapping[currentDate];
            const tinyNetIncome = tinyRevenueMap[mappedTinyWeek] || tinyRevenueMap[currentDate] || 0;
            const tinyJpNetIncome = tinyJpMap[mappedTinyWeek] || tinyJpMap[currentDate] || 0;

            const oaNetIncome = matchingRevenue
                ? matchingRevenue.homeClubIncome + matchingRevenue.homeUnionIncome +
                  (matchingRevenue.superUnionNetIncomeMinusCost || matchingRevenue.superUnionNetIncome || 0)
                : 0;

            const expenses = this.getWeekExpenses(currentDate, r2h);

            return {
                date: currentDate,
                oaNetIncome,
                r2hNetIncome: r2hProfit.totalProfit,
                tinyNetIncome,
                tinyJpNetIncome,
                ...expenses,
                netProfit: 0 // 之後計算
            };
        });
        // 計算每週的總淨營收（含 TinyJP）
        combinedData.forEach(item => {
            item.netProfit = item.oaNetIncome + item.r2hNetIncome + (item.tinyNetIncome || 0) + (item.tinyJpNetIncome || 0) -
                           item.personnelCost - item.publicExpense - item.creditCardMisc - (item.cashflowCost || 0) - (item.otherExpense || 0);
        });
        // 只取每週資料（排除區段總和）
        // 這裡假設所有週的 date 都是 'YYYYMMDD-YYYYMMDD' 這種格式
        // 並且不包含 '區段' 字眼
        const weeklyData = combinedData.filter(item => /\d{8}-\d{8}/.test(item.date));
        // 依日期舊到新排序
        weeklyData.sort((a, b) => a.date.localeCompare(b.date));
        // 準備 chart data
        return {
            labels: weeklyData.map(item => item.date),
            datasets: [
                {
                    label: '總淨營收',
                    data: weeklyData.map(item => item.netProfit),
                    borderColor: 'rgba(47, 188, 47, 0.76)',
                    backgroundColor: 'rgba(47, 188, 47, 0.2)',
                    tension: 0.3,
                    fill: false
                }
            ]
        };
    }

    getLatestTinyWeek = (tinyRevenueData = []) => {
        const weeks = tinyRevenueData
            .map(item => item?.week)
            .filter(week => typeof week === 'string' && /^\d{8}-\d{8}$/.test(week))
            .sort();
        return weeks.length ? weeks[weeks.length - 1] : null;
    }

    getNetProfitWeeks = ({ revenue = [], r2h_revenue = [], tinyRevenueData = [] }) => {
        // Tiny 開幕第一周包含多兩天，不應額外獨立成一列
        const EXCLUDED_WEEK = '20251213-20251221';
        const latestTinyWeek = this.getLatestTinyWeek(tinyRevenueData);

        const allWeeksSet = new Set([
            ...revenue.map(rev => rev?.duration).filter(Boolean),
            ...r2h_revenue.map(item => item?.["月份/日期"]).filter(Boolean),
            ...tinyRevenueData.map(item => item?.week).filter(Boolean),
        ]);

        return Array.from(allWeeksSet)
            .filter(week => /^\d{8}-\d{8}$/.test(week))
            .filter(week => week !== EXCLUDED_WEEK)
            .filter(week => !latestTinyWeek || week <= latestTinyWeek)
            .sort();
    }
}

export default Revenue;